export const HANDS = [
  'Ah5d4c3c2h',
  'QsQhQc8s7s',
  'JcJdKc7h4s',
  'KdQdJhTd9h',
  'QsJcTh8h7s',
  '2s2h2cAh8s',
  'JhJc3s3dQs',
  'As5s4s3s2s',
  'QhJhTd9d8s',
  'QsQhQcQdAh',
  '9h9d7s6d3d',
  'AhKhTs9d7h',
  '7h6s5h4h3d',
  '6s6h6cQsQh',
  'AsTs7s4s3s',
  'JhJcJdAcKs',
  'AhAcAdQd2h',
  'Ac7c4c3c2c',
  'JsJhJcJd8h',
  'QsJdTh9d8d',
  'QcQd7c7d3d',
  '4c4dKh8s2s',
  'Th9s8s7h6s',
  'KsKhKcKd6c',
  '5s5hJs8s3d',
  'AsAcKcKd6s',
  '3s3dKdJc7s',
  'AsKs8s4s2s',
  '2c2dAdJh3c',
  'AhAc7h6d5s',
  'AcAdKcKdQc',
  '7s7h7cAhTc',
  '9s9h9c9dQh',
  '8s8h8d7s7d',
  'AsKsQs9s3s',
  'KsJsTs9s6s',
  'QsQhQd9s9d',
  'AsAhAc8c5h',
  'As9d6c5h3s',
  'AsAhAcTh6s',
  'AcKhQcJcTd',
  '4s4h4cAsAh',
  'KsQs8s4s3s',
  'QsQdJd6h3s',
  '7s7c9h6c5h',
  '6s6hQd8s7c',
  '5s5h5dJh7d',
  '9s9h9c8s7h',
  'AsJs5s4s3s',
  'KsKhTd9s3c',
  'As5s4s3s2s',
  'JdTs8h4c2d',
  '2h2c2d9s8h',
  'JhJcJdAsAh',
  '9s9h9c9dQc',
  'As5s4s3s2s',
  'KsKc7s7cTh',
  'KdJd6d5d3d',
  '3h3c3dKhKd',
  'QsJsTs7s5s',
  'AdJd6d5d3d',
  'KcQc9c7c6c',
  '6s6h6d3s2c',
  'QsQcAs7c6h',
  'KhQhTh7h6h',
  'AsKhQcJhTh',
  'KdQd7d6d3d',
  'AhAdKsKh6s',
  '5s5c5d4d2c',
  'JsJhJd9s9h',
  'JsJhJdAsTc',
  'AcQcTc7c2c',
  'AsAc7c7d5s',
  '7s7c7dJsJd',
  'Jd7d6d4d3d',
  'JsJhJdAsAh',
  'AsAhAcAd5s',
  'Ad6d5d4d3d',
  '5h5c5d8c8d',
  'AsAd2h2c9s',
  '5s5hAdQd8c',
  '4s4h4cAsAh',
  'AsAhQdJs7c',
  'KsQsJs7s5s',
  'Td9d8d7d6d',
  'As9c8s5c4s',
  '9s8c7d6c5h',
  '3s3h3d9d7s',
  '7d6d5d4d3d',
  'AcJc9c7c4c',
  '5s5h4h4d3s',
  'Qd7d4c3c2d',
  '3h3d8c6c5d',
  '6h6c3h3c8h',
  'AhKsTc5h3h',
  'KdJd6d4d3d',
  '8d7c6h5c4h',
  'TcTdAh8d3d',
  'AhAcAdKsKh',
  'JhJcAhKh2c',
  'KhKcKd5c5d',
  'KhQsJhTc9d',
  'KsKcKd5c5d',
  '8s8h8c8dQd',
  'AdKd8d7d3d',
  '7h6c5c4c3d',
  'KsJs9s3s2s',
  '6h6dQc7c2h',
  'QhQcQd8h8c',
  'JhTs9h8h7s',
  '9s8s7s6s2s',
  'JdTd9s8s7s',
  '5s5c5d9c7d',
  'JsJd6h6d5c',
  'AdQdTd9d7d',
  'QsJs9s7s6s',
  'Tc9c8c4c2c',
  'QcJhTh9h2s',
  'QsQcQd6s6h',
  '9s9h9dAhAd',
  'QsQhQdKdTc',
  'AsAhAc8s8c',
  '4s4h4dJsJh',
  'AsAd9d8c7d',
  '7s7h7c7dTc',
  '6c5c4c3c2c',
  '4s4h4c6s6d',
  '7h6d5s4h3d',
  '2s2h2c2dJd',
  '2h2c2d9c6s',
  'QhJdTc8h4c',
  '7s7h7c7d9s',
  '7s7dAdTc6d',
  '6s5s4s3s2s',
  '9s9h9cAcAd',
  'Th8d6h5s3h',
  'QsTs8s7s5s',
  'AhAcTcTd3d',
  '8s8h6s6d7d',
  '9s9h9cAcAd',
  'AsKdTd8d3s',
  '4s4c4dKc7h',
  'Ah5h4h3c2c',
  '8s8h8dQc4h',
  'AcKhQhJhTh',
  'AsAhAdKh7h',
  'Th9c7d5s3c',
  'AcAd9h9c2c',
  'QsQhQcQd8d',
  '7s7h7c7d8d',
  'QhJsTh9d8c',
  'TsThTcKsKh',
  '7s7h7c7dKh',
  'QhJhTh9c8d',
  '5s5h5dTc9s',
  '7s7h7dQsJc',
  'Ac5h4c3s2c',
  'QsQhQcQdTs',
  'JsJh2c2d7c',
  'AcKsQsJdTc',
  '2h2dQs9d3s',
  'AsAhAd6s6d',
  'QsQcAdKh2h',
  'AsAh8s8d5s',
  '2s2h2c8h8d',
  'JsJhJcJdAs',
  '7h7c7dQsQh',
  '8s8h8c8dJd',
  'KcQcJhTh9s',
  'AsAc7s7hKh',
  'AdKcTc9s6c',
  'AsKs8s7s5s',
  'JsJdTsTc8h',
  'KsJs6d4h3d',
  'Ts7s6s5s3s',
  'AdKd7d6d5d',
  '3s3h3c3d4h',
  'TsThTcTd9h',
  'AcJs9c6c5s',
  'AhJs9s7h6h',
  'JcTc8c7c2c',
  '2s2h2c2d5h',
  'JdTd9d8d7d',
  'TsThTcJh8d',
  'JcJdKhQs7c',
  '4s4h4c4dQd',
  '7s7h5h5dJh',
  '3s3h3cTd2d',
  'AsQsJsTs2s',
  'KsKhKcKd7h',
  '7s6c5d4d3s',
  'JsJhJdAs9s',
  'Ad9d7d3d2d',
  '7s7h7c7dKc',
  'QdJdTd5d3d',
  'JsJd8c4c2d',
  'KsKcKd9h7c',
  'AcTc5c4c3c',
  'ThTcTdQh6s',
  '4s4hAs7c5h',
  '7c6h5d4c3c',
  '4s4h4c4dTh',
  'KsQsJs7s4s',
  'JhJdAh8h5d',
  'KsKhKdAs3s',
  'Jc9h7d4c2c',
  'AdJcTs9h8d',
  '7c6h5c4s3s',
  'Ad5c4h3h2d',
  'TsTh8s8cQh',
  '9h9cJd7s3c',
  'JhJcJdKsKc',
  'JcTd9d8s7d',
  'KhKcTc6c2c',
  'QhQcQd8h8d',
  '8s8h8cAsQd',
  'AsAhKsKh2s',
  'AsKsJsTs9s',
  'Kc8d6d5c4c',
  '9h9c9dQhQd',
  'KsKhJsJhAc',
  'JsTh9c8h7d',
  '5s5h5c5d2h',
  'QdJd9d8d6d',
  'JsJhTsTd4d',
  'Ks7s6s5s4s',
  'AdKh9h6s3d',
  'Ac5c4s3d2c',
  '2s2h2c8s8d',
  '4s4hTc5c2s',
  '8c7c6c5c4c',
  'AsAhAd6c3d',
  'KhKcQcQd3d',
  'AdQc9s8d2h',
  'AdKdQd4d2d',
  'KsKhKcKdJd',
  '9s8s7s6s5s',
  '9s8h7s6s5c',
  'QsQhQcQd7h',
  '6d5d4d3d2d',
  'QdJhTh9h8h',
  '8s8d5h5d9s',
  '5s5h5cJs4h',
  '2s2h2c2dJc',
  'JsJhAcKcQs',
  '6h5h4h3d2s',
  'TsTcTd8s8d',
  '6s5s4s3s2s',
  'AcKcQhJhTs',
  '8s8h8c8dQc',
  'KhQhJhTh5h',
  'JsJc3c3d7d',
  'KhQhJs8s5h',
  'TsThTc7d2s',
  'QhJhTh9s8d',
  'AhKh9h8h2h',
  'AcKsTh5d4d',
  'KhKd9s9d7s',
  'KsKhKdJsJh',
  '7s7h7c7dJs',
  'AsAhAcAdKs',
  '2s2h2c2dQs',
  '8s8h8cAdKs',
  'AcAd4s4hJd',
  'AhJh7h5h2h',
  'AsAhAd2c2d',
  '6s6dAcJdTh',
  '8s8h8c8dKs',
  'KdJh9s5c3h',
  'KcJc7h5c2s',
  'JhJcJdQs7c',
  '7s7hAhTd6d',
  '5h5dTd9c7s',
  '9c9dAd8h6s',
  'AdKhQhJh5s',
  'JsJhAhKd9s',
  '8s7c6d5h4h',
  'QcJc9c8c3c',
  'AhKdJc9c8h',
  '7s7h7dJdTh',
  'QdJsTs7h2d',
  'AhKsQhJcTh',
  'Td9d8c7c6c',
  'Td9c8d7d6d',
  'KsKdQsQh8h',
  'As5s4h3d2h',
  'AsAhTd6c5c',
  'KsQhJc9c8c',
  '7h6h5h4h3h',
  'As5c4s3c2d',
  '2h2c2dAsAh',
  'AsAhAcAdKd',
  '7s7h7cQh3d',
  'As5d4c3c2d',
  'KhQs7s5d4c',
  '3s3h3c3dAh',
  'AsAhAd7h5s',
  'Ad7d5d4d3d',
  'AdKdQd4d2d',
  'Ad5d4d3d2d',
  'JhJcJd7s7c',
  '9c8c7c6c5c',
  'AsAhJcJd3d',
  '8s8h8c8d6h',
  'QsQhQcJsJd',
  'AdKdTd9d7d',
  'TsThTcTdKs',
  'Ad5d4d3d2d',
  '3s3h8s7h5c',
  '8s8h8d6h4d',
  'AdJd7d4d3d',
  'JhJc6h6c7c',
  '4h4c4dQcQd',
  'JcTc9c5c3c',
  '9h8h7s3d2s',
  'TcTd5c5dAs',
  'AsAhAc2s2h',
  'JsJhJcJd6d',
  'KdQd9d3d2d',
  '5s5h5cTcTd',
  '2s2h2c2d5h',
  '6s6cAcKhTd',
  '4s4c4dAsJh',
  'JcTs9d8d7h',
  'KcKd3h3c6s',
  'KsKhKc8h7h',
  '8h8c8dAcQs',
  '5c5dAdKs7d',
  'KdQd9d7h5h',
  'JsTd9s8d7s',
  'QcJc8c7c3c',
  'AsAhAcAdKc',
  'JdTd8c6d3d',
  '9s9h9cJsJh',
  'KhQcJh7h6c',
  '8s8h8d7c7d',
  '7h7d9s4h2s',
  '3s3h3c3dQh',
  'AcKcQc7c4c',
  '8d7d6d5d4d',
  'TsThTd8c6s',
  'AsAhAdKsTh',
  '6s5s4s3s2s',
  'QsTs9s8s3s',
  '9s9h5s5hTd',
  '8h8c8d9s9h',
  '9c9d4c4dQs',
  'JhTc9c8h7d',
  'AdKd7d5d4d',
  '8s8d5h5dJc',
  'Ks7h6h5c3d',
  '7s7h7cQh2c',
  'Ts9s8s7s6s',
  'KsKhKdQsQh',
  '2s2h2cAsAc',
  'AhAcAdKc6s',
  'AsAcKs9d7c',
  'JsJhKc4h3h',
  'JsJhJcJd9d',
  '8s7s6s5s4s',
  '3s3h3dQh5s',
  'AdKdJd3d2d',
  'KdTd9d5d4c',
  'QcJcTc9c8c',
  '6h5h4h3h2h',
  'JhTc9s8d7d',
  '7s7h7dAc6h',
  'AhAcAdKc9s',
  'AsAhAcAd8d',
  'AhTs8d4c3c',
  'AsAhAd6s6h',
  'KdQdJcTd7s',
  'KsKhAcQd2h',
  'QsQhQcQd6s',
  'JsTd9c8d7d',
  'QsQdThTd2d',
  '2s2c2dKcKd',
  'AhKdQcJhTs',
  'QhJsTs9c8d',
  '9s9c9dAsAd',
  'JcJdTc9c8s',
  'KhQs9c3c2h',
  'AsAhAdJdTs',
  'Ts9d8s7s6h',
  'QsQc6h6dJc',
  'AhAc9d8h7s',
  '5s5h5c8s7s',
  'Ah5c4d3s2c',
  'AsAhThTcKc',
  'KhKcQsQh2d',
  '5s5h5c5dAd',
  'ThTc9s9h6s',
  'AsAhAcKh6c',
  'QsQdAdKdJd',
  'QdJcTh9c8s',
  '6d5d4d3d2d',
  'AcKdQsJcTc',
  '2s2h2c2dKc',
  '9s9hQsTs2c',
  'AdKdQdJd5d',
  'TsThQh7h5h',
  '2h2c2dJsJd',
  '4h4c4dQc7c',
  'KsQd7c6s5h',
  'JdTd9d8d7d',
  'QsJdTd9c8c',
  'JsJhJcJd6h',
  'AsAh6s6d7h',
  'AsTs8s6s5s',
  'AsAhQh7h4h',
  'QcJsTc9d8h',
  '6h6c6d2c2d',
  'KsKdQcQdJc',
  'AsAhAcThTc',
  'TsThTcKcKd',
  '6h5c4d3s2s',
  '9h9c9d7c7d',
  'Ts9s8h7d6h',
  'As5s4s3s2s',
  'AsAhAc8c3s',
  'AdKdJd5d2d',
  '9s8c7h6d5c',
  '6h6d9c8c2h',
  '6s6h6c6d9d',
  'AdKs9h6h2s',
  'Ah5s4d3s2c',
  '8s8h8cAsTc',
  '9s9h9dJsJh',
  '9s9h9c9dAc',
  '2s2h2c2dQs',
  'AhAcAdKsKd',
  '6s6h6cQcQd',
  'QsQhTc6c4h',
  'TsThTcTdQh',
  '8c7c6c5c4c',
  'QsJs5s4s3s',
  'KhQcTs7h5s',
  '7s7h7c7d5c',
  '7h6d5c4s3s',
  'AsAhKsKhJs',
  '3s3h3c3d8s',
  'TcTdAh7d3d',
  '7s7h7c7d8d',
  'Th9h8h7h6h',
  '5h5cQhJh9h',
  '4s4h4c9h8c',
  'QsQhQcQdJs',
  'KdJdTd5d3d',
  'AdKdJdTd8d',
  'Kc8c7c6c4c',
  'Th9s8c7c6d',
  'AdKd8d7d6d',
  '3s3h3dAc7h',
  '7s6s5h4d3h',
  'AhAcKsKdTh',
  'AdJd7d5d2d',
  'KcJc9s3s2d',
  '9s9c4s4h6d',
  '7c7d4s4hTc',
  'QsQhQcAhAc',
  '5s5h5dJsJd',
  'AsAhAd8c8d',
  'QcJc7c5c2c',
  'AcAdJdTc5s',
  '4s4h4dAd9c',
  'QsQh8c8dAs',
  '9c8h7s6d5s',
  'KsQs7s6s3s',
  'AcQs9c7s5d',
  'Tc9c8c7h6d',
  'Ac5h4h3d2h',
  'QsQdTsTdKc',
  'KsKhAh6s2c',
  'KsQs8s7s5s',
  'AsKsQsJsTs',
  'QcJhTh9h8c',
  '9s9h9c9dJh',
  'KcQsJdTc9d',
  '8s7d6c5c4h',
  '6s6h6c4s3c',
  '7s7c7dAcQc',
  '8s8d2s2h6c',
  'JsTs9s8s7s',
  'AsAh5s5hKd',
  'KhKcKd3s3d',
  'AsKsQs6s5s',
  'Ad7d6d3s2c',
  'Ac5c4d3d2h',
  'AdKc9c6s4h',
  'AhAcAd6c6d',
  '5s5c3c3dJd',
  'Js9s6s3s2s',
  '9h9dJd8c3d',
  'QsQh2c2d6d',
  'As9s8s4s3s',
  'AsKs5s4s3s',
  '2s2h2dAs7h',
  'TsTh3s3c7s',
  'Kd9d6d3d2d',
  'AhAcAd8s8h',
  'AhAc6s6hKd',
  '4s4h4c4d6d',
  'AsQs9s8s6s',
  'QcJhTs9c8d',
  'KhJh9h6h5h',
  '5s5h5cTsTd',
  'JsJhJcJd7s',
  'KcKdTd9d2s',
  'KsKhTsTh6s',
  'QsJdTc8d3d',
  'JsJdAsQs8h',
  '8c7h6s5d4d',
  'AsKs8s5s2s',
  '9s9h6s6c4d',
  'QhQcQd7h3d',
  'AsAdThTcKc',
  'AsAhAcAdJs',
  '6s6h6d7h2d',
  'Ts9s8s7s6s',
  '7s7h7c7dAs',
  '9h9d2c2dAs',
  'QsQhQd6s6d',
  '7h7c7dKs8s',
  'JsJhJdAh7s',
  '8h8c8d4c4d',
  'AsKs7s4s3s',
  '6s5s4s3s2s',
  '8h8cAsKd9c',
  'JsTs9s8s7s',
  '8h7h6c5s4h',
  '6c6dAd9s7d',
  'QhQdAsKs8h',
  '6c6dAc3c2s',
  'KsQsJsTs9s',
  'Ac9h8s6c5h',
  'JsJhJc5h5c',
  'Js7s6s4s2s',
  'AsAhAcAd2c',
  'AcAdKcQc9h',
  'KdTd9d8d6d',
  '9s9h2s2cAc',
  '5s5h5d8s8h',
  'AcKc9c6c3c',
  '7d6d5d4d3d',
  '7s7h7d8c5d',
  '6c5h4s3d2s',
  'AdKdQd9d4d',
  '6s6h6d3d2s',
  'JsJhJc7h7d',
  'KcQcJdTd9c',
  'AdKdQd4d3d',
  'QsQh7s7hKs',
  'AdKdQd8d2d',
  '8s8h8d5s5d',
  'KsKhKdAc8c',
  '2s2h2c2dTh',
  'TsTh8s8dJc',
  'AcKh9h6c4h',
  'Ad5d4d3d2d',
  'AcKcQcTc3c',
  '3s3dTd7c2d',
  'AhAc3h3c7c',
  'QhQc7h7cAh',
  'KsQdJh4d2h',
  'AdJd4d3d2d',
  'Ad5d4d3d2d',
  'AsKcQs9s8h',
  'Th9c8s7h6c',
  '7s7h7c7d6d',
  '9s9h9c9d8s',
  'ThTcAdKdJh',
  'QsQhQcKh4d',
  'JsJdQs6s2s',
  'Td9d8d7d6d',
  'Qd7d6d5d3d',
  'TsThTd2c2d',
  '7c6d5h4h3s',
  'AsAc4h4cJd',
  'AcAdKcJd4s',
  'QdJd8d3d2d',
  'AhKsQsJdTs',
  'Ah8c7h4c3c',
  '7s6s5s4s3s',
  'Ks9s8s7s5s',
  'Tc9c8c7c6c',
  'AsAhAdJcJd',
  '8c8d6c6dKs',
  'JsJcKc3s2s',
  'JcTs9d8h7s',
  'KhQhTh8h7h',
  'AsAhQsJs8c',
  '7s6h5h4s3h',
  '8d7s6s5h4s',
  '8h8dAcKcQc',
  'KdQdJhTs9s',
  '5h5c5d3s3h',
  'QcJc9c8c7c',
  'KsKd3h3d6c',
  'JsJh9s9cKc',
  'AsAhJc6h2d',
  'QsQcQdKsKd',
  'QdJh9d6c5s',
  'AsAhAc9c2d',
  'QcQdAh7c5d',
  'TsTcAdKhQc',
  '8s8h8d4c4d',
  '8h8c8d4s4h',
  'JsJhJc6c6d',
  'JhTd9c8c7h',
  '4s4h4dQsQh',
  'Td9c8c7d6s',
  'Ac9c5h4d3c',
  'AcKhQhJcTd',
  'JsJh8s8cAh',
  '9d8d7d6d5d',
  'JhJd6s6hQd',
  '2s2h2c2dJh',
  'AdKsQs9d6s',
  '9h8h7d6c5d',
  'AsKsQs9s6s',
  'KhKc9s9h2h',
  'As7s6s5s3s',
  'AdJhTd6c2d',
  '2s2h2dAsAh',
  'JdTd9d8d7d',
  '8s7s6s5s4s',
  '7s7h7c7d6s',
  '3h3c3d9c9d',
  'JsTh9d8c7s',
  '9s9h9dAsAd',
  'TcTd9c9d4h',
  '7h7c7dTcTd',
  'TsTh3s3d5c',
  'AdKhQsJdTh',
  '2s2h2dJd7d',
  'JdTh9s8d7c',
  '4s4h2c2d8s',
  'AsKsTs9s5s',
  'JsTh9h8c7s',
  'As7h6d4d3h',
  'KhQhTh5h2h',
  'AdTd7d5d2d',
  'AcKcQcJc3c',
  'JsJhJcJd9d',
  'KdQc7s6d2c',
  'KsKhKc8s8h',
  '8h8c8dQsQh',
  'JsJdAs6s2d',
  '9c8c7c6c5c',
  'AhJc9c3d2c',
  '8s8h8c8dQc',
  'AcQc9c4c3c',
  '6c6dAdKh9c',
  'TsThTcAd7d',
  '7d6c5d4h3d',
  '4h4c3s3d7h',
  '7s7h7dQhQd',
  '8s8h8cAcAd',
  '8c8dJs7s2h',
  'Qs7s5s3s2s',
  '4s4h4cAd9d',
  'AhKhJh6h3h',
  'KsJsTd9s8h',
  'Ah8c6s3d2c',
  '9s8d7c6s5h',
  'QsJsTs9s8s',
  '8s8h8cJsJh',
  '9c9d7s7hQd',
  'JsJh8s8h6h',
  'AsAhAcAd6s',
  'JsJhJcJd9h',
  'AhAdKcKd2c',
  'KhKcKd9c9d',
  'QsQdTsTdAs',
  'QsQhKh7s6d',
  'KhKcKdAhAc',
  'QhQcQd8s8h',
  'QhQcQd6c6d',
  'QcQdTs9c4c',
  '6h6c6d5h4h',
  '3h3c3d9s9d',
  'QsJc9d5c3c',
  'JsJhJcJdAc',
  'Ts9d8s7h6d',
  'JsJhJd6h6c',
  'AsAhAcAd2s',
  'AsQs9s6s2s',
  'JsJd9h9dKc',
  'TsTcTdAh3h',
  'JhJcJdTd7h',
  '4s4h4c6c6d',
  'QcQdJs8c2d',
  '7s7h7dAcAd',
  'KdQd9d8d4d',
  'AsAhAcAd7d',
  '6h5c4h3h2c',
  '5s5h5c5d3c',
  '9s9h9c9d2c',
  'TsThTcTdJd',
  'AcKh7c5d4c',
  'AdKdQdJd5d',
  'AdJsTc8h2c',
  'TcTd9s9h6c',
  '5c5dQdTd7h',
  'As9s7s4s3s',
  'AsKsQsJs3s',
  '8s8c8d9c9d',
  'AsKsQsJsTs',
  'KsKcKd4h4d',
  '8s8c8dAhQh',
  '4c4dTd7s5c',
  'JsJhJcJdAh',
  '9d8d7d4d2d',
  '6d5d4d3d2d',
  '9s9hKdQh6h',
  'TsThTcTd4c',
  '3s3hAdKs2s',
  '8s7h6c5s4h',
  '6h6c9d7c2s',
  'QsQh2h2dJh',
  'Td9d8d7d6d',
  'AsAcKsQc6s',
  '4s4h4dQd7s',
  '2s2h2cKhQc',
  '3h3c3dJs4d',
  'AsAhAdQh6h',
  'AsAh4s4dKh',
  '9s9h9c9d2h',
  'Tc9c8s7s5d',
  'AsAdKhKc8h',
  'Jh9h6h4h2h',
  'TsTcTd6c6d',
  'AcKhQcJsTs',
  '9c8c7c6c5c',
  'AhKhTh9h8h',
  '4s4h3s3hAh',
  'AsKh5c3s2h',
  'Kc8c7c4c3c',
  '9s8s7s6s5s',
  '9s9h9c9dAc',
  'ThTcTdAcAd',
  'KcJcTc4c3c',
  'AsKd7s6h3d',
  '9h9c2s2hQd',
  '9c8c7c4c2c',
  'JsJhJd2c2d',
  'AsAh9c9d8d',
  'JhJcJdAc9s',
  'KsQsJs6s2s',
  'QhJhTh9h8h',
  'JsJhJcJd9d',
  'QhQcQdJsJh',
  'JsJhJcJdAc',
  '7s7hJc9c6c',
  'As9s6s5s2s',
  '8c7c6c5c4c',
  'JsJh9h8h7s',
  '9h9dAhJh3c',
  'JsJh9d8c4h',
  'Ts9c8h7s6c',
  'AhAcAd7h7d',
  '3s3h3c3d2d',
  'AsAhKdQc3h',
  'QhJhTh9h8h',
  'KcQsJsTs9c',
  'QsQhQc6s3h',
  'AsKdQs7s5h',
  'AcKcQcJcTc',
  'AcTc9c8c3c',
  '2s2h2dQsTd',
  '3s3h3c3dQh',
  '7s7c2s2dAd',
  '6s6h6c6dAd',
  'AdKd8d4d3d',
  '8s8h4c3c2h',
  'TsThTc9s3d',
  'JcTc9c7c3c',
  'AhKhTh4h3h',
  '7h7c7dJhJd',
  '8c8dJdTd9s',
  '9s9d7s7c5h',
  'JsJc6s6hKc',
  'As8s6s5s3s',
  'JhJcAcKdQs',
  'JhTd9c8h7d',
  'TsThTcJhJd',
  'Ad8d7d6d5d',
  'QsQhQcQd4c',
  '3s3h3d5h5c',
  '6s6h6c6d7d',
  '7s6h5d4c3s',
  'JsJhJcAhKs',
  'QsQdTd4h3d',
  'JsJdAdKc8c',
  'JhTc9h8c7s',
  'AsKs9s7s4s',
  'AsKcQd6h4h',
  'JsTs9d8h7h',
  'AsKsQsJsTs',
  'As8s7s4s3s',
  'AsAh8c8d4h',
  '7s7h7c7dAc',
  '7c7d6s6h2d',
  'AdJd9d5d3d',
  'KhJc8h5d2s',
  'KsKhKcAd3c',
  '8s8hAsTc9c',
  'AsQs6d5s4c',
  'AsAhAdKsKh',
  '9s9h9dTsTh',
  '9s9h9dQhJc',
  '7s7h7c7dJs',
  '2s2h2cQsQh',
  'AhKs9d8c2h',
  'JsJhJcJd3d',
  '8s8h8c8dQh',
  'JsJhJdAcAd',
  '7s7h7dTsTd',
  '6d5d4d3d2d',
  'AhKs6h5d3h',
  'JsJhJcJd6c',
  'KcKdTh6h5s',
  'AsAdQhTc5h',
  'Ad7d4d3d2d',
  'QcJhTd9h8c',
  '7d6d5d4d3d',
  '3h3c3dQsQd',
  'KdQsJdTs9d',
  'JcTc9h8h7d',
  'QdJd8s6d4s',
  'AdKdQsJsTs',
  'AcKc5c4c3c',
  '6d5d4d3d2d',
  'KhKcKd6s2h',
  'KsKhKcKdJs',
  '9s9h9c9dAc',
  'AdKs8s6d3d',
  '8s8h8c3s3d',
  '9h9c9d8s8h',
  'AhKh6h4h3h',
  'QhQcQdAd7c',
  'QcQd2h2cTs',
  '2c2dJh7d3s',
  '7s7h7cAsAc',
  '8s8h8c8dTc',
  '9h9c9dAcAd',
  'KsQhJsTs9s',
  '7s7dJs5c4h',
  '2s2h2c2d3s',
  'QsQd6c6dTd',
  'AdKdQd9d6d',
  'AdKd7s4d3d',
  'JsTh9c8s7s',
  'AsKh9c7h4s',
  'KsQs9s3s2s',
  'KdQdJd7d6d',
  '6s6h6dAsAh',
  'AsKd7d5d3c',
  '2s2h2dKhKc',
  '8s8h8c8d2s',
  'AsJh7c5h4h',
  'AcAdKsQc6h',
  'QsJs8s7s4s',
  'QhQcAsKc3d',
  'KsQs5s4s2s',
  'AsAh7s7h9d',
  '2h2dJc9c4d',
  '8s8d6s4h2h',
  'QhQc2s2hAh',
  '7s7c7d5c5d',
  'AsAhAd6c6d',
  'AdKd6d5d4d',
  '5s5d3c3d2h',
  '2h2c2dAd8h',
  'AsAc9c9d2s',
  'QsQhAd7c3h',
  'QsQhQd9c8h',
  'JsJhJcQcQd',
  'QsQhQcQdAd',
  '6s6h6c6d2d',
  '4s4h4dKhKd',
  'AcJs8s6s4s',
  '3s3h3d7s7d',
  'AhKdQcJsTh',
  'AsKs9s6s3s',
  'QsQhQcQd7d',
  'AsAd7c3s2c',
  '8h7h6h5h4h',
  'JdTd9d8d5d',
  '7s6s5s4s3s',
  'QdJdTd6d5d',
  '2h2c2d7h7d',
  'QdJc8h6s2s',
  '3h3c3dJhJd',
  'KsKhJhJd6c',
  'AsAhQcTd6d',
  'JhJd7h7d6s',
  'QhQcAs6h4c',
  'AsTs9s8s2s',
  '8h8cAcKc2c',
  'AsKhQhJh5c',
  '8s7d6c5d4h',
  '6h5h4h3h2h',
  '4s4h4c4dJc',
  'Tc9c7c4c3d',
  'KdTd8d7d5d',
  'KsKhKcAsAh',
  'JhTc8c7s6h',
  'AdQd8d5d4d',
  'AhKcQcJcTs',
  '2s2c2d6s6d',
  '7d6c5h4c3c',
  'TsTd6s6h8c',
  'AhAcAdQhJc',
  '4s4h4c4d3s',
  'QhQcQd3s3h',
  'JsJhJd7c6c',
  '9s9h9c9d8d',
  'AsAhAdQc7c',
  'KhKcQsQc9d',
  '2s2h2d6s6d',
  'QcJhTc9c8c',
  '9s8h7c6c5h',
  'QsTs7s3s2s',
  'Td9s8s7d6h',
  'QsQhQc4c4d',
  'TsTh2s2hQh',
  '3s3h3d9c9d',
  '9c9d8c6c5h',
  '5s5h5c9d7d',
  '6s6h6c6d7h',
  'QsQhQcQd8s',
  '9c9d2s2hAc',
  'TsThTcAh5h',
  'JsJcJdAc5h',
  'As5s4s3s2s',
  'AdKcQdJsTs',
  'JsJdAh6h5s',
  'KsKcQhQc6s',
  '8h8c5c5dAh',
  '6s6cAdKh5d',
  '6h6c6dAd7h',
  'AdKcQcJcTc',
  '8s8dTd9h2s',
  'KhKdTs9s7c',
  '9h9cAhKcTs',
  'JsJhJdAcKc',
  '7h7c7dJc4s',
  'KcQsTh7c4h',
  '2s2c2d9h9c',
  '7s7d5h5cTh',
  'AsAhAdTh5d',
  '9h9c9dAhAc',
  'JsJhJcJdAh',
  '6h5s4h3h2c',
  'Ks9s8s7s6s',
  'AcJc7c5c4c',
  '8c8d2s2h9c',
  '3s3h3c3d5d',
  'AhAd5s5h4s',
  'Jd7d5s4h3s',
  'KsQsJsTs9s',
  'AsAhAdKcTs',
  'JcTh9h8d7d',
  'As9s7s6s5s',
  'QcJsTc9h8h',
  'AdQd9d7d5d',
  '7s7h7cJhJd',
  'AcKc8c7c6c',
  '8c7d6d5d4s',
  'JcJdTd6s4d',
  '6h6dJd8d7d',
  'AsAhTh8h6s',
  '9s9h9c6s6h',
  'JdTd9d8d7d',
  '3s3h3c3d7h',
  'Ts9h8d7d6s',
  'JhJcJdAh6s',
  'JsJdAc4d3h',
  'AsAhJsJh5c',
  '9h9c9d5c5d',
  'KsKdAh9s4h',
  '9c8s6h5c4s',
  'KcQcJcTc9c',
  'QhQdAdTs6d',
  '8h8c8d7h7c',
  '2s2dQdJs8c',
  'TsThTcTd7h',
  'AdKdJdTd3d',
  '3s3h3dQsJs',
  '5s5h5cJcJd',
  'AsKsTs7s2s',
  'AhAc2c2d7s',
  '6d5s4c3c2c',
  'QsQcQdJsJh',
  '8c7c6c5c4c',
  '4s4h4dKsKh',
  'AhAcAd7s7c',
  'Td9d8d7s4h',
  '4s4h4cTc2c',
  '6s5s4s3s2s',
  '9h9c5c5dJc',
  '7s7hQd6c2c',
  'AcTc6c5c3c',
  '9h9c9dAhAc',
  '9h9cTd8c5h',
  '9c9dKhQh3s',
  'QhJhTh4h2h',
  '9s9d3h3cAc',
  'JsTd9h8s7c',
  'Jc6c4c3c2c',
  'JhTd9c8c7c',
  'KcKdQsQc9h',
  '8h8c8d4h4d',
  'AdKdQd8s5s',
  'JsJh6s6hAd',
  'JdTd9d8d7d',
  '2s2h2dJcJd',
  'KcQcTc7c4c',
  '4s4h4c4d8c',
  '9d8d6d4d2d',
  'JsJc7s7h6h',
  'KhJsTh9h7h',
  '2s2h2d8h7d',
  'AdKsQsJhTs',
  'AhAcAd9c9d',
  'JsJhJcJd5d',
  'Td9d8d7c6h',
  'KsQc9d7d5h',
  'QhJc9s8s7d',
  '4s4h4cAd3d',
  'AsJc4d3d2s',
  '8s8h8c8dAd',
  '7h6s5h4d3c',
  'Ac9c8s6h4c',
  'Ad5c4d3d2c',
  '3c3dAhKdQs',
  'QhJhTd9h8d',
  'Ah5d4s3s2h',
  'QhQcKsJh7d',
  'AsAhAcAdKd',
  'AsAhAdThTc',
  'Kh7h5h3h2h',
  '8h8c5s5cJc',
  '6d5s4c3c2s',
  'KdQdJcTc9h',
  '8s8h8d9c4h',
  'AcAdKh8c2s',
  'AcKdJs9h7c',
  'AsAhAd6s5c',
  'JhJcJdTc8s',
  'KsKhKd8s8h',
  'AdKs6h3h2c',
  'Jh7c5d4h2s',
  'AhAdKcQs8c',
  'AsAhAcAdKh',
  'QsQh5h5cAd',
  'TcTd3s3h7c',
  '7h6d5h4s3c',
  'KsKc8h7s2c',
  '7s7h7c9c9d',
  'AsAh2s2h4h',
  'QhJhTd9d8c',
  'KcQhJcTh9s',
  'JsJhJc7s7h',
  'JsJhTh3s2d',
  '9h9cKcTh3h',
  'TsThTd8d7h',
  '6h6c9c4s3s',
  'QsQcJsJdAd',
  'AhJh9h7h5h',
  '4h4c4d9s3d',
  'QdJdTd9d8d',
  'KdJh8s5c4h',
  'AcAdKd5d3h',
  'QsQhQdTh2h',
  '2s2h2cJc9h',
  'KcQhJcTc9d',
  '6s6h6c6d8c',
  '9s9h9c9d4c',
  'QsQc8s8hTc',
  '7c7dQd3s2h',
  '8s8h8c6s6h',
  'Td9c8h7s6s',
  'AhQhJcTc6h',
  '6c5s4d3h2s',
  'QsQhQcQd4h',
  '6s5s4s3s2s',
  '7c6h5h4h3h',
  'KhKcKd7h7d',
  '4s4h3c3d8s',
  'KcQcJcTc9c',
  'JsJcKc6h3s',
  '7s7hAdKcJc',
  '8c8d5h5cKc',
  '6s6h6cTsTh',
  '8s7c6c5c4h',
  'KhQs6d4d3h',
  'Ts9s8d7h6c',
  '7s7h4s4cJh',
  'Ts9c8h7c6h',
  'AsKsQs8s6s',
  'QhQcQdAs5s',
  '7s7hAs4s3h',
  'AsKdQd6c5s',
  'QdJdTd9d8d',
  '3s3c3dJcJd',
  'AhAcAd7h7d',
  'AsAhAcAdTd',
  '2s2h2c2d5s',
  '6c5c4c3c2c',
  '8s8h8c8d7d',
  'AsKsJs9s6s',
  '7s6s5s4h3d',
  '8s8h8d3s3h',
  '4s4h4cKcQh',
  'AsJd8h5c3s',
  'TsThTcJhJd',
  'KdQdTd4d2d',
  '6s6h5s5h9d',
  'JcTc9c8c7c',
  'QsQdJhJdAc',
  '3s3h3d9s9d',
  '7d6s5s4h3c',
  'QhQcQdTs3h',
  '9h8d7c6d5c',
  '2s2h2cAh6h',
  '8d7c6s5d4s',
  'AsAhAcAdTd',
  'AsAhAdJhTc',
  '9s9h9c9d7s',
  'ThTcTdAc6h',
  'JsJhJd8s8h',
  '8s8c7s7hAd',
  '5c5dAdKc2c',
  'AdKdQd7d5d',
  'AsKhJcTs4s',
  'Tc9h8h7d6d',
  'AsAd3s3hKc',
  'KdJd7d4d3d',
  'Th9h8h7h2h',
  'KsQsJs7s3s',
  '8s8hAdKc4c',
  'JsJhJcJdKs',
  'ThTcTd7h7d',
  'AdKdTd8d5d',
  'AsQsJs9s8s',
  '8s8h8c8dJd',
  'JcJdAdKh4c',
  '4c4dAdJd9d',
  'AsKhQhJcTc',
  'AhKhQsJhTs',
  'KsKhKdJsJh',
  'JsJhJc9d3s',
  '5s5h5c5d3h',
  'JsJhJcJdTd',
  '8h8c8d3h2h',
  'JsJd2s2dAd',
  '4s4dAs9s3h',
  '6s6h6cJh8c',
  'ThTcTd6c6d',
  'AcAdJhJc5s',
  'QsQdJdTd3d',
  'JdTd9d8d5d',
  'AcKcQc5c4c',
  'KhQdJdTc9s',
  'AhKhQhJhTh',
  'AdKcQcJhTc',
  '6s6h6cKc3c',
  'AsAh9c9d4d',
  'QsQhJsJhAh',
  'QdJhTs9s8d',
  '6s6h6cAs7h',
  '7s6h5h4h3d',
  'TsThTcJs6s',
  'KdJdTd8d3d',
  'KhJh9h6h5h',
  'AhAc4s4h9s',
  '7h7c7d2h2c',
  'AhAcAd5s5h',
  'Jd9d8d7d3d',
  'AhAcAd6c6d',
  'KsKhKcTd3h',
  '6d5s4c3d2c',
  'JsJhJcAsAd',
  'KsKhKcKd5c',
  '3s3h3c3d4h',
  'QcJs6d5s4c',
  '8s8h8c8d2c',
  'TsTcTdQcJs',
  'JcTd9s8d7c',
  'AdJsTh9c6h',
  'AsAcKsKh6h',
  'Qd6h4h3h2h',
  'AhAcAd7s4s',
  '9s9hTc8h7h',
  'AsAdKhKdTs',
  'JcJd7h4h2c',
  '3s3h3c9c4d',
  'AsAdKcKdQd',
  '5s5h5dQdJd',
  'JdTd8d5d2d',
  'JcJd9c9dTc',
  'AsAhAc2s2d',
  '9d8d7d4d3d',
  '6s6h6dAsKd',
  'AcAdKsKd6c',
  'Ts9s8s7s6s',
  '9d8d7d6d5d',
  '8s8h6c3d2h',
  '5s5h5cQcJc',
  'AsAhKh7d5s',
  'AsAhQcQdJs',
  'QhJsTh9c8c',
  'JcJd5s5dTh',
  'AsAhJsJh4s',
  '7d6s5c4h3d',
  '8s8h8cKd3h',
  'AsJs8s6s3s',
  'AdKdJd8d6d',
  'Jd9c7c4d2h',
  'TsThTcTdAd',
  'AhAcAdTc5s',
  '7s7hKh6d5d',
  'AsQh8h7d4c',
  'ThTcTdQh2d',
  '7d6s5h4h3h',
  'KsQs9d8d6d',
  'KhKdAcJd6d',
  '9s8s7s6d5c',
  '4h4c4dAc2d',
  '4h4c4d9s9d',
  'AsKdQc9c2s',
  'Js8s7s4s2s',
  'TsThTcTdAh',
  '7s7h7c7dAd',
  'AdKs6c5c2d',
  'AhKhQhJhTh',
  'AsAhAcAdKh',
  'TsThTc9h9c',
  'TsTh7s7c6d',
  'AsAhAdJh6c',
  '8d7h6h5s4s',
  '4s4h4cKs7s',
  'JsJhAdTc9h',
  'TsThTd7d2s',
  '8h8c8dJsJd',
  'AsKhQhJcTs',
  'KsQs9s8s3s',
  'AsAcAdJcJd',
  'AhKs9d6s5s',
  'JsJhJdTsTd',
  'AcJcTc9c8c',
  'AcKcQhJhTd',
  'AsKhQh7s2c',
  'TsThQh6d3s',
  'AdKd7d3d2d',
  '2s2h2dAh7c',
  '9s8s7s6s5s',
  'Qd8c6s5c2c',
  'JcTc9c8c7c',
  '2s2h2c2dAh',
  'JsJhJcJd2d',
  'JsJhJc6h6c',
  'AsKsQsTs6s',
  'QsQhQc5s5d',
  '7s7hKhQh6s',
  'KcQcJcTs9c',
  'AhJh9h7h3h',
  'Qd7c6h3h2c',
  'JcJd3c3d7d',
  'Tc9c8c7c6c',
  'AhKdQcJdTc',
  'TsThTd8c8d',
  'KsTs9h8c5c',
  'QdJd7d5d3d',
  'KsKhKcKdAc',
  'AhAdKsKhTd',
  'Kh7h6h3h2s',
  'AcJd9s7s6c',
  'JsJh2s2hTh',
  'QsTh7d6c2c',
  'QsQh7s7h5s',
  'KcQc9c6c4c',
  '8s7s6s5s4s',
  '4s4h4c4d9c',
  'KdQd8d7d3d',
  'JsJcJd9s9c',
  '9s9h9cAc5s',
  'AsAhAcAdTs',
  '6s5s4c3c2s',
  '8c8d3h3d5h',
  'Ac8h7d6d5s',
  'QhQcQdTc5d',
  'ThTcTd9h7h',
  'QhTh7h6h3h',
  'Kh5d4h3h2s',
  'KsKhKcTsTc',
  'AsAhKc4h3s',
  'AcAdKs7d2c',
  'JsTs9s8s7s',
  '2s2h2cTsTh',
  'JdTc9c8c7h',
  'AsAhAcKc6d',
  '2c2dAcKs4c',
  'Js7h6c5d4s',
  'QsQcQdAsTd',
  'QcJcTc9c8c',
  'QsJsTs7s2s',
  '5s5c5dKcJh',
  'JsJhJcJdKs',
  '7s7h7d2s2d',
  'JcTc8s4h3c',
  'Th9h8d7d6s',
  '2s2h2cJsJh',
  '5s5h5c7c7d',
  '7c7dQc5s2c',
  '4h4c4dTd9d',
  'Ad5c4d3d2h',
  '8s7d6s5d4c',
  '5s5h5cJd3d',
  '9s9h9cQsQh',
  'KhKcKdJs8s',
  'KhKcKd8s8h',
  'KsKhKdQsQh',
  'Th9s8c6d2h',
  'KdQdTd4d2d',
  '9s9h9c2s2d',
  'AcAd4h4d7d',
  'KsKhKdAc6h',
  '4h4c4dAhAc',
  'QsJs9s6s3s',
  'JhJdAdKh3s',
  '9s9h9c9dAs',
  '9d8d7d6d5d',
  'AsKsTs8s5s',
  'AcQc9c7c6c',
  'AdKdJd4d2d',
  '6c6dAc7h5s',
  '5h5d8s6d4d',
  'Jd8d6c3s2h',
  '8c8d5s5h6s',
  '6s6hAs8d5c',
  '3s3h3c3d4h',
  'KcQcJcTs9c',
  'AsAhAcQh4h',
  'AhAc9s9d8c',
  '8h8c8d3s3d',
  'AsAh4s4cKc',
  'JhJc7c7d4c',
  'QsQhJs9s6d',
  'QsQhQcAhKs',
  'AsAhJhTd3d',
  '3s3hQc7d5h',
  '9s9hAc6s2h',
  'Ah5c4c3d2d',
  'KsKhKd5d4s',
  'AhKhQsJcTh',
  '2s2h2c2d8s',
  'QcQdAs9d6h',
  'JcJdAdKc8s',
  'KsKd9d5s2d',
  '4s4h4dJsJh',
  'TsTcAs7s3d',
  'JcJd2s2hAh',
  'JsJhJdAc3h',
  '8s8h8c8d9c',
  'KsKh8d7s5s',
  'Ah5c4c3h2d',
  '7s7h7c9d4d',
  'KdQcJhTs9c',
  'AsJs9s8s6s',
  'JsTs9s6s5s',
  '5s5h5cKs3d',
  'AsKs9s7s6s',
  'KdQdJcTh9h',
  'AhAc6c5s4s',
  'AsKc8d7h2d',
  '8s7h6s5h4c',
  'AsAhKsKd7s',
  'Jc9c8c5c4c',
  'JsJhKdQd5s',
  '9s9h9dQc6s',
  '5c5d4s4d3h',
  'QsQc6h6dJs',
  'As5d4d3d2d',
  '7s6s5s4s3s',
  'AsJs5s4s2s',
  'JhJcJd3s3h',
  'Th8h5h3c2d',
  'QcJc9c8c7c',
  'AsAh7h7c5c',
  'Ac9h6s4s3c',
  '3h3c3d9s9d',
  '8s8h8d5s5h',
  'AsKsTs5s3s',
  '8c7d6d5d4d',
  '5h5c5dAcAd',
  'KcQcJc5c2c',
  'Tc8s7s6h4c',
  'JcTc9d8d5c',
  '7s7d2c2dKc',
  'AcAdKsKh9c',
  '7s7h7c7dJh',
  'AhAcAd8h2d',
  'AcAdKcQcJd',
  'JhTs9s8d7h',
  'AsAdKcKdQc',
  'AsAhKhQsJs',
  '9s9h9c8c7d',
  'AhAcAdKcKd',
  '5s5h5cJsJh',
  '5s5c5d3s3h',
  'Ad9c8s7c5d',
  'QhQc7s7d4d',
  '6s6c6d3h2d',
  '8h8dAs5c2c',
  '4s4hTh9h3h',
  '9s8s7h6d5h',
  '7d6d5d4d3d',
  'JdTd6d3d2d',
  'AhKsQd9h3c',
  '8c7c6h5c4h',
  'KsKhKd8s5s',
  'TsTcTd9d8s',
  '6s6hAd9s3c',
  'AhAd8s8dKd',
  'AsJsTs8s4s',
  '3s3h3c3d7d',
  'AsKsQsJsTs',
  '9c8d7d6d5d',
  '2s2h2d5s5h',
  'JsJhQhTd6d',
  '7c7dJh8d6h',
  '7s7h7c7dJc',
  'AsKs8s5s3s',
  'JsJhJd3c3d',
  'AsAcAd7s7h',
  'AhAc9s4h3d',
  'KsKhKcKd7h',
  '7s7h9s8c3h',
  '2s2h2d9c9d',
  'KsKhKcKdTs',
  'AhAcAd6c2c',
  'KhQh9s5c2s',
  'QsJsTs6s5s',
  '8s8h8dQs9d',
  '7s7h7dAs9d',
  'AsAhAcAdKd',
  'QsQhQd6s6h',
  'AhAdQcQd7s',
  'AcAd9d8s3s',
  'QhJhTs9s8c',
  'Qd8d6d4d2d',
  '6s6d8s7c3h',
  '7h6c5h4c3s',
  'AhAcAdKsKd',
  'AdKsQh5d3c',
  'AhKh9h8h5h',
  '8c8d6h3c2d',
  'QsQhQd7s7d',
  'JhJcJd6s6h',
  'JsJd9s9dAs',
  'AsAhAd8h8c',
  'AcAd7s6s5h',
  'AsAhAcAdKh',
  '7h7cAsKh6c',
  '7d6d5d4d3d',
  '8c7s6h5s4d',
  'QdTd8d6d2d',
  'AdJdTd9d3d',
  'KsQs8s6s3s',
  'AsKsQsJsTs',
  '9s9h9c5h3d',
  'QsQcQdJh9s',
  '3s3h3cJhJd',
  'Ad5h4s3h2c',
  '8s8h8c8d2h',
  'As5s4s3s2s',
  '7s7h7dKc6h',
  '8s8hAh3d2d',
  '9s9h9c9dTd',
  'KhKcKdAsAh',
  'AcKhQcJdTc',
  '4s4hKc9c2s',
  'AsAhAcAd3s',
  '9h8h7h6h5h',
  'Th9s8s7s6d',
  'AcKsQsJcTc',
  'AsAh8c8dQs',
  '8c7c6c5c4c',
  'KcJc8c6c3c',
  'TsTdJc6h2h',
  'AsAhJhJd7c',
  'KsKhKcKd8h',
  'KhQh7h4h3h',
  'JhJcJd2c2d',
  'JsJhJdAd5d',
  'ThTc3s3hQc',
  'JsJhJcJdAh',
  '7s7h7c7dAh',
  'QcJcTc9c8c',
  'KsKhKcKdJd',
  'KsKhAcQs8d',
  'KdQd5d4d2d',
  '7h6s5h4s3s',
  '7s6h5c4s3s',
  'AcKcJcTc3c',
  'AhKdQs7c4c',
  '9h8h7c6h5c',
  '6d5d4d3d2d',
  'AsJsTs9s2s',
  'AsAhAcAdTs',
  '9h9c9dTsTh',
  'JcJd3s3h6c',
  'JsJcJd9s9d',
  '5s5h5c5dAh',
  '9s9h9c9d7s',
  '5s5h5c6h6c',
  'KhQhJhTh5h',
  'AcKcQcJc5c',
  'KsQhJhTh9h',
  'AhAcAdJhJc',
  'AdKdQd7d2d',
  '3h3c3dQd7s',
  'AsAhQcJd3d',
  '5c5d3h3dAc',
  '8s8c8d6s6h',
  'TsThTdAdKc',
  '6s6cJc4c2s',
  '5s5h5c5dJd',
  'KdJh9c6d5s',
  '6s6h9d4h3s',
  'KdQhJc6d3d',
  'As8s7s6s2s',
  '9s9hQh6s4c',
  'Ah5d4s3c2s',
  '7s7h7c8h8d',
  'AsAcAdKd9d',
  'AcKc5c3c2c',
  '7s7h7c7d9d',
  'TsTh3c3d6s',
  'QhTh9h8h7h',
  'QhQcQdAs4d',
  'AsAhAcAd2d',
  'AhAcAd5s5d',
  '5h5c5dKs4d',
  '6d5s4h3d2d',
  'TsThTcAd2c',
  'AhKcQsJsTc',
  '7s7h7cTs8c',
  'AcKcTc9c7c',
  'QsQhQcQdJs',
  'QcJsTs9c8s',
  '7s7h7c7d4h',
  'QdJcTc9s8c',
  'AhKh8s5s4h',
  'AhKd9s5h2c',
  'KhQs8d5h2h',
  '7s7h7c3c3d',
  '8c8d3h3cAc',
  '3h3c3dJs8h',
  '5s5hAdTc2c',
  '7h6s5s4d3d',
  '2s2h2dTsTc',
  'AsAcKcTc2s',
  '9s8s7s4s3s',
  'AsAhAd5s5h',
  'QcQdTh5s2d',
  'QsJs8s5s3s',
  'AhQhJh9h6h',
  'JsJhThTd9s',
  '2s2h7h5s4c',
  'QdTd9d5d4d',
  'Ks9h8d5s4s',
  'JsJd7h7d2h',
  'QsQd9s9c3d',
  'As5s4s3s2s',
  '9d8h7d6c5c',
  'QdJd8d6d2d',
  'Th9c8s7h6h',
  '5h5c5dJcJd',
  '7c7dAh9d2d',
  '7h7cAhTd2h',
  'AhAcAdTd2d',
  '8h8c8d5c5d',
  'JsJcJd6c6d',
  'AsKhQhJhTs',
  'AdJd7d3s2s',
  '5h5c5dThTc',
  '6c5s4s3d2d',
  'AcKcTd6h4d',
  '8c7h6h5s4c',
  'AhKcQcTd9c',
  'QdJcTh9c8d',
  '2s2hAdKdJd',
  '8h8c8dAsKc',
  '4s4h4dAsAh',
  'AsAhKc7c2h',
  'AsAhJsJhTd',
  'AdKcTs9h7d',
  '8h7h6d5c4s',
  'TsThTc8s8h',
  '7d6h5d4s3d',
  'KsKcKdQhQd',
  'Th9h8s7h6c',
  '9c8d7d6h5s',
  'Ac5h4c3h2d',
  'AsAhAcAdJd',
  'AsKsQs6s3s',
  '9s9d7h7c3h',
  'AcKc8c6c3c',
  '7s7h7c7dQd',
  'JhTd9s8c7s',
  'AdKsQcJhTc',
  'QsQhQcQdTc',
  '7s6s5s4s3s',
  '6c5s4s3d2d',
  '5s5h5c5dKs',
  'AsTh9s8c7c',
  '7s7h7c7dQc',
  'AdQd7d4d3d',
  'AsAhAcAd5s',
  '7h7c7d6s6d',
  '6h5h4h3h2h',
  '9s9h9c9d4h',
  'AsAhAcTs5c',
  'KhKcKd7c7d',
  'AsJd9d6d4d',
  'QsQhQd7c4h',
  'AcQc9c7c3c',
  '7h6d5s4h3h',
  'JsJhJcTd2s',
  'KdQcTc9s8s',
  'AhAcAd9h9c',
  '6s6h6c6d3c',
  'JsJh3s3h2c',
  '7s7dKsTh3c',
  'KsKhKcKd2h',
  'JsJhJcJd9d',
  '7s6c5s4c3h',
  'KsQsJsTs9s',
  'AsKhQhJdTh',
  '3s3h3dQhQc',
  'AsAhAcAdJc',
  'JsJh9c9d7c',
  'KsKcKd9c9d',
  'AsQsJs7s5s',
  'KhQcJh9h5c',
  '9s9h9cTd7c',
  '2s2h2c2d6c',
  '8c8dJcTs9d',
  'Jd9d8d6d2d',
  'AhKcQc5c4c',
  '4s4h4cAsKc',
  '8s8h3c3d6d',
  '8s8h8d5s5c',
  'AsAhAcAdQd',
  'Ks8s7s4s3s',
  'KdQdJd7d2d',
  '3h3c3dAcAd',
  'AsAh8c4d3s',
  '8s8h8d7h6h',
  'KsKhKcJsJh',
  '7s7h7c7dJs',
  '7s7h7cTs8d',
  'Td9d8d7d6d',
  'AdKd9d4d2d',
  'KcKdAcQsTs',
  'KsKhKcKd3h',
  'KsKhKd9h3s',
  'QsQhQcQdTh',
  '9h9dAd8d2s',
  '3h3c3d9h9c',
  'QsQhQdTh5d',
  '4h4dTc9c2c',
  'QdJdTc9s8c',
  'JsTh9h8d3h',
  'KsQs9s7s4s',
  'AsAhAc6d2s',
  'AsAhAdTs4s',
  'AhKd8c6s2c',
  '2s2h2dQc6d',
  'QdJdTh9d8d',
  '4s4h4d2c2d',
  'AdKh9c3d2c',
  'JhJd8s8h6s',
  'KsQsJsTs3s',
  'QdJsTd9c8s',
  'JdTh9s8h3h',
  'KsKcAd8d7h',
  'AcKdJc7s6c',
  'AsAh8c8dKc',
  '9h8h7h6h5h',
  '5s5h5c5d9h',
  'AcKcJcTc6c',
  'QhJsTc9s8h',
  '7h7c3h3cAs',
  '3h3dAc7d4c',
  '7s7h7c6s6h',
  'QcJcTs7c3c',
  'JsJh4h4c2h',
  'JhTc9d8c7s',
  'AcAdKhTc3h',
  'QsJdTc9c8d',
  '7h7c7d8s8c',
  'JhJc8c8dTs',
  '8h8c8d5d3c',
  'AsAhAdKsQc',
  'KcQdJcTd9s',
  '7s7c7d6h5d',
  'AsQsJd7h2s',
  'Ts9s8c7c6c',
  'AsAh9d3h2c',
  '6s6c6dAsAh',
  'AsAhAd8c3d',
  'Ad7d6d5d4d',
  'Ad8c7h4d2h',
  '8s8h8c8dAc',
  'KdQsJs8s5d',
  'AhAcAdTh5c',
  '5s5h5cJsTc',
  'Qd6d4d3d2d',
  '6d5d4d3d2d',
  'AhKsQc6h3h',
  'AhJh5h3h2h',
  'JsJcJdQs6d',
  '8c7c6c5c4c',
  'AhKhQh5h2h',
  '2s2h2cAhAd',
  '9c8h7c6d5d',
  '7s7h7c7d9s',
  'As7s6c4s3d',
  '8d6d5d4d3s',
  'AsAhAcAd6c',
  'TsTdJd8c7s',
  'AhKhJh9h5h',
  '5s5h5d9c2s',
  'Ts9h8d7c6c',
  '7h6h5h4h3h',
  'QsQhQcQdTd',
  'TsThTc2h2c',
  '6s6hAdKd8h',
  '7s7h7c7dQd',
  'QsQhQd9s9h',
  '4c4dTh7d3c',
  'AhQsJc4d3s',
  'AcKcQsJhTh',
  'QhJcTd9c8c',
  '3c3dQhJc4d',
  '9d8s7s6h5h',
  'TsThTcTd2h',
  'AsKdJhTd9d',
  '8d7d6d5d4d',
  'AhJh5h4h2h',
  'Td9h8h4s3s',
  '2s2h2cQcQd',
  'AhKh8d6h5c',
  'AhAdKhKc5h',
  'JcTc9d7h6h',
  'AhKhQsJcTs',
  'KdQsJd6d4h',
  '8s8h2s2c6c',
  'JhJc2s2h4d',
  '7s7h7c7dAd',
  '9s9h5s5c2c',
  '5c5d4h4d7c',
  '9c9d2s2d6d',
  '5s5h5c5d9c',
  '6c5c4d3h2h',
  '9s8c7d6h5h',
  'QsQhQc9h9d',
  'AsAhAcAdQd',
  'KsKhKcKdAc',
  'AdKdJdTd6d',
  'AhKc6d5s3s',
  'TsTh6s6hAs',
  'AsAhAcKsKh',
  '2s2h2d8c4s',
  'JsJhJdAcAd',
  'Qs7s5s4s3s',
  'AcAdKcKd5s',
  '8s8h3s3hTc',
  '7h7cTh9s6s',
  '7d6d5d4d3d',
  '5s5h5dQhQd',
  '7s7h7dAhJd',
  '3s3h3c3d8d',
  '7s7c7dAd8d',
  'AhKh8h4h3h',
  '6s5h4s3s2s',
  'Jh9h5s3d2d',
  'QsQd3c3d7c',
  'KsKhKcKd7d',
  'AsAhAc6s6d',
  '8d7s6s5h4d',
  '5s5h5dJsJh',
  'Tc7c6c4c2c',
  '8s8h8dAsTd',
  'AdKdQhJc7c',
  '2s2h2dQd6c',
  'As5s4s3s2s',
  'ThTcTdAcKs',
  'QsQhQcQdJc',
  'AcJc7c3c2c',
  'As7h6d4s2c',
  'QsQcQd4c3c',
  'AhKh8h7h3h',
  'ThTcAcKd9c',
  '8d7d6d5d4d',
  '8h8c8dJcJd',
  '7s7h7c5h5d',
  '9s9c9d3s3d',
  'Qs9s7s6s3s',
  '9s9h9cJc8s',
  '6s5d4h3d2c',
  'AcKs9c8d4h',
  'AhAcAd4s4c',
  'AcQdJh9s3h',
  'QcTc8c7c2c',
  'KsQhJhTh9h',
  '6s6h6cJc9h',
  '9c9d2c2dJh',
  'KsKcKdJhJd',
  'AsKcQhJh7s',
  'QsJsTc9h8s',
  '3h3cAhKc7s',
  'AsAhAcAd9h',
  'TsTd8h8cQh',
  'JsJh6s6c9h',
  'KcJc9c7c4c',
  '6h5h4h3h2h',
  'AsJs7h5d2d',
  'JsJcJdKhKc',
  '7c6h5h4h3s',
  'ThTd3c3d6s',
  'Qd7d5d4d3d',
  'JsJhJcAcAd',
  'ThTdAsKh2d',
  'JdTd4d3d2d',
  'JcTh9c8c7d',
  'AcAdTsThKh',
  'AhAcAd7d5h',
  '4s4dAc6h2d',
  'QsQhQcQdKs',
  'JdTd6s5s4d',
  '3s3h3c3dKs',
  'AsAhAcAdKc',
  'As5s4s3d2h',
  '6s6h6c6dKd',
  '5h5c5dJcJd',
  'QsQhQdAsAd',
  'QcJsTd9c8s',
  'QhJc8d5d2d',
  'KcKd3c3dAd',
  'AsAcAd8c8d',
  'AhAcAdQhQc',
  '9s9h9c9dKd',
  '2h2c2dThTc',
  'QsJs8s5s2h',
  'TsTd9s9hKs',
  '8h7h6h5h4h',
  '7s7h7c9h9d',
  'AcTc7c6c4c',
  '7s7h7dQsQh',
  'QhJd9c6c4h',
  '4s4dKcJs6s',
  '3s3h3c9c8s',
  '6s6hTs7c2d',
  'AcKcQc4c2c',
  'As5s4s3s2d',
  'AsAhAcJdTs',
  '9c9d2s2d8d',
  '9s9h9c9d3d',
  'AsAd7d6c4c',
  '9h9c9dAs7s',
  '7s7h7dTsTc',
  'JsJcJd3s3h',
  '9s9h9cJs6c',
  'KsJs9s4s2s',
  'AsAhKsKd8c',
  '9s9h9c9d7s',
  '6s6h6c6d7h',
  'JsJd7c7d4d',
  '9h8d7s6c5s',
  'JcTc9c7c5c',
  'KsQs9s8s4s',
  'AsAd2s2hKs',
  'Td9d7d5d2d',
  'As5s4s3c2d',
  'TsThAd8c4d',
  'AsAhAcAdKs',
  '8h7c6d5s4h',
  'QsQh7s7c9h',
  '9s9h9c5c5d',
  '3s3h2h2cTs',
  '9s9h9c9d6d',
  'TcTdAs8s4s',
  'ThTdKh7s5d',
  '7s6c5s4d3d',
  'AsKsTh9d7c',
  '8h8c8d3d2h',
  'AsAhAcAdQh',
  '5h5dKdTs6h',
  'KsQhJsTh9c',
  'KhKd3h3cJc',
  'Td9d8d7d6d',
  'JsJhJcJd9d',
  'JsJhJcAc4c',
  'AcKdQdTd2c',
  '7c6h5h4d3s',
  'JsJd5d3d2h',
  'KhKdAh6h3d',
  '5h5c5d4s4d',
  'Tc9c8c7c5c',
  '6s6h6c6dAs',
  'AsAhAcAdKh',
  '7h6d5s4s3c',
  '9c8c7c6c5c',
  'QsQhAdKd3c',
  '3s3c3dTsTh',
  'QsQd9s9h3d',
  '6h6c6d5s5h',
  '2s2h2c2d7s',
  'AsAhAcTs9s',
  'JsJhJdAsAh',
  'QhJsTs9s8s',
  '9h9cAd6h5s',
  '7c6d5s4h3h',
  '3s3h3c3d5h',
  'AdTs4h3d2h',
  'AsAhAd3s3h',
  '8c8d6s6cTd',
  'Ad5d4d3d2d',
  'JcTc8h4c3h',
  'AsKsQs7s3s',
  'Js9s8s7s5s',
  'AsAdTcTd7d',
  'AsAhAd8h8c',
  'JsJhJcAd7s',
  '9s9h9c9d3d',
  '8c7c6c5c4c',
  'AhKcQc8h6c',
  '4s4h4c7s7h',
  '5s5h5cQc7d',
  'JsJd2h2dTh',
  '7s7h7cQs8d',
  'JsJhJc6h2s',
  'QhQdAsKd3d',
  'TsThTcTdKd',
  '8s8c8d6s2s',
  '7s7h7d5h5d',
  '3s3h3cAcAd',
  'QhQcQd7h7d',
  '6s6h6c6dJh',
  'KsKhKdTs4c',
  'Ah8s7h5h2d',
  'JsJhJc7c7d',
  'AsAh7d6c5d',
  'Ac5c4c3c2c',
  'AsAhKsKhJd',
  'TsTh2s2dKs',
  'KhKcKdAhJh',
  '9s8c7c6d5d',
  'AdKd7d6d4d',
  'KsQsJsTs9s',
  'JsJhTh9s5h',
  '8s8h8c8dTc',
  'AcKdQsJcTd',
  '6s6h6c6d7h',
  'Js9s8s7s6s',
  'QcQdJcJd7d',
  'AsAcAdTd8d',
  '9h9dAdQsJh',
  'QdJcTc9s8h',
  'QsQhQcQd3h',
  'ThTcTdKh5h',
  '9s9h5s5hTc',
  'AhKd7h6c5d',
  '9s9d8s8d7c',
  '3h3c3dKsQc',
  'As5s4s3s2s',
  '8s8h7h7c5d',
  'QsJcTh9d8d',
  'QhQcQd4h4c',
  'JcJdTsTh6s',
  'AhAdKsKh8s',
  '8s8h8cAs6d',
  'AhAcAd6c4d',
  'TsTd8c5h3s',
  'KsKcKdQsJc',
  '7d6h5d4h3h',
  'AsAd5s5h6d',
  '7s7h7c7d6d',
  'AhKsQhJsTd',
  'AhKsTd7c3h',
  'AdKdQdJdTd',
  'KsQsJdTs9c',
  'AhKhQhJhTh',
  'ThTc9c9d8h',
  '7s7c7dTcTd',
  'AsJh6d5c3d',
  'AcAd6s6d9h',
  '2s2h2cAd9h',
  'AsAhAcAd6d',
  'KsKd8s8d4h',
  'AsAhAcAdKs',
  'JsJh6c6d8c',
  'KsKdQcQdAc',
  'AsAh7s7hQc',
  '9h8c7h6c5c',
  'QdJd5d4d2d',
  '3h3cKcQs5s',
  'KhQhJsTh5c',
  '4h4c4d2h2d',
  'KsJsTs9s3s',
  '7s7h7cKc2c',
  '9d8h7c6h5h',
  'KsQsJd7h3d',
  '8s8h8dQs2c',
  'QcQdAsKd9d',
  'JcJd8c8dQh',
  'Qs7c6d5c4h',
  'AsAhAd8c8d',
  'QdJsTs9h8h',
  '8s8hQs6c4s',
  'AdKd8d5d4d',
  'AsAhQd4s2h',
  '8s8h8c8d6d',
  'QsJs5s4s2s',
  'AdKhQsJhTc',
  'As5d4d3s2d',
  'AsKc8s7h3d',
  '9d8d7d6d5d',
  'JsJhJcTs7h',
  'QsQd5h4d2c',
  'Td9d8d7d6d',
  'Td9d8d7d6d',
  '7h7c7dTcTd',
  '8c7h6s5s4c',
  '4h4c4dAsKc',
  'KsKhKcKdAc',
  'QcTd7d6h3c',
  'Td9d8s7s6d',
  'QsQhQdJd5h',
  'AhAc8s8h7h',
  'AcKc8c6c3c',
  '7s7h7cAsAd',
  'KdQdJsTc9s',
  '2h2c2d9c6h',
  'TsThTd6d4h',
  'Jh8h7h5h4h',
  'JsJcJdTs3s',
  '3h3c3d8s2d',
  'JdTh7c4d3s',
  '5s5h5d8c3d',
  'QcQd7s7hAc',
  'KhQdJsTc9c',
  'Ad9d8d5d3d',
  'AcAdJcTc9d',
  'AdKdQsJhTd',
  '9s9h3s3hJh',
  'KsKhKcKdQh',
  'Ks7s6s4s3s',
  'Ts9s8s7s6s',
  'TsTh2s2h5c',
  'AcKsQsJcTs',
  '9d7c6s4s2c',
  'Kd9d5d4d2d',
  'ThTd8s8hAs',
  'KsQsJs9s4h',
  'AsAcAd3s3h',
  '7s7dAc6h4h',
  'AhAcAdTsTd',
  'QsJs9s6s3s',
  'Jc7c6c4c2c',
  'AhAcAd8c5d',
  'JdTs4d3d2c',
  'KsQsJsTs9s',
  'QcQdJhJdAh',
  'Ts9h8c7h6d',
  'TsThAhKd2h',
  'QsQhQdAc7h',
  'Ad5d4d3d2d',
  'AsAhAdQs2d',
  'Jd9d8d5d4d',
  'AsKsJs9s5s',
  'AsKsJs8s4s',
  '7h7c7dJd6h',
  'QsJcTs9h8h',
  'AsAhAcQs3c',
  '8h8c4c4d6s',
  '2h2c2dKhQh',
  'KcQcJc7c3c',
  '9s8s7s6d5h',
  'JhJcJdAhTs',
  '9s9h9c9dAh',
  'AhKsQdJsTc',
  'AdKdQdJdTd',
  'JsTc9h8c3c',
  'Jd8s7s6c4c',
  'AhAcAd9c9d',
  '6s6h6cJd2h',
  'TsTh3h3d2s',
  '5h5c5d7s7h',
  'KdQdJdTd5d',
  'JsJhJcJdAc',
  '8h8c8dAsAh',
  'JhJc8h6d2h',
  'KcQcJhTc9s',
  'KsQc7h5s3h',
  'JsJhJd7s7h',
  'Jd7d5d3d2d',
  '3s3h3c3d9h',
  'AdTd9h5s3c',
  '9h9c9d8s8h',
  'AsAhAcQdTd',
  'AsAhKh7c6d',
  '2s2h2cKc4s',
  '7d6c5s4c3h',
  '7h7c7d9d8c',
  'JhTh9h8s7s',
  'AsAhAcAd9c',
  '5s5hJc7s3d',
  'QsJsTs8s2s',
  'JsJhJd8s8h',
  'AdJc8d4d3d',
  'Ad7d6d5d3d',
  '4s4h4d9s9h',
  '9s8s7s6s5s',
  'JhTh9d8h7c',
  'AdKdQdJdTd',
  'JsJhJd2h2c',
  'QsQdJhTd6d',
  'KsKd9s9hAh',
  'QhJhTs9h8h',
  'AsKh6d4c3d',
  'TcTd9s9hAc',
  'KcKd4s4dTd',
  'AsAhKs8s7d',
  '3s3h3dJhJc',
  'KsJc5h4h3c',
  '8s8h8cAsAd',
  'TsThTcTd2d',
  '4s4h4c4d5h',
  '7s7h7c7d4d',
  '9c8c7c6c5c',
  'JsJhJcJd6d',
  '9s9d8c6h2d',
  'AhAcAdQcTd',
  '6s6h6c6d8d',
  'Ah5h4h3d2s',
  '2s2h2cAsQh',
  '7s7h7c7dQc',
  'KsKh5h5dJh',
  '8s8hAdJcTc',
  'JsJhJcJdTh',
  '5s5d3c3dAd',
  '4s4h4dAsAh',
  '5s5h5cTs4h',
  '9c8s7c6c5c',
  'AsAhAd8d3s',
  'KdJd7d5d4d',
  'KhJh9d5c3h',
  '7c7d6c5h3h',
  'KsKhKc4c4d',
  '2s2h2c5s5c',
  '7s7hJc8s2s',
  'AcAdKhTh3c',
  '4h4c4dQcJc',
  'AhKs7s6s4h',
  '9s9h9dKc6s',
  'QhJcTd7h5s',
  'KsJs8s7s4s',
  'AhAdKcTc9d',
  'AcTc8c4c3c',
  'ThTcQh6s2c',
  '4c4d2s2dQd',
  'KhKcKdTd8c',
  '9h9c9d3s3c',
  '9c8c7c6c5c',
  '3s3dAdJs4c',
  'AhAcAd3d2h',
  'AsAh9h9c5c',
  '6s6hAd8h5c',
  'JsJh7c7d6h',
  '7s6c5h4c3s',
  '4s4h4dKhQs',
  'AhAcAd8s8d',
  'QhQcQdAhAc',
  'Ts9h8s7h6d',
  '3s3hTh8c2d',
  'QhQcQdTh3c',
  'TsTd5s5hAc',
  '8s8h8c7s4h',
  'AsKsQsTs9s',
  'AcAdKhKcQh',
  '4s4h4cJd5s',
  'AsAh7h5s3c',
  'Kh8d7s3c2c',
  '6h6c6dQc5c',
  '3s3h3cAh8h',
  '8s8c8dJdTs',
  '5s5dAdKc3c',
  'QhQcQdKhTc',
  'JsJhJcJdAh',
  '2h2c2dKsKd',
  'QhQcQdAcAd',
  '6s6h6c7d3s',
  'AsAhAcTcTd',
  '8c7c6c5c4c',
  'JsJhJdAs6s',
  'QsQhQdKc6h',
  'AdKdQcTc7c',
  'Th9h7h3h2c',
  'AhAcAdJh3c',
  '6d5d4d3d2d',
  'KhKc6s6d3s',
  '8s8d9c6d5h',
  '6h5s4s3s2c',
  'JsJh9h9c5s',
  '7c7dJh8d4s',
  '6s6h6cAcKh',
  'QhJsTc9c8d',
  'TcTd9c9dAd',
  '8s8h8c8d4s',
  'KhQsJsTd9s',
  'AsAhAcAdTd',
  'Qs6d5h3h2c',
  '5h5c5dQc7s',
  '2s2h2dKc9d',
  'AsKhTh8c2s',
  '7s7h7c7dTs',
  'JhJcJdAs2s',
  'Ac5d4s3d2s',
  '7d6d5d4d3d',
  '4s4h4d9h9d',
  '8h8c8dKhKc',
  'AdKdTd9d3d',
  '5s5h5c5dTc',
  '5s5h5cAsAd',
  '7s7h5h5c8d',
  '7h7c7dTs9s',
  '2s2h2cJdTh',
  '7s7h7c7dAh',
  'KcQc8c5c4c',
  '7h7dQdJc2d',
  'AhAcAd5s5h',
  'AsAh5h5c4d',
  '9h9c9dJc5s',
  'Ad5d4s3s2s',
  '2s2h2d8c7h',
  'JcTc9c8c7c',
  'Tc9c8c7c6c',
  '5s5h5c5d2h',
  'Ts9s8s7s6s',
  '8s8h8c8dJc',
  'QcJcTc5c2c',
  '7h6s5d4c3c',
  'JdTd9d8d7d',
  'AhAcAd3c3d',
  '8s8h8c8d7c',
  '4c4dJc7s5h',
  'AcAd6c6dQh',
  'AcKs6c4s3s',
  '4s4h4cKd3c',
  '9s9h9c9d3c',
  'AdKhQsJhTc',
  'TsThTc4c4d',
  '9s9d7s7h8h',
  'AsAhAcQh7d',
  'QsJsTs9s8c',
  'QsJs8d6c2s',
  'KhKd3s3h6h',
  'AcKs7h5s2h',
  'JsJh8s8h6h',
  'AdQdJd8d3d',
  'TsTdAc6s2h',
  '8s8hJdTs2d',
  'KsQsTs4s3s',
  'Th8h6h5h4h',
  '9s9h9c9d3c',
  'TsThTcTdAs',
  'JsJhJcJdAs',
  'KsKhKcJcJd',
  '7s7h7c9h9c',
  'JsJhJc6s5s',
  'AsAhAc6h6d',
  'ThTcTdQsQh',
  'AsKcQdJdTc',
  'KhKcKdAcAd',
  '9h9c9dAs5d',
  '5s5c5dAc8d',
  'TcTdAh7d5h',
  'QsQdJc3c2s',
  '8s8h8c7d6c',
  'AhAcAd4h4d',
  'KhKcKd9d8s',
  '4s4h4c4d2c',
  'Td9h8h7s6c',
  '2s2h2c2d4h',
  'AhKsJdTs3s',
  'JsJhJc9s9h',
  'Th9c7c5c4d',
  'KdQdJdTd9d',
  '4s4hKc8h7h',
  'KsKcQd8h6d',
  'AsJsTs8s7s',
  '3s3c3d4s4h',
  'AcKh7c6d3h',
  '7h7cQc6d2d',
  '5s5h5d9s9h',
  '7s7h7c7d2h',
  '7h6h5h4h3h',
  '7s7h7dAc5c',
  'JsJhJcAdKh',
  'JsJcThTd3d',
  'AsAhAdKsKc',
  '7s7hQcJs9d',
  '5h5c5dJs8h',
  'AcAdJcJdQd',
  '2s2hTs5d3h',
  'AdKsQsJcTc',
  'AcKdQh6c5h',
  'JsJhJdQsQd',
  'AcKcQc3c2c',
  'Ad9h8h4s3c',
  'AsAhAcJh6h',
  '7s7h7c8d6d',
  'JsJhJdKc2c',
  'AsAhAcAd2h',
  '4s4h4c4dJd',
  'Qc8c7c6c3c',
  'JsJhJdQcQd',
  'AdKhTc4c3h',
  '7s6c5d4s3h',
  'QcJs6c3s2c',
  'QhTh8h7h5h',
  'KcKd8h8d3h',
  'AhTh7h6h4h',
  'JsJhJcJdTh',
  '9h9d4h4c7c',
  'AdKdQd4d2d',
  'AcKcQcTc3c',
  '8s7d6c5c4h',
  '8s8hAc6h2c',
  '7d6c5c4s3c',
  'AdTd8d7d5d',
  'Ah7c4h3s2d',
  '7c6c5c4c3c',
  'JsJd2s2hTd',
  'AhKd9h7c5h',
  'As5s4d3s2s',
  'AsAhAcAd7c',
  'JsJhJcJdTd',
  '9s9h9c9d2h',
  '5s5h5d8c7s',
  'AsTs9s5s2s',
  '6s6h6dJh7c',
  'AcAdKcKd9d',
  'KcKd7h7cTc',
  'Kd9d7c4c2d',
  'AsAhAcQc9s',
  '4s4h3s3cJd',
  'JsTs9d5h4s',
  '3h3c3dKc8c',
  '8h8c8d4c4d',
  'Td9c8h7c6d',
  '8d7d6s5h4h',
  'AsKsQs6s3s',
  'JsJhJd7c6c',
  '8h7s6h3c2c',
  'JsJhJcJdAh',
  '7h7c7dJcJd',
  '3s3hAcKh2s',
  'QsQh4h4c3s',
  'KhQhJhTh9h',
  'Ad5s4s3h2h',
  'ThTd6c6d5c',
  '7h7c7dJh6h',
  'AsJs4c3c2s',
  '5s5dTc4h2s',
  'AhJs5s3d2d',
  'TsThTc4d3s',
  'AcKh5d3h2d',
  'As5s4s3s2s',
  '5s5h5d2s2h',
  '3s3h3cAcAd',
  'Jd9d8d5d2d',
  'Ah9s8s7d4c',
  'Kd8d7d3d2d',
  'KhJh8d5h3s',
  'QsQcQd9s9c',
  'AsKs5s4s2s',
  'AsQsTs7s4s',
  '6h5h4h3h2h',
  'QsJs9s7s3s',
  'AcAdKcQh7h',
  'KsQsJcTs9c',
  'AcTc9c7c6c',
  '8s8c8dQsQd',
  '7s7h7cAs5d',
  'AsKsTs4s2s',
  'Td9d8h7h6s',
  'AhKdQcJdTh',
  '7s7h7cKdQh',
  '7s7h7c7d6c',
  'QsQh9h9c3h',
  'AsKsJs9s8s',
  '8c8d3s3dAd',
  'KdQd9d6d2d',
  'AdKsQhJsTc',
  '6s6h6cAhKd',
  'AsKsJsTs9s',
  'KsKdJs8s6d',
  'Td9d8d6d5d',
  '8h7h6c5d4h',
  'AsAcAd8h4s',
  '7h7c7d3c2d',
  '3s3h3dKs9c',
  '3c3dJs6s2h',
  '4s4hKdQs9s',
  '7h6d5d4h3d',
  '6d5d4d3d2d',
  'Ts9h8s7s6s',
  'QsQhQcAc2s',
  '8s8h8d7h7d',
  'Th9h8c7d6h',
  'ThTcTdQd9s',
  '9c8h7d6c5c',
  '7s7h7c4s4h',
  'KsKhKcKdAc',
  'AhAcAd9d7d',
  'KcJh9d7s2h',
  'QhJh9c4h2d',
  '4s4h4c4dAd',
  'JcTs9d8d7c',
  'AcKsJdTh8c',
  '2h2dKhTs8s',
  'AsAhAcAdTc',
  '7s7h7c6s6d',
  'QcJc6c4c3c',
  'AcJc9c6c3c',
  'AcKhQd7h4h',
  '7s6s5s4d3c',
  'TsThTcQhJs',
  'AsAhAcKsTs',
  'AsKsQh7s4s',
  'QsQdAsJh3s',
  '9s8s7s6s5h',
  'AsKsQs8s7s',
  'QdJdTd3d2d',
  '9s9h9c9dAh',
  'AsAhAc9s6d',
  '2s2h2cJd5s',
  'TsThTcQsQh',
  'KcKdQcQd9c',
  '3s3h3cQdTd',
  'JsJcJdAh7s',
  'AsAhAcAd7h',
  '5s5dAcJc9h',
  'JsTs9s6s4s',
  'AhAcQsQhJc',
  'KsQdJhTd9s',
  'JsTs7s6s2s',
  'AsKsQdJcTd',
  'JcTh9d5c2h',
  'JsJhJd3c3d',
  'KsQsJsTs9s',
  'AsAhAcAd7h',
  'QsQhQcQd6s',
  'Ah9h8h7h3h',
  '3s3h3c3d2s',
  'AsAh8d3d2s',
  '5s5h5c5dJh',
  '7h7c7dAcAd',
  'TsThTd8h8c',
  'KhQhJdTc9h',
  'AsAhAcAdKc',
  '6s6h6c6dAc',
  'QsQhQcQd3c',
  'TsThTcTd3s',
  '3s3h3c9d4d',
  '7s7h7dKcTc',
  '9s9h9c9d2s',
  'Th8h7h6h3h',
  '5s5h5dAhAd',
  'KdQdJcTd9s',
  'JsJhJcJd3h',
  'AhKh6h3h2h',
  'AsAhAcAd3d',
  '2s2h2dQsQh',
  'JdTd9d4d3d',
  '9s9h9d8h8d',
  'AsJs7s6s5s',
  'AdKdQc6c2c',
  'AsKs9s3s2c',
  'KcJc9c6c3c',
  'JsJhJcJd8d',
  'AdKh9h3c2s',
  '7s7h4s4d8c',
  '6c5s4d3d2h',
  'AsAhAd7h5c',
  'JdTh9h8h7h',
  'JcJd9c9d4c',
  'KhKcKdJd6h',
  'QdJd9d5d3d',
  'QsQhQdAc6h',
  '3s3h3c3dTh',
  'ThTcTdAsKd',
  'AdKdQd9d5d',
  '3s3h3c3dJh',
  '3s3h3d7s7d',
  'QsJcTh9h8c',
  '6c6d2h2dQs',
  'KsKhKcTc3d',
  '7s7dJsTd2d',
  'Ts9s5s4s3s',
  'Th9d8d7h6s',
  '7c6c5c4c3c',
  'AdJdTh6d3d',
  '3h3c3d5s5h',
  'AhTh6s4s3s',
  '8s8h8c8d6h',
  '5s5h5d6s6d',
  'Ah5h4h3s2d',
  'KsJs8s6s4s',
  'TsThTdQs7s',
  '6s6h6cJs7d',
  'Qc8c7c5c4c',
  '8d7c6d5d4c',
  '6h6cKd8h3c',
  'AsAhKd7c6s',
  'AhKhJh7h6h',
  '4s4d2c2dJd',
  '2s2dKs8d5s',
  '2h2c2d5h3h',
  '4s4h4dKd8h',
  'KdQdJdTd9d',
  'KcQcJcTh9s',
  'Td9s8d7h6h',
  'Js9s8s7s5s',
  'JdTd9d8d7d',
  'JsTs4s3s2s',
  '6h5c4d3h2s',
  'QhJcTc6d5d',
  'AsAhKhKc4h',
  'QsQhJsJh2h',
  'AdKdQs8d6s',
  'QcJcTc8c2c',
  '5s5h5c8s8c',
  '5s5h5c5dQc',
  'AsAhAc9s9h',
  'KsKhAhTh3c',
  'Td9s8h7h6c',
  'AhKdQcJsTs',
  'Jd9d6d3d2d',
  'AcAdJs8c4s',
  'JsJhJcKs5c',
  '4h4dQc7c5d',
  'KsKhKcKd9c',
  '4s4h4cQd5d',
  'AsAhAdTsTh',
  'AsAhAcAdKs',
  '5s5h5c5d9s',
  'AsAd2s2d8s',
  '5s5h5c5d2h',
  'KhQsJcTh9c',
  'AhAcAdTc3h',
  'KhQhJhTd9h',
  '9s9hTc8s2d',
  'JsJhAc9s7d',
  'AcKsJsTc3d',
  'QdJdTs9c3d',
  'AcTc6c5c2c',
  '2s2c2d6c6d',
  'QsJs6s5s3s',
  'JcJd9s9h6c',
  'AcKcQc5c3c',
  'JcTd5c4c2s',
  '9s9h9cJhTc',
  'KsKhKcAd9h',
  'AhAc6s6hTh',
  'QhTh9c6d5s',
  '3s3c3d4c2s',
  'AdKdQcJdTc',
  'As5s4s3s2s',
  'KdQsJhTh9c',
  'Th6d5d3d2c',
  'JcJdAdKd7s',
  '8h8d2c2d6c',
  'AsAh2s2hKc',
  '7s7h7c9s5s',
  'AsKsQsJs4s',
  'QsQhQcQdAh',
  'AsKsTs8s5s',
  '9h9c9d3h2h',
  '8s8hKcTd9h',
  '8d7d6h5h4c',
  '2s2h2dAsAh',
  'Qs8h5d4h2d',
  '9c9d3c3d5d',
  '6s6h6c6d2s',
  'KsKhKcKdJd',
  '9d8d7d6d5d',
  'QsQdJsJh3c',
  'JhJcAhKs9h',
  '7s6s5s4s3s',
  '4s4h4c4d7c',
  'AcKcQcJcTc',
  '9c9d8s8hAc',
  'JsJhJd8h3c',
  '9s9h9c9d3c',
  'AdTd7d4d3d',
  '9c8h7s6d5h',
  'JcTc7c4c2c',
  'AcAdJcJd3d',
  '3c3dKdTd4h',
  'Kd7d6d5s2c',
  '4c4dTh6c5c',
  'AhQs8s5h3s',
  'AsAhAdKh8d',
  'Ah5h4h3h2h',
  '9s9h9cQdJs',
  'AsAhJsJd3c',
  'Td9d8d3d2d',
  'AsAhAdJc3h',
  'Jh9s7h6d3s',
  '5s5h5cAs6s',
  '7s7h7c7dQs',
  'QhQd4h4cAc',
  'TsThTdAh9s',
  'QdTd6d5d2d',
  'AsAhAcAdKh',
  '7h7c7dJd8h',
  'KdQsJhTs2h',
  '9h9cTd7h5d',
  'JcTh9s8c7d',
  'AsAdKsKc8s',
  'Ts9s8s7s6s',
  '3s3h3c3d2d',
  '6s6h6dKd4d',
  'JhJc4s4h9s',
  'ThTcTd4c4d',
  '8s8h8c8dJs',
  'AhKc9c7c4s',
  '6s6h6c6dAd',
  'TsThTcQdJd',
  'JcJd7c3c2d',
  '4s4h4c4dKd',
  '8s8h8c7h3c',
  'QcJc7c5c4c',
  '9s9hJc6h2d',
  'KcQs9d7h2s',
  'AhAc3s3hJd',
  '9h9c9dJh6s',
  '7h7c7dQsQh',
  '7s7c7d4s4h',
  '2s2h2c9d4h',
  'AsAhAdQh5c',
  'AsKhQhJhTs',
  '6c5d4s3d2h',
  'AhAcAd4h4d',
  'JcJdTsTh9h',
  '9d8d7c6s5s',
  'AsJd9c4s2h',
  'ThTcTdKhKd',
  'JsJcJd6s6d',
  'AsAhAd6s6d',
  'Ac5s4h3h2s',
  'JsJhJc9s2h',
  'QsJcTs9d8d',
  'TsThTcTd7h',
  'QsJsTs9s8s',
  'JsJhJcJdKh',
  'AsAhAdTs8h',
  'AdKdJd5d4d',
  'AsJs9s7s3s',
  'TsThTc2s2d',
  'AsTs8s7s3s',
  'KsKhKdThTc',
  '9c9dAc8c5d',
  'AhTc8h6c5h',
  'QhJh8h7h2h',
  '7d6c5h4s3d',
  '6s6h6c6dKc',
  '2s2h2c2dAs',
  '7d6d5d4d3d',
  'KcTc8c7c5c',
  'KcTc8c4c3c',
  'KsQsJs5s2s',
  '7h6c5c4c3d',
  'AsAhKsKh3s',
  'AsKc9s4h2d',
  '6c5c4d3h2s',
  '7s6c5c4h3c',
  '2c2dAcTc8c',
  '9s5s4s3s2s',
  'JsJc7c7d9c',
  '4h4c4dAsAc',
  '9s9h9dJhTc',
  'JsJhJcQs2h',
  '7h7c7d6s6h',
  'AhAcAdTcTd',
  'KsKhKdJsJd',
  'AhKsQhJcTs',
  '3s3h3c5s5h',
  '2s2dJsTd3d',
  'AdKdJdTd8d',
  'KsKhQsQhJs',
  'QhQcQdJc6d',
  '9h8c7d6c5h',
  'Qd8d7d6d5d',
  'AsAcAdQcQd',
  'QsJs9s5s3s',
  'KsQs6s5s4s',
  '7s7h7c7d5c',
  '8h8c8dQc7s',
  'QdTd9d7d5d',
  'AsKsTs9s4s',
  'Td9h8h6d4s',
  'AsKsQsJsTs',
  '3s3h3dAdKc',
  'AdQs5s3c2c',
  '5s5dKdQc9d',
  '8d6h5h4h3d',
  '4h4c4dAdJd',
  '6s6h6d8s8h',
  'JcTc9c7c6c',
  'AsKsJs7s5s',
  'Ah8c7d6c5s',
  'Ad5c4c3c2c',
  'AsAcAd9c5s',
  'AsAd3c3d9c',
  'JhTd8c6h5d',
  'JhJcJd9h6d',
  '5s5hJs8c4s',
  '7h7cAsJc8c',
  'KsQsJdTh9d',
  '2s2dAsKc4h',
  'Kd9c6s4d2d',
  '8s8h8dJh3s',
  '4s4h2c2d8h',
  '9h9c9d3s3h',
  'Ad5c4h3d2c',
  'KsKhJsJh6d',
  '5s5h5c5dJh',
  'JsJhJcJd9s',
  'AcKsQcJhTs',
  'AcKsTh9s6c',
  '5s5c5d7c7d',
  '6s6h6c6d9c',
  'QhQcQd9s6d',
  'Ad5d4d3d2d',
  '7s7h7c7dAh',
  '9h8c7s6s5s',
  'KcQcJcTc9c',
  'AhKh7h6h4h',
  'JsJhTcTdQs',
  'AsAh6c6d5s',
  'QhJsTd9h8d',
  'AsAhAd8h8c',
  'QhJc8c7h4c',
  'QsQhQc4d2s',
  'JhJcJdKh5s',
  '3s3h3c3d9h',
  'Ad5d4d3d2d',
  '6s6h4h3s2d',
  '9s9h9c6c6d',
  '8s7s6s5s4s',
  'JsJh6s6h5h',
  'Ad5s4h3c2s',
  '7d6d5d4d3d',
  'TcTd7s7dAh',
  '6d5d4d3d2c',
  'AdKdTc3c2c',
  'AhKdQsJcTh',
  'QsJdTd9d8h',
  '7s7c7d2c2d',
  '2s2h2c2d8d',
  '4h4c4d8h2d',
  '6c6d7s5c2s',
  '8c7h6s5s4c',
  '7c6c5c4c3c',
  '5s5h5c8s8d',
  'AcAdKhQd6c',
  '3s3c3dTc8d',
  'QdJdTd8d2d',
  'AcAdQhTc4c',
  'AhAdTc7s3s',
  '4c4dJd9c5h',
  '8c7h6h5h4d',
  '6s5d4d3d2s',
  'JdTd7d6d2d',
  '4s4dAhKdQs',
  'Td9h8c7c6c',
  'TsThTdJcJd',
  'TsThTcTd2c',
  'Ac7c6c5c3c',
  '4h4c4dAhKh',
  'KsQhJh9d3h',
  'KdQc9d4c3c',
  '3s3h3dJhTs',
  'KsTs8s7s5s',
  'AhAcAd7s6h',
  'AsJs9h7d5h',
  '7s7h7dJd9s',
  '6c5c4h3h2c',
  'AsAhAc7c4h',
  'Kh8h7h5h2h',
  '7h7cAs9d3s',
  'JsJhJcAsAd',
  'KsKhKcTs7c',
  'KsKh6s6hAc',
  '7s7h7c7d6d',
  'JsJhJc3h3c',
  'AcQd6s3d2h',
  'AhKh8h7h6h',
  '5h5dAs7d2h',
  '9s9h9c9d5s',
  '8d7s6d5c4d',
  'KdJdTd8d4d',
  'AdKd8d6d2d',
  'JdTd7d4d2d',
  '8h8c8d9s9h',
  'AdJdTd9d3d',
  'AdKdQdJdTd',
  '4s4h4cQc6h',
  'AsJs9s3s2s',
  'JsJhJdTsTh',
  'AsKsJsTs8s',
  '3s3h3dAd8c',
  'JcJdAsKsQs',
  'KsKhKcAhAd',
  'Ac9c7c6c3c',
  '2s2h2c2d7s',
  'TsTd4s4dJd',
  '7h7cJc9c8s',
  'QsJs7s5s4s',
  'AsAcAd2c2d',
  '8c7c6d5s4s',
  'KhTh8c7d6h',
  'As8c7c5s4h',
  '8h8c8dAs6s',
  'As6d5h4c3d',
  '7s7hKhQd3s',
  'QsQhQcQdKh',
  '7s6s5d4h3s',
  '8s8h8dAcKh',
  'AsAhAd9h2d',
  'Th9h8h7h6h',
  '3s3h3c3dAh',
  'AsAhAcAd6d',
  'KdJd8d5d4d',
  'QsQhAcKs2h',
  'AsAhAdJcJd',
  '5s5h5d7s7h',
  'JhJcJd6s6h',
  'Ad5d4d3d2d',
  '4s4h4dAsKc',
  'AsAhAcAdKh',
  '9s9h9dKc4d',
  '7c7d3c3dAh',
  'AhJs7h6d2h',
  '5s5d4h4d7s',
  'JsJhAdKcQd',
  'AsAhAd4d3c',
  'AsKs5s3s2s',
  '4s4hKc6d2d',
  '5h5c8h7h4s',
  'JsJhJcJd6d',
  'QcJcTc9c2c',
  'QsQcAs5c4d',
  'AsAcAd6d4d',
  'AsAhAd6s6d',
  'AhAcAdKcKd',
  'JsTs9s4s2s',
  'JcTs9d8s7h',
  'AcJd9h8d5d',
  '9s9h9c9d3c',
  'AsAhAcKdQc',
  'AhAcAd3c2c',
  'As9h8d6d5c',
  'QdTd8d4d2s',
  '9s9c9dJcJd',
  'QsQhQcTd6c',
  'KsKhKcKd9d',
  'AsAhAcAdKs',
  'QhQdTs7h6c',
  'AsAhAcAdTc',
  'KsKhKcKd5h',
  '8c7c6c5c4c',
  'KsQs9s8s5s',
  'AsAhAd4s4h',
  'AsAhAc9s8d',
  'TsThKs8h3d',
  '9c8c7c6c5c',
  'AdTc9c8h3c',
  'JsJdAdKc3c',
  '9s9h9c7s7d',
  'KsKhKcKd9s',
  'AdKd5d4d2d',
  'KcQcJc9d4h',
  '7s7h7dAsAd',
  'KcTd9c7s6c',
  '9s9c9d2s2h',
  '6h6d4s4hKs',
  'KcQcJcTc5c',
  '6c6dJcTc2s',
  '2s2h2c2dKs',
  'AsAc3s3c6h',
  'As7s6s5s4s',
  '8s7c6s5c4h',
  '4c4dQhJs9c',
  '5h5dJdTd4c',
  'KdJdTd9d8d',
  'AhAc8s8hTh',
  'Ad8d5c4c2c',
  'AsAhAc8s8d',
  '4s4hJd5s2s',
  '7s7h7c7d3h',
  'KhKd2s2c4c',
  '6c6d4s4dJs',
  'AsKs9s8s2s',
  'ThTcAcKd2h',
  'KsKh2s2h6s',
  'AdKhQs6h4c',
  'KsQdJd9d8c',
  '4h4cKcQsJs',
  'AcAd4c4dJh',
  '5c5d2c2dTs',
  'QcJc7c6c4c',
  'AhKhQdJdTs',
  'TsTd7s7hQs',
  '8h7h6h5h4h',
  'Ts8s6s5s4s',
  '4s4h4c4dKh',
  'KsQc9h4s2c',
  'AsKsQsJsTs',
  '8c7d6h5d4s',
  'JcJd2s2d8d',
  '8s8hQd9h3d',
  'KsTs8s6s3s',
  'AsKsTs7s6s',
  'AsKsQsJd2h',
  'QsJdTd7c6s',
  'QcTc9c6c5c',
  'KsKhKcQd2c',
  'AsAhAcKcKd',
  '9s9h9c9dTd',
  'KhKdAcQs7d',
  '7s7h7c2s2h',
  'QhQcQdTd8c',
  'ThTc4s4h3c',
  'AcKcQsJcTc',
  '5s5h5d4c4d',
  '8c7s6h5c4s',
  'TsThQs8h3s',
  'QcJcTc9c8c',
  '3s3c3dKsKh',
  '2h2c2dJcJd',
  'AsKdQd6s4h',
  'TsThTdAhKc',
  '9s9h9dAc6s',
  'JsJhJcQd2d',
  'Ts9s8s7s6s',
  '9s9h9c7c7d',
  'QcQdJsJhKc',
  'AsKsQs3s2s',
  '7h7c7d8c8d',
  'AhAcAdKsJs',
  'KcQd7d3h2d',
  '4s4dQcTh6d',
  '9c9d7h7d4h',
  'AdJh7d3c2h',
  'QsJs5s4s3s',
  '5s5h5c5dJc',
  'QhQdTc8c4c',
  '6s6h6c6dJc',
  'KhQcJhTc9s',
  '8s8h8c7c7d',
  '6s5c4c3h2d',
  'AsAhAcAd8d',
  'QcJcTc9c8d',
  'AhKhJh7h2h',
  'KdQhJsTs9h',
  '2s2h2dQcQd',
  '3h3dKcJd2h',
  '8c7h6s5h4h',
  'QsQc8c8d6c',
  '9s9hAh7h6h',
  '9s9h9c3h3d',
  '9c8d7c6h5c',
  '7h7c7d9d2c',
  'As9c6h3d2c',
  'AdKdQdJdTd',
  'JcJd7h6h5d',
  '7s7dAdKs8h',
  '7s7d4s4c5c',
  'AcAdKsQc3c',
  '4h4c4d7h7d',
  'AsKsQsJs6s',
  'AsKsQsJsTs',
  'JcJdTcTdAs',
  'JcTc9c8d7s',
  'AsAd9s9d8h',
  'KhKcKdAd7c',
  'JcTc9c8c7c',
  'KsQcJcTd9h',
  'AhKhJh8h6h',
  'JsJh7h7c2d',
  '3s3h3d8h8c',
  'QsQhAd6h3c',
  'AsKdJd6h4c',
  'Js9s8s7s5s',
  '7s7h7d6s6h',
  'Ks7s4s3s2s',
  'AcJh9h6s4h',
  'Ad5c4h3d2c',
  'JsJhJcQsTc',
  '5s5h5c5dJd',
  '9h8c7h6c5c',
  'QdJcTs9c8c',
  'AsAhAcAd4h',
  'QsJd9d7s6c',
  '7s7dAhKc6c',
  'JhJcJdTd3h',
  'As9h8d6c5d',
  'AcAd5h5d3d',
  'AcAd4h4d5c',
  '7s7h7c7dAs',
  'AdKs9h6c5d',
  'KcKd2h2d9s',
  'AsKs7s4s2s',
  'JsJhJcTsTh',
  '4h4c4d7s7h',
  'JsTs8s7s4s',
  '5s5h5c5d9c',
  '9s9h9c9dAd',
  'KcKd3s3dJd',
  'JhTs9s8s7c',
  'QcJdTd9h8d',
  '6s6hAs7h2d',
  'KdQdJd7d5d',
  '8s8h8c9s9d',
  'JcTc8c5c4c',
  'JhTc9c8c7d',
  'AsAhKsQs8d',
  '8s8h8c8d2h',
  'QsQhQdAs6h',
  'KsKhKcKdTc',
  '2s2h2cTc7c',
  '8c8dAd7d2h',
  'AdJc6d5h2s',
  'AsAhAcAd7h',
  '8h8d3c3d6h',
  '8h8c8dAcAd',
  'Ah8d7d4h2c',
  'QsQdJsJc9d',
  'QsQh9s9h2h',
  'KsQcJhTh9d',
  '7s6s5h4s3s',
  '6s6h4s4h9c',
  '7c6h5h4d3d',
  'AhKsQsTc7d',
  '5s5h5cJhJc',
  '6c5c4c3c2c',
  'TsTd6c4c2c',
  'AdTd5d3d2d',
  'AdKd8d4d3d',
  'KhKcJs7h3s',
  'QsQc2h2d7d',
  'Td9s8c6s5c',
  '2s2dKhTd8d',
  '8s7d6d5d4d',
  '7s7h7cAhJd',
  '6d5d4s3d2c',
  'AcTc9c7c3c',
  'KdJd9c5c2h',
  '3s3h3c3d7c',
  'AhAdJsJh7c',
  'QhQcQd3s3h',
  'KcKdJsJh6s',
  '7h7c6c6d9s',
  'KcQhJcTh4d',
  '8h7c6c5h4h',
  'AhAcJsJh9d',
  'KsKhKc6s6h',
  'KsQsJsTs4s',
  '9s9cJsTh4h',
  '4c4dQsJh6s',
  'AsAh9s9d8h',
  'As5h4s3h2s',
  '7c6s5c4s3h',
  '7s7d8c6c5c',
  '8s8h8c8dJs',
  '4s4h4dAh7h',
  'TsThTcTd6c',
  '7d6d5d4d3d',
  '9s9h9c9d7s',
  'AhQh9s6d4s',
  '5s5h5d2h2c',
  '7s7h3s3hKc',
  '6h6c6d8c4d',
  'JhTc9s8d7h',
  '6s6c4h4c7c',
  'AhAcAdJdTd',
  '4h4c4d7h7c',
  'AdKsQsJsTh',
  'QsQhQdJh7d',
  '7s7h7c5d3s',
  'AcQc8c7c3c',
  'Jd9s5d4h3c',
  'KcKdAsQs5s',
  'QdJd6d5d4d',
  'KsKdAd8s3h',
  'AhAd8s8dKh',
  'Td9d8d7d6d',
  'QcJsTh9d8d',
  'KsKcKdTd3s',
  '9s9hJdTd8h',
  'TsThTcTd3d',
  '9h8c7d6s5s',
  'KsKhKc6c5h',
  'TcTd4c4d9h',
  'KsQs8s4s2s',
  'AcAdKh9d6c',
  'AdKdQd5d4d',
  'AdJc9d3c2h',
  'TsThTc8d6h',
  '7s7h7c7dAh',
  '8s8h8cQsQd',
  '4s4h4cAcKd',
  'KsKhKcAcAd',
  'AsQsJs6s5s',
  'AsAhAcAd5h',
  'TcTdAhKdJc',
  '8s8dQsJh4s',
  '7s7c7dAsAh',
  '8s8h8c8dJh',
  '5s5h5dAsTs',
  'AdKdQd7d5d',
  'AsKcQc7s5s',
  'TsTh6c6d7d',
  '8s8h8c8dAh',
  'KsQsJsTs9s',
  '8h7d6h5d4h',
  'AsJc9c6c3s',
  'JcJdKd9c2s',
  '8d7h6h5c4c',
  '8s8h8c8d7c',
  'JsJhJcJdQs',
  'TsThTcAhAc',
  'KdQsTc9c6d',
  'AsJs7s5s4s',
  'AsAdJc9c6h',
  'ThTcTdJsJd',
  'KsKhKc6c6d',
  'KsJs9s6h5s',
  'AsJsTs6s5s',
  '6s6h6c8s8h',
  'JhTc9s8d7d',
  '8h7c6h5h4h',
  'QdJc8d3c2d',
  'JsJhAhKd3d',
  'JhJcJdAsTc',
  'AhAcAdQdTc',
  'Ts9c8d7h6d',
  'KsKhKc7s7h',
  'QsQhQdKc2h',
  'KsKhKd7h2h',
  'Ts9h8c7h6d',
  'JhJd8c8dTs',
  'Ah5s4d3d2h',
  'Ts9s7h3h2c',
  'QdJd8d4d2d',
  '9d8h7s6c5s',
  '3h3c2s2hJc',
  '6h5s4h3d2d',
  'AhAdKh7h2s',
  'QsQcQdAhKh',
  '9s9h5s5dQh',
  'AcKsQdJcTc',
  '6h6dJs7s5h',
  'Td9h8c7c6c',
  'QsQhJsJd6c',
  'AhAcAd3s3c',
  '7h7c3s3c6c',
  '8h8c8d9s9d',
  '5h5c5d9s9d',
  '7s7h7dKdJh',
  '8h8c5h5cJd',
  'KsKhKcKd8h',
  '2s2h2c2dQc',
  'KsKhKc3h3d',
  '5h5c5dQcJh',
  'JhJc3h3c6d',
  'JhTs8c5d3s',
  '7c6h5d4h3s',
  'AcKsTs6s2c',
  'QcJc7c6c3c',
  'Kd8d7d6d5d',
  '5s5h5c5d8s',
  'KsKhKcJsJd',
  'KdQdJdTd9d',
  'AsAcAd9s6h',
  'QdJd8c5s2d',
  '7s7h7cJc3s',
  'QsQhQcQd2s',
  'Ts9c8h7s6c',
  '7s7c7d3c3d',
  'AcTd4h3c2h',
  '3s3h3c3dJc',
  'Th9d8s7c6h',
  'Ad5s4h3s2c',
  'AcAdKh9d4d',
  'AsAhAd6h6c',
  '5s5c5d7s7h',
  'JhJcJdAsAh',
  'TsThTcTdAh',
  'KsQdJhTd9c',
  '7h7cAc8c4h',
  'QdJd8d5d4d',
  '8s8h2s2hTc',
  'TsTcJh7d5d',
  'KhKd8h4h2c',
  '7s7hJsTs9h',
  'AcAdKsKc4d',
  'KdJd8d6d4d',
  'AsQcJc9h7d',
  'Ad9d8d5d4d',
  'AcQdTd6d3c',
  'JhJcJd9d4h',
  'KsJsTs7s6c',
  '6s6h6cJcJd',
  '4s4h4c6c5d',
  'AcKc7c6c5c',
  '3s3h3dAs4d',
  'QsQhQc4c4d',
  '4h4c4d3s3h',
  '3s3h3cKhQd',
  '7d6d5s4c3s',
  'AsAhAdKd4d',
  'KhQcJs8c4d',
  'AcAdKsKh6c',
  'AsAhAd7s7h',
  'JsJhJdKc9c',
  '9s9h9c9d4h',
  '7d6s5c4h3s',
  '7s7h6s6dTh',
  'QhQcQdTh6c',
  'AcTh9h8d6d',
  '5s5h5d3s3c',
  'AdKdQdJdTd',
  '2s2h2c2dQc',
  'AcKd8c5h2s',
  '9s9c9dJd7h',
  '9h9c6s6hKs',
  '7c6c5c4c3c',
  'AsJs8s7s5s',
  'TcTdKdJh3c',
  '9c8d7s6d5h',
  'JdTc9d8c7c',
  'JsJhJc2h2c',
  'AhAcAd3c3d',
  'Ad7d5d4d3d',
  'JsJhJcJd4d',
  '2h2c2d4s4h',
  '8s8dKh4c3s',
  '6s5c4s3c2c',
  '3s3h3cTsTh',
  'JsJh7s4h2s',
  'QsJdTs9d8c',
  '6s6h6c6d9c',
  '3s3h3cQhTd',
  'QhQcQd6s6d',
  'KcQcJcTc9c',
  'Qd9d6d4d3d',
  '7s7dAsKs8s',
  '5h5c5dAh7d',
  '7s7d2c2dJh',
  'As5s4s3s2s',
  'AdKdQd7c5d',
  'AdKcQcJhTc',
  'AcJd9h6d3d',
  '2s2h2dAcJs',
  'KhKc7c7d6c',
  'KhQsJsTs9h',
  '3s3h3c3dKc',
  '7c6c5c4s3d',
  'JsJhJcJdTc',
  'AsJs8c3c2d',
  '9d7d6d5d4d',
  '9c8c4c3c2c',
  'AsAhAcAd2c',
  '9c8h7s6s5s',
  'AsAh6s6hJh',
  '2h2c2d9c9d',
  'Ah5h4h3h2h',
  '8s8h8cKhJh',
  'KdJs6h5d2h',
  '4s4hKhQcTs',
  'KdQdJhTd9h',
  '6h6d7s5h3s',
  'QcQdJs8c4s',
  'AsKhQsJdTh',
  'KsKhKdAhJd',
  'QsQhQcAs6h',
  'AsAh8h8c7s',
  'KsKh7s7dTs',
  'KsQdJdTh9c',
  'KdJd7d5d4d',
  'AcJh9h4s2h',
  'KsKh7s7hTc',
  'KhJh8c7d4d',
  'JsJhJd8d7h',
  'AsAh3h3dTc',
  '7s7h6s4c2s',
  'QdTd5d4d3d',
  '6h5d4h3s2d',
  'QsJs9s7s6s',
  'AhQhJs8h7s',
  '7s7h7cAsKd',
  'AdKd9d7d2d',
  'KsKhTh9c8d',
  '7h7c5s5d9d',
  'QhTh9h7h3h',
  'Ah7h6h5h3h',
  '7h7c6c5h2c',
  'AhAcKsKh7h',
  'JsJd8s8hAs',
  'QdJd9d7d3d',
  'Jd8d5d4d3d',
  'Jd8d7d5d3d',
  'AdJd7c6h2c',
  'AsAhTh9d2s',
  '9s9d8s8h4d',
  'AcQcJc9c6c',
  '5h5c3s3d8c',
  '8s8h8dJdTs',
  'QcJh7s4d3h',
  '9c8c7c6d5h',
  'AdKd9d4d2d',
  'AsAh7c7dKh',
  'Ts9c8d7d6s',
  'AhAcAd9h9c',
  'AsKsQs9s7s',
  'AhKh8h7h3h',
  'TsThTdJc6h',
  'QsQhQcAs2h',
  '9c9dJcTc5s',
  '3s3h3c3dAs',
  '9s9c9dQhQc',
  'JsTs9s8s7s',
  'JsJhJdTcTd',
  'ThTcTd7s7h',
  '7h7c7dAhAc',
  '5s5h5c5dTh',
  'Ts7c5h4h3h',
  'JsJhJcJdTh',
  'KdQdJdTd9d',
  'QdJd8d7d2d',
  'AsAhAdJsTs',
  'AhAdJsTc3s',
  'AcKcTc9c7c',
  'TcTdQs6s2c',
  '2s2dAhKh6c',
  '8s8hAdJd6s',
  'KsQs7s4s3s',
  'AhQc8h7h3h',
  'AhKsQsJsTs',
  'QhJhTc9c8h',
  'AdKdQd8d5d',
  'QdJdTd9d8d',
  'TsThTcTdKc',
  'AdKdJd7d4d',
  '6h6c6d7s7h',
  'QcJcTd9d8s',
  'JsJc6s6h8h',
  'Qs5s4d3d2h',
  'AcKcQdJc3c',
  'AdJd8d6d5d',
  '9s9h9c9d2s',
  'KhQd9h7s5d',
  'KhKcThTdAd',
  'JdTc9h7d5s',
  'QhQc6c6d7d',
  '9d8d7d6d5d',
  'Ah9c4d3s2c',
  'AsAhAd9s9d',
  'AhAcKsKh9h',
  '9s9h9c9dTd',
  'KsJdTs7d4h',
  '3s3dAcJd6c',
  '7h6h5h4h3h',
  '9s9h9cKhJs',
  'AsAhAc5d4c',
  'AsAd9s8c6h',
  'JsJhJc6h5s',
  'AhAcAd2s2h',
  'KsKh7s7c3c',
  'QhJcTd9d8c',
  'KsKhAh3h2c',
  '8s8hAh9s5h',
  'QsQhQd9c6s',
  '2h2cQdTc9s',
  'AsAhAdKcKd',
  '7s7d3h3c8h',
  'JdTd9s8c7h',
  'QsQhQcQd7h',
  '5s5h5c5d4c',
  'AsKcQsTh9h',
  'JsJh6s6hTh',
  '7s6c5c4h3d',
  'JsJhJdTsTd',
  'TsThTd9s9d',
  'QsQcQd8d7h',
  'AsAdKcKdJd',
  '4h4c4d9h9d',
  'ThTcTdAdKs',
  '8d6s4d3h2s',
  '7s7h7c7dKc',
  'KcQhTd8d5d',
  'AcKs6d5c3c',
  'AcQc6c4c2c',
  'AsAcAdQh6h',
  'AsAhAcAdJd',
  'QhJs8d6c5s',
  '7s6s5s4s3s',
  'KsKh2s2d5c',
  '7c6c5h4d3d',
  '7c6d5d4s3c',
  'QsQhQd7c7d',
  'QdJsTh9s8d',
  '8h7c6d5s4h',
  '9s9h9dJh4c',
  '7s7hJc9c2c',
  'AhKh7h5h2h',
  'KsKcQcJh2h',
  'Th9c8c7d6c',
  'ThTcTdJsJh',
  'AhKhQsTd2d',
  'QhQcAcKc2c',
  'Ts9s8s4s2s',
  'QhJdTh9d8d',
  'AhAcAd2s2d',
  'AcAd6h5h4h',
  '7c6d5d4d3c',
  '7h7dJd9c3c',
  '7h7c7d5h5c',
  '9s9h7h7c6s',
  'As9s5s3s2s',
  'AhAd8c6h4s',
  '6h5s4c3h2h',
  '2s2h2dTh9h',
  'AsQsJs9s2s',
  'AsQs6s4s2s',
  'QcJc5s3c2c',
  'TsThTcTd2c',
  '4s4h4cKd9d',
  '7c7d6c6dJs',
  '7s7c7dQdTd',
  'AdKsQsJsTs',
  'AsKhJdTs5c',
  'KcQhJhTh9s',
  '4s4h4c4dTh',
  'AdKdTd7d2d',
  '2s2h2c2d9c',
  'QdJd7d6d5d',
  '6c5d4h3d2d',
  '4c4d2c2d9c',
  '7s6s5s4s3s',
  'KsQsTs8s3s',
  'JsJd6s6dAh',
  'AhAd3c3dTd',
  'JhJcJd6c6d',
  '6s6cQs7d3d',
  'KhQhJdTd6h',
  '9s9h9c9dAs',
  'JsTs9s8c7c',
  'QsTh7s4d3s',
  'JsJcJdAhKs',
  '8c8dQhJh5c',
  'JsJhJd8c8d',
  'JsJhJcAdKd',
  'KsQs5s4s2s',
  '7s7h7dAsAc',
  'KcJc9c7c4c',
  '2h2dJh5d3s',
  'QcJcTc9c5c',
  'TcTd9s9cAc',
  'KsKd6c4c2c',
  '7d6d5d4s3h',
  '7c6c5c4c3c',
  '8s8c8dAhAc',
  '7c6d5c4s3d',
  'KsQs6h4d2c',
  '2s2h2d9s7s',
  '7s7h7dJh3c',
  'Tc9c8s7c6s',
  'AsTs6s5s3s',
  '7s6s5s4s3s',
  'KhQhJh7h5h',
  '9s9d8s8hJs',
  '3h3c3dAc9s',
  '8h7h6h5h4c',
  'TsThTc6s6d',
  'TsThAsKcJh',
  'AsAhAcQcQd',
  '8s8h8dQhQc',
  '4s4c4d7s7h',
  'AcQc9c6c5c',
  '9s9h4s4hAd',
  'JsJhJd9c7c',
  'QcJsTd6c2c',
  'Tc9c8c7c6c',
  'JsJdAsQs5h',
  'AcKdQs8d7c',
  'KsTs9s8s5s',
  'AsAcAd4s4d',
  'Td7h5h4s3s',
  '7s7h7dKs6s',
  'JdTd8d5d4d',
  '7s7h7cJc4d',
  'AcKh8c7s5c',
  '9d8h7s5d4c',
  '3s3h3d7s2s',
  'AsAhAcKsKd',
  '8h7h6c5d4s',
  'JcJd3s3d6h',
  'KsQsTs7s6s',
  '9s8d7h6h5h',
  'AsJhTh6d3h',
  'AsAhAcAd9h',
  '7c6s5c4c3c',
  '7c6d5d4c3d',
  'JcJd2h2c6d',
  'Td9d8d7d6d',
  'AcKsQdJdTd',
  '7s6d5s4c3c',
  '7s7hQcJc2s',
  'QcQdAs7c6c',
  'JsJhJcJd4d',
  '8s8d7c7dQd',
  'Qd8h7h4c2s',
  '2s2cAsTd7d',
  '8s8h4s4c3s',
  '7s7hQcJc4s',
  '7s7h7c9s9h',
  'KsKhKd3d2c',
  '9h9c9dAdJh',
  'KsQd8c5h2h',
  'QsQh8h8dAd',
  '2h2c2dAh9h',
  'KsKhJc7h4h',
  '7s6s5s4s3s',
  'KsKcAcQs8c',
  'AsQs7c3s2d',
  '9h8h7h6h5h',
  'QsJsTs9s8h',
  '4s4h3c3dTh',
  'AsKsQs5s2s',
  'KcQsJcTc9d',
  'AsKsQs7s2s',
  '7s6s5s4s3s',
  'KsKcTsTd7c',
  'JhJcJdQh3c',
  'AdKd8d7d2d',
  '8s7c6d5h4d',
  '7s7h7cAc2h',
  '7d6h5c4c3h',
  'ThTcTdKs2d',
  '9c8s7d6s5c',
  'AsAhQhQcTs',
  'AdKd9d3d2d',
  'AcKc9c7c5c',
  'TsThTc9h8s',
  'QsQhQcAsAd',
  'JsJhJdQsQd',
  'KhQsJdTc9h',
  'QsJsTs9s8s',
  'ThTcTd8s8h',
  'Td9d8h7d6d',
  'Qs9c8s6s3d',
  'QdJd9d6d2d',
  'AhAd9c9dQc',
  'AsAhAcAdQh',
  'QsQhJcJd6h',
  '6d5c4h3d2d',
  'Jd9c8s6h2s',
  '5s5h2c2dTc',
  'KdQdTd9d5d',
  'AdQd7d5d3d',
  '8h8d2s2dAc',
  '7s6c5h4s3h',
  'Ts9s8s7s6s',
  '2s2hKdQs9h',
  '9s9h9d6h5h',
  'AsAhJcJd5c',
  'TsThTcTd8s',
  'AhAcAd8s8h',
  'KcQcJcTc9c',
  'KsKhKd6s6h',
  'QhJcTh9h8d',
  'JsJhJcJd3d',
  'JsJhJcQcTs',
  '6s6h6dAsKc',
  '3s3h2s2dJd',
  'KhKcJhTh8d',
  '6d5h4h3s2s',
  'QhQd9s9dAc',
  'Th9c8h7h6c',
  'QsQh8s8h7d',
  '8c7c6c5c4c',
  '9h8h6h5h4h',
  '7s7h5s5c9h',
  'AhKhQhJhTc',
  'KsKhKcAsQd',
  'AsAhAcAdKd',
  'AsKdQhJh2h',
  '9s9hAd7h2c',
  'AhKhTh6h3h',
  'AsKsJs8s4s',
  '2s2h2cTd9c',
  '9s8s7d6c5s',
  '4s4dJd7s5s',
  'KsQhJsTc9h',
  'JhJcAhKh6s',
  '9s9h9cAc2h',
  '6s6h5h5dAd',
  '7d6d5d4d3d',
  'QsQhQd5h5c',
  '9c8c7h6s5d',
  'As5s4s3s2s',
  '2h2cQsJhTd',
  'Th9d8h7d6h',
  'Jc9c8c4c2c',
  '7s7h7d9s9d',
  '8s8h8cAd5s',
  '6s5c4h3d2s',
  '6c5c4c3c2c',
  'AhAc8c8dQd',
  'AsAhAdKsKh',
  'QsQcQdJsJh',
  '4s4h4d9h7c',
  'JcJdTsTh3c',
  '6s5s4c3d2s',
  'KdQd5d4d3d',
  'AsAdKsKd6h',
  '9s9c9dQc2h',
  '7s7h7cQsQc',
  'JcJd2s2c4h',
  'AsAhAcJc4c',
  'TsTd4s4h9h',
  'QcJc8c5c3c',
  '2h2c2d8s4c',
  '9c8d7h6c5c',
  'KdJd7d4d2d',
  '8s8d3h3dKd',
  'AhAcAdJdTc',
  'AsAhAd3s3d',
  'JhJdAhKhTc',
  '8s8dAhJd9d',
  'Jd9c6d5s3d',
  'KdQsJhTc9d',
  '4s4h4d7s7h',
  'AhAdKsQh3h',
  '6h6c6d4s4c',
  '2s2h2dAhKs',
  '6s6c6dKsKd',
  'AhKh7h5s3h',
  'QsQhQd9h9c',
  '7h7c7dQcTc',
  '5s5hJsTc7d',
  'KsKhKcKdAc',
  '6s6h6cAh7s',
  'ThTcTdKsKh',
  'AsJs7s4s2s',
  'QdJd8d6d2d',
  'Ah9h6h5h2h',
  'AhAc8h8d2d',
  '9c9dAd7d2d',
  'AsKs9s7s5s',
  '7c6h5d4c3s',
  '2s2c2dKsJc',
  '4s4h4cQs2h',
  'AsAhAcAdKh',
  'AsAdQhTd4c',
  '7d6c5c4c3d',
  'QhQcQdKcKd',
  '4s4h4c4d2d',
  '6s6h6c6dQd',
  '5s5h5dAcAd',
  '5h5c9c3d2c',
  'AhAcAdKhTc',
  '2s2h2c2dJs',
  'QdJd7d6d3d',
  'JsTs9s8s7s',
  'JsJhJcJd6h',
  'JhJd8c8d3c',
  'QsJdTc9h8s',
  'QcJcTs9c8d',
  'AsKd9s8d6h',
  'Ah9h8h7h3h',
  'AsAhAcAd4s',
  '7s7h7d8s8h',
  'AsAhJsJh2d',
  '6s6d5d4d2s',
  '4h4c4d3c3d',
  'AhAd3c3dKh',
  '9s9h9dJsJh',
  'AsKs7s6s5s',
  'JsJhJcJdKd',
  'AsAhAd4c4d',
  '5s5h5c9s9c',
  '5h5c5d8d2c',
  'AsAhTcTd7d',
  '7h7d4s4dQc',
  '6s6h8s7d4d',
  'QhQcQd7s6d',
  'AsJs9s7s6s',
  '8h7h6s5c4c',
  '8d7d6s5c4d',
  '4s4h4cKd7d',
  'KsKhKcKd3s',
  '5s5h5cAs9d',
  'AcAd8h8cJc',
  '3s3c3dQsQh',
  'Jh9s8s7h2c',
  'KhKcKdTc4h',
  'JsTs9s7s4s',
  '8c8d2h2d6h',
  'JsTd8s5d3c',
  '3h3cAcKc6c',
  'AsKs9s7s4s',
  'Ac9c8c6c5c',
  'TsThTc9c9d',
  'As5s4s3s2s',
  'QcJhTh9s8s',
  '7d6d5d4d3d',
  'JsJdQhTs3h',
  'Ad5d4d3d2d',
  'AcKhQsJsTs',
  'JsJhJcJdKd',
  'Ac5d4d3s2c',
  '6s6c6d2c2d',
  'AsAhAd4s4d',
  'AhAcAdKdQc',
  'QsQd3c3dKh',
  'JsJd7s7h6s',
  'QhQd5s5cJc',
  'AsKhJc8d3c',
  'QsJsTs9s8s',
  'Ad5d4d3d2d',
  '9s6s5s3s2s',
  'AsKsQsTs2s',
  'KsKhKcTh6s',
  'JhTd9h8d7s',
  '6s5h4c3c2s',
  'QcJhTc9s8c',
  'AsAdKsTc8c',
  '9s9h9cThTc',
  '5s5h5dTcTd',
  'AsKs9s7s3s',
  'AsAhJhJcTs',
  'JsJhJcJdAd',
  '8h8cJc6s4s',
  'AdKcQsJcTc',
  'AhKcQcJsTc',
  '6d5h4c3d2d',
  'AhAdKsKhTd',
  '6c5h4s3c2h',
  '5s5hQhJd9s',
  '2s2h2c2dJc',
  '6s6h6c6dAd',
  'AdTd9d7d6d',
  'QsQhAsJd7s',
  'QsQhQdTh8c',
  'AsAhAcJcJd',
  'JsJhJcJdTc',
  'As8s5s4s2s',
  'QsJhTc5c4h',
  '9c8d7c6d5h',
  'Th9h8h7h6h',
  'AsAhAd9s7d',
  'KsKhTd6h3h',
  'JsJhJdKd2d',
  '9s8s7s5s4s',
  'JsJd2s2h8s',
  'AsAcAdKsQh',
  '8h8c8dJsJh',
  '6h6c6dAc9s',
  'KsKhKc2h2d',
  '8s8h8dAdQs',
  'AcAdKs7s5h',
  'JhTc9s8d7s',
  'KhQhJhTh4h',
  'Ac9d8c7s5h',
  '9s9hTh5h4h',
  'KsKdAd8s3s',
  'JdTd9d8d7d',
  'QhJcTd9h8c',
  '7s7dKdQd8h',
  'Ts9s8d7c6c',
  'AhKhQhJhTh',
  '7s7h7cJs4d',
  'QhQcQdJh4d',
  '8s8h8c7s7h',
  '6d5h4c3s2h',
  'KsKh9s9h3s',
  '9s9h9d2c2d',
  'KdQcJsTc9s',
  'QsJsTs9s6s',
  '9s9h9c9d6d',
  'KhTc7d5h3h',
  'Ad9s8h6c2s',
  '6s6h6cJsJd',
  'QsQhQdJsJd',
  '8d7h6d5s4s',
  'JcTs9c8d7c',
  '2s2h2dQcQd',
  '6d5d4d3d2d',
  '3s3h3c3dQs',
  'AdKs6h5h2c',
  'JsTs9s5s3s',
  '8h8cQdJc7c',
  'ThTcTdAc6c',
  'AdKdJdTd6d',
  'As7d6c5d4c',
  '9d8d7d6h5h',
  'AhKh9h7h4h',
  'AsAdQdJs9c',
  '2h2c2dAhKd',
  'JcJdAs5h4c',
  'QdTd9c7c5h',
  '8s7s6s5s4s',
  '2s2c2d8s8h',
  'AsAhAcAdQc',
  'AcKd9h5s2c',
  'Jc5c4d3h2h',
  '4h4c4d7s7h',
  'AsAhAdKcKd',
  'QsJsTs4s3s',
  'Jd9d7d5d3d',
  'Ad9d8d7d5d',
  'JdTd8d7d4d',
  'JcJdTcTd9h',
  'AsAhAcTc6s',
  '9s9h6c6d4h',
  '7s6c5h4c3d',
  'QsJcTh9c8c',
  'JsJdTh6h4d',
  'QdJdTd9d8d',
  'JhJcJd7s2d',
  '8s8h8c8d9h',
  'AhAcAd2c2d',
  'QsQhAh6c2h',
  '8d7d6d5d4d',
  'JhJcJdAhKs',
  '2c2dKs7c5c',
  'Ac9c8c3c2c',
  '6s6h6c6d4s',
  '8s8h8d3h3c',
  'QsJcTs9d8d',
  '9s9h9c9dTc',
  '8h8cTh6c3c',
  '2h2c2d7h7d',
  'AsAc9c9dKh',
  'JsJcJdAcAd',
  'AdKhQd9h7h',
  'QhQc7h7d5s',
  'QsQcQd8s6h',
  '9h9c9d6c6d',
  'QsQhQc4h4d',
  'QsQh6c6d7h',
  'QsQhQcKhJd',
  'AsAd6h6cQh',
  'QsQhAs8c6d',
  'TsTcTd6s6d',
  '8h8c8dAhAc',
  '8d7d6d5d4d',
  'AcAdKsKh2h',
  'QcJc7c6c3c',
  '7h7cKdJh4d',
  'TcTdAs9s3s',
  '9s9h9c9dAh',
  '4s4hAd7d3d',
  'TcTd9s9dQc',
  'JsJhJcTc6s',
  '6s6h4s4dJd',
  '5s5h5c5d8h',
  'QdJd9d6d5d',
  'KhKdQd6d3c',
  'AhAcAd5s5h',
  'AsKd9s5d4s',
  'AsAhAcAd9c',
  'JhJdTsTd6s',
  'AsJhTc9d6s',
  'AsQs7s6s3s',
  'TsTd7s6h2s',
  '2h2dJcTh6h',
  'Tc9c8c7c6c',
  '6c5d4s3c2h',
  'AsAhAc9s9d',
  '4s4hAsKd8h',
  'Td9d8d7d6d',
  '8d7h6c5s4h',
  '8h8c8dKsKh',
  'AsJs7s6s3s',
  'AhAc6s6hJh',
  '8d7s6c5s4c',
  'TsThTcTd9d',
  'JhJcAc8s5s',
  'AcKcQhJs4d',
  'TsThTcAs6d',
  'TsThTcTd4d',
  'AdKd9d5d3d',
  'AsAhAcAdTc',
  '8s8h8c5s5h',
  'AdJd8d7d6d',
  'TsThTcJs7c',
  '8c8dAdKhQs',
  'As5d4s3s2s',
  '4s4h4dAh6h',
  'KhKd5c5d8c',
  'JsJhTsTd8d',
  '9c9dAhKd8s',
  'QsJs7s5s3s',
  'AhKcQcJhTh',
  'AdTd7d5d2d',
  'KcJs8s5c2c',
  'TsThTdQcQd',
  'AcJh9c4d3c',
  '5s5d3h3c7s',
  'JsTs9d8s7s',
  '4s4h4cAh5s',
  '8s8c8dKcJs',
  'QcJc9c6c5c',
  'QdJcTd9s8h',
  'QsQhQc5c5d',
  'AcAd2c2d3h',
  'KsKhKcKd8c',
  'AcAd9s9d4h',
  '3s3h3d4s4h',
  '9s9h9c6d2h',
  'AcKcQsJsTs',
  'KhKcKd6s6h',
  'QcQdTs7c5d',
  'AsAd8c8dTc',
  'AsKsQsJsTs',
  '7s6s5s4s3s',
  'AsTs7s5s4s',
  '6c6dQc9d7c',
  '3s3h3c3dKs',
  'QcJc9c4c2c',
  'AcAd8c8d4h',
  'Ah5h4d3d2d',
  '4s4h4c4d7d',
  '8h8c8dQh5s',
  '9s9h9dJd6h',
  'Ac5h4c3d2s',
  '8c8dAsKh2h',
  '9s9c8c8dTs',
  'KhKcAh6h4d',
  'AsKsJs6s3s',
  '6s5c4d3h2c',
  '4s4h4c4d7c',
  '9d8d7d6d5d',
  '3s3h3c3d5s',
  '4c4dJh7s3d',
  '9c9d7s7h3s',
  '4s4h4cTsTc',
  'JsJhJc9s3d',
  'JsJhJc4s4h',
  'QhJdTd9c8s',
  'AcKsJd9h8c',
  '9s9h9c9dAh',
  '9s8c7c6s5s',
  'AsAhKcKdJd',
  'QsQhQcJdTh',
  'Ts8s7s5s3s',
  'Ac5c4d3c2s',
  '2s2h2c2dAs',
  'TsThTcQsQd',
  '9d8d7d5d4d',
  'QdJdTd9d3d',
  '9d8d7d3d2d',
  'As5c4s3c2c',
  'Qh9h7h5h3h',
  'QhQc3c3dKs',
  '8s8h8d6s6d',
  'AsKh7h6h2s',
  '9c8d7h6c5h',
  '3s3h3c3dTh',
  'AsAh7h7cKd',
  'QhQc7h6s2d',
  'TsThTcQsQd',
  'AdKd9d5d3d',
  'AhKhQhJhTh',
  'JhJcJdAh9d',
  '8s8h8c8dQh',
  'AdJd9d6d4d',
  'AhAcKsKhQs',
  '3s3h3c3d8s',
  '4s4hKh6d5d',
  '8d7h6s5h4s',
  'KsTs9s8s4s',
  'KdQdJdTd9d',
  'AsAhAcTd7s',
  '3h3c3d9c7d',
  'JsTd9h8h7s',
  'JsJhJcJdQc',
  'Ts9c8c7s6s',
  'KsKhKcKd6c',
  'KdTd9d7d3d',
  'QdJdTc9h8c',
  'AsAhAcAdQc',
  'KhKcKdAdQh',
  'QsQhQcQd5s',
  'ThTcTdAc3c',
  'JcTh8h7s4h',
  'JsJcJd8c8d',
  '7h7cKhJd8d',
  '6h6c6dAs7c',
  'AsAh5c5dQd',
  'AsQsJsTs3s',
  '8h8c8dAs2d',
  'JhJcJdQs7c',
  '7c7dTd6s5d',
  'TcTd2s2h7s',
  'JsJhJd2s2d',
  'As5c4h3c2d',
  'AsAhJsJh6d',
  '4c4d3c3dTh',
  'KcKd7c7d6s',
  '7s7h7dAhAc',
  'AsKsQsJs2s',
  '7d6d5d4d3d',
  'AhAcAd3h3c',
  'AsAdKsKhQs',
  '9s9hQh7d4d',
  'QdJd7d5d4d',
  'JhTc9s8d7h',
  'AdQd9d8d6d',
  '9h9c9dJhJd',
  '7h7dAhKc8c',
  'QsQhQc8c7d',
  '7h7c7dJc4h',
  'Ac5s4h3d2d',
  'Ts9c8h7c6s',
  '6s6h6c6d3c',
  'KsKdQsQh2c',
  '5s5h5c5dAc',
  'KcQc8d3h2s',
  'AsKs6s4s2s',
  'AhAdQdJh7d',
  'KsKhKcKdQd',
  'KsKhKd7d6d',
  'Tc9s8d7d6d',
  '8h8c8dQhQd',
  'KhKdJsJdTs',
  'AhAcAdTsTh',
  '8s8h8dJsJh',
  'AsAhAcAd8d',
  '5s5dAdKh3d',
  '7h7cAh9h6h',
  '2h2cAc8d7c',
  'KsQsJsTs9s',
  'AhAcAdKsTs',
  '9h9c9dJd6c',
  'AdKdQdJdTd',
  'AsAcAd5s5h',
  '5h5c5d7h4d',
  'AsAdKs8d5d',
  '7h7c3s3hAd',
  'AsAdQdTc7h',
  'Tc9c8c7c6c',
  'KsKhQd4h3h',
  'QhQcQdAs7h',
  '7s7h7d6d5c',
  '7d6c5h4c3d',
  '3s3h3c3d7d',
  '8h8c8dAcAd',
  '5s5h5cTsTc',
  'ThTcTd9d5c',
  'JcTd9c8d7s',
  '9s9cAdKh8d',
  'KcQsJdTc4s',
  'AcKdQhJcTd',
  'AsAhAcAd4d',
  'KhKcKd9c9d',
  '6s6c6dAsAh',
  '2h2c2dAs3d',
  'QsQhQcJsJh',
  'AsAd2s2d8c',
  '8s8h8dTh6d',
  'JhJcJd6s6d',
  'ThTcTdAcAd',
  'QhQd7s7hJd',
  '9s9hAdKh7c',
  'AsAhAdKs6s',
  'JdTd9h8s7s',
  'Ad5d4d3d2d',
  '9c8c7c6c5c',
  'AdKsQsTs3h',
  'QsTd9d6s4h',
  'JsJd4s4c2s',
  '2h2c2dAh4c',
  'QsQh2s2c3s',
  '2h2c2dQh4s',
  'QhQcQdKh6s',
  '2s2c2dAcTd',
  'KcQcTc8c7c',
  'KhKcKd3c3d',
  'AhAc9s9hKc',
  '8s8c8dKdTd',
  'AdKc9d8c6c',
  '4s4h4c4dAd',
  'QhJsTd9s8c',
  'Qs9s7s4s2s',
  '9d8d7d6c5d',
  '8d7c6c5c4s',
  'JhJdTsTh3d',
  'TcTd9d7c3d',
  '3h3c3dAhQh',
  'AsKsQsTs3s',
  'AdKdTd8d6d',
  'AsAhAcKsKd',
  '7d6d5d4d3d',
  'QsQhQdKs2c',
  'KhKcKd7c7d',
  'AhAcAdKd3h',
  'KdQdJdTd9d',
  '3s3cQsJd4h',
  'KcQhJhTc9s',
  'AsAhAc9s9h',
  'JhJcJdThTc',
  'TsThTd8c8d',
  'AsAdKcKd9h',
  'AsKsTc7d5d',
  'AsAhQcTh4d',
  '8h8d6s6h5d',
  'AhKhJh7h2h',
  '9s8s7d6h5s',
  '9s8d7c6s5c',
  'TsThTc5h3h',
  'KsQsJs7s5s',
  'JsJhJc8c8d',
  '8s8h8c8dJs',
  'Th9c8s7s6c',
  'Ah9s8h7d5h',
  '7s7c7d3s3c',
  'QsJhTh9h8d',
  '9h9c9dAh6c',
  'KhJc9c8c6c',
  '7h7c7dJhJc',
  'JhJdTd9h8h',
  'QhJhTd9c8c',
  '9s9h9c9dTc',
  '5s5c5dQhQd',
  'QhQcTc3d2h',
  'AdKdTd6d3d',
  'TsTd9s9d7h',
  'QsQhQcQd9h',
  'KsKhJdTd5c',
  'AsAhAcAdKs',
  'AcJc8s4c3d',
  '9s9d3s3dQs',
  'JcJdTcTd6d',
  'JhJcJdQs5d',
  '9s9h9cQsJc',
  'Ts9s8s7s6s',
  'AsAcAdTsTd',
  'JdTd9c7h3c',
  'JcTc9s8h7h',
  'QsQhQdKsKc',
  'JhJcJd8d3c',
  '6h5c4d3d2c',
  'AdKdQd8d5d',
  'Ts9s8h7d6c',
  '5s5h5c5d9d',
  'QsQhQcKsKd',
  '4s4h4c7h7c',
  '3s3c3dKsKd',
  '8c7c6c5c4c',
  'AsAhAd9h9d',
  'QsQhQdTsTh',
  'Kc8c5d3d2c',
  '8s8dJc9s7d',
  'QsQhQcQdJd',
  'JsJhJcJd4d',
  '8c7h6s5s4h',
  'AhKhJh8h4h',
  'QsQhQd9h9c',
  '9s9hKs7s6d',
  'Ac5d4c3d2h',
  'JsJhJcJdQc',
  'AsAhAc2s2h',
  'JsJhJcJdAs',
  'KhKc7s7h6c',
  'AcKdJs9c3c',
  '7s6s5s4s3s',
  '5h5c5dJc9s',
  'Ks6d4d3s2d',
  '3s3h3dAh6s',
  'JdTs9s8h7d',
  '7s7dTs8d2d',
  '7s7h7c7dQc',
  'KsKhKcKd5s',
  'KcKdJcJd8c',
  'KsQsJs7s2s',
  'AsAhAcJsTc',
  '4h4c4dJsJh',
  'TsThTc4s4h',
  '2h2c2dAs5h',
  '2s2h2c2dKs',
  '6h6c6dJd9c',
  'KhKd2s2d6d',
  'AhAc7s7c8c',
  'KcQcJcTc9c',
  '6h5h4h3c2c',
  'AhAc8d7s6d',
  'JhJcJdKc2h',
  'KsKd9h7s4d',
  'AsAh8s8h6s',
  '7c7dKcTd6d',
  'KcQcJcTc9c',
  '4h4d2s2d7s',
  'AhAcKsKc8c',
  'KsKhKdJhJc',
  '3s3h3dQc8c',
  'QhJdTc9c8d',
  'KsJs9s7s2s',
  'QsJh8h7c3h',
  'AcKcQhJdTd',
  'AsAhAdKhKc',
  'KdQd7h6c4s',
  'KcKdAdQd6h',
  'Tc9h8d7c6s',
  'TcTdKdQh9d',
  '7h7cJdTc9h',
  'QsQhQcQd6s',
  '6s6h6dQh2c',
  '8s8h8dKh4d',
  '8s8h8c8d2c',
  '8c8d2s2d7h',
  'AhAcKhKcQc',
  'TcTd4s4c6c',
  'KdQdJdTd9d',
  '7s6d5h4s3c',
  'Ad7d6d5d3d',
  'AdKdQdJdTd',
  '4s4h4c4dQs',
  '2h2c2dJs9h',
  '4s4h4dKs2s',
  '3s3h3cAsKd',
  'Qs8s6s4s2c',
  '3s3h3d5h4c',
  '9s9h4s4dAc',
  'AsAhAcAdKs',
  '9s9h9c9d4d',
  'Js8s7s6s2s',
  '6c6dTc9s2d',
  '7h7c7d5h5c',
  '7c6c5c4s3c',
  '9s9h9dAhQs',
  'AsAd7s4h2h',
  '8s8h8dAs2d',
  'Kd9d7d5d2d',
  '3s3h3dKsKd',
  'JhJcJd5c2h',
  '9s9hQcJsTc',
  'TsTc9s9hAh',
  '7h7c7dJcJd',
  '9h8d7c6s5s',
  'QsQhQcJh6s',
  '9d8c7s6s5s',
  'QsQhQdJh9c',
  'JsTs8h6c2s',
  '8s8h8cTsTh',
  '6s6h6c6dAc',
  'QhJsTh9h8s',
  'AdKdQd9d3d',
  'JhJc7h7d5d',
  'JcTd9d6s4s',
  'QsQhQcQdJd',
  'KsQs9h7c2h',
  '8s8c2c2dQd',
  '8s8h8cAc4d',
  'QdJd6s5h2d',
  'KsKhKcKdTh',
  'TsThTc4s4h',
  'ThTcTd8c8d',
  'AsAcAd8c5s',
  '7s7h7c6c6d',
  '8s8dJs9d6h',
  '9s9h9d5h4s',
  '4c4dAdKs6d',
  '6s6h6c6d5s',
  'KsQs9s3s2s',
  '3h3c2s2hAs',
  '4s4h4c4d9h',
  'KdQd9d7d2d',
  'As5h4c3c2h',
  'AsTs8s7s4s',
  'AhAcAdKsKh',
  'AsTc9c7d6d',
  'KcQsJsTd9s',
  'KhJcTc7h5s',
  'QhQdJcTs8d',
  'JsTs9s8s7s',
  'AcJs9s4d2d',
  'KsKhJsTd5d',
  '9s9c8c8d7h',
  'QsJdTc9h8s',
  '9s7s6h5h4d',
  'Td8d6d5d2d',
  'AsKsQs8s5s',
  'KcQdJhTh9d',
  '8h8c8dJsJd',
  'AhKh7h4h3h',
  '9c9d8h8d7s',
  'AsAdKc5c4d',
  'AsAhAdQcJd',
  'KcQc8c5c3c',
  '7s7cKs6d5d',
  '6s5h4c3c2s',
  '7c7dQs8c3s',
  '9s9h9dQd3d',
  'AdKcQcTh8s',
  'KsKhKc9h4h',
  'QdJdTd9d5d',
  'QsTs6s4s2s',
  'AsAd7d6d3s',
  'AsAhAcJh5c',
  '7s7h7dJhJc',
  'JsJhJdAs3h',
  'AcJc9c5c2c',
  'Jd8d7d3d2d',
  'KsKcJsJhAs',
  'AdQd8d6d4d',
  '9s9h9c9dJs',
  'AsAdJs9c3c',
  'Ah9h7h4h3h',
  '7s7c7dQsQh',
  'KdQsJdTc9c',
  'KsKh9s8h7h',
  '4h4c4dAsAh',
  'KcKd8h6h5d',
  'QsQh6c6dAh',
  'QdJd8d5d4d',
  'TsThTcTd9c',
  'AsAhAcJcTh',
  'Ad5h4c3c2h',
  '3s3h3c9h9d',
  '7h6c5s4d3d',
  'JsJd8s8dQh',
  'AcQc9c3c2c',
  'AdKdQd9d5d',
  '2s2h2dAhKc',
  'KdJh5s3h2s',
  'AsAhAc5h5d',
  '7s7h7c6s6d',
  'AdKdQcJdTh',
  'AdKd9d6d2d',
  'Ts9s8h7c6d',
  'AhKhQh7h2h',
  'JsJhJc8s3d',
  '8s8h8cKs5c',
  '8s7d6h5h4h',
  'KdQhJsTh9d',
  '7s7h7c7d4c',
  'AdQsTd9s4c',
  '5s5h5c4s4h',
  'KhJsTc9s5s',
  'QsJsTs9s8s',
  '6s6h6c6d9h',
  'AcKcTc9c5c',
  '5s5dKsQd7s',
  '6s5s4s3s2s',
  'Tc9c5c3c2c',
  '8s7d6s5c4h',
  '8h8d7s7dJh',
  '8s8h8c2s2d',
  '9s9hJd6h4d',
  'AdKdQdTc3c',
  'TsThTcTd9c',
  'QdJdTc9d8s',
  'KcQcJc9c5c',
  'QsQhQcQdTd',
  'AhAcAdQs3c',
  'AdQsJh8d6s',
  'Js9h6d5h4c',
  '7c7dAcKs4c',
  'QdJhTh9h8s',
  'JsJcJdAd8h',
  '5s5h5c8d4h',
  '6s6hAcTs8s',
  '9c9dAc7h2c',
  'JsJd8s8d3c',
  'AhTh9h7h5h',
  '9s8s7s6s5s',
  '4s4h4c4d7c',
  'JsTs9d7s6h',
  'AsAhAcKsKh',
  'AsAhTsThKc',
  '7h6h5h4c3c',
  '5s5d4s4h8h',
  'AcKsTh7h6s',
  'AcAdQh8d6d',
  '6h6c6d7s7h',
  'QhQc4c4d2h',
  'AsKs9c6h3c',
  'AcKsJc8c4h',
  'AdJcTs9h6s',
  'TsThTcTd6h',
  'AsTs8s5s2s',
  'Ts8s7s5s4s',
  'AsAhKhQd6s',
  'Ac8c6h5c3s',
  '7s7h7cTd2s',
  '7s7h7dJh6d',
  'JhTh9h8c7h',
  '7s6s5s4s3s',
  '8h8dAs9s2h',
  '7h7c7dKsQd',
  '7s7dKd3d2d',
  '7s7h7cKd5c',
  'KhQdJsTh9d',
  'AsAh3c3d6d',
  'AhAcJdTs8s',
  '4s4h4c4dTs',
  'AhAc2s2h5c',
  '7h6h5h4h3h',
  '8c7c6c5c4c',
  'JcJdAc9d3c',
  '5s5h5c8h3s',
  'AhAcAdJc7d',
  '2s2h2d9c9d',
  'Ah8c7d6d4c',
  '4h4c4d7d6c',
  '8s8h8dJcJd',
  '9s9h9cAcAd',
  'TsThTcTd2s',
  'As5d4c3h2d',
  'JsTs9s8s7s',
  'AcQdJh8d6s',
  'AsAhAcKd6c',
  'JsTc9h8s5c',
  'JsJh2c2d6h',
  'QhQdJhJcAs',
  'AsAhAcAdKd',
  '8d7s6s5h4c',
  'AdKdTd6d2d',
  'TsThKsQs9s',
  'AsAdTs8s6h',
  'KsKh3h3c7s',
  '5c5d3s3hKd',
  'KsKhJcJd5h',
  'AcAd7s7cKc',
  'Qd9d4d3d2d',
  '9c9d3c3dTd',
  '5s5dAhJh3s',
  'JhJcJdAsAh',
  '7c6h5d4s3s',
  'TsThTcTd7s',
  '6h5h4h3h2h',
  'AsAcAd2h2d',
  'AsAc6c6dKd',
  'JsJcJdKcTd',
  'QsQhTs6s3c',
  'AsQsTs9s6s',
  'KdQd9d7d2d',
  '8s8h8c8d4s',
  'JsJhJdQhQc',
  'KdQdJdTd9d',
  '9c9d8s8dKs',
  'QsJs7s6s4s',
  '9c8s7c6d5s',
  'AsKsQsJsTs',
  'KdQdJdTh9h',
  'QsJsTh9d8d',
  'AsTs9s8s2s',
  'As5d4c3c2c',
  'ThTcJd9s2s',
  'JdTc9s8s7c',
  '6s6cAd8h7s',
  'As5s4h3h2d',
  'Td9h8c7s3c',
  'JhJc3c3dAh',
  '2s2h2c2d8d',
  'AcKcJd7d4h',
  'JhJcJdKhQd',
  '6s6h6c8s8h',
  'KdJhTc6s3d',
  'QhQcJcJd9c',
  'KsKhKc7s7h',
  '5h5c5dAcQh',
  'AsAh2c2d6s',
  'AsAd8h8dQc',
  '8h8d5c5d6c',
  'QcJdTs9h8c',
  '4h4c4d2h2c',
  'QsTs8s7s5s',
  '7s7h7d9s9h',
  'TsThTcAcAd',
  '8s8h8c8d2d',
  'AhTs7c6h3d',
  'AsAd5c5d9d',
  'AhJc8c7s3c',
  'AcAdKhQc4c',
  'AhAc4c3h2c',
  'Jd9d8h7c2d',
  'Qh9h8h7h5h',
  'Ah9h5h4h3h',
  'JsTd8h5c2s',
  'Tc9d8s7h6c',
  'QsQhQcAhKs',
  '8s8h8c2s2h',
  'AcKc9h6c3h',
  'AcJcTs5d2d',
  'Th9s8c7s6h',
  'QsQcQd2h2c',
  '6s6h6c6d4s',
  '8s8dAcKh7d',
  '3h3dKhJd7s',
  'AsAhKsKd6s',
  '6h6d5s5cTc',
  '9h8c7d6d5d',
  'KsKh4s4h2d',
  'QsQhQcQdJs',
  '7s7h9d8s6h',
  'JdTh9s8h7h',
  'AhAdKs6d5s',
  'KcQc7c6c3c',
  '7h7c7dQs8s',
  '6s6h6d9h3c',
  'TcTd2c2d9s',
  'AsAhQcJd9d',
  '6d5h4c3d2d',
  '3s3h3dQcQd',
  'QsQcJhJd6c',
  'KsKh7s7d3c',
  'AdTd7d5d2d',
  '9s9h9c9d7c',
  'Kd9d6d5d3d',
  'Th9s8d7c6d',
  'AsKsTs9s7s',
  '6c5c4c3d2c',
  'QsQhQd7s7h',
  'QsQd9s9hAd',
  '9d8d7d6d5d',
  'AsKcQc7s6h',
  '6s6h6cTc9h',
  '9s9h9c7s6c',
  '8h7h6s5h4d',
  'JsJd5s5dQh',
  '9s9h9cAdKs',
  '7s7h7c5h5c',
  '6s5c4s3c2d',
  '9h9c9dTsTh',
  'KhKcKd2h2c',
  'AhKhQhJhTh',
  'JcJdAh8h4s',
  'As9s6s5s2s',
  '6s6h6cKcKd',
  'QsQh8d7c2h',
  'QcQdJhJc9d',
  '6s6d5h5d3c',
  'KcQcJcTc9c',
  'JsJhJcQhQc',
  'Td9d8d7d6d',
  '5s5h5c5d3c',
  'AsAhKsKhQc',
  'KhQhJhTh9h',
  '3s3h3cQsQh',
  'Ac5c4c3c2c',
  'AsAcAd8h2s',
  '9s9h9c6h6c',
  'AsAhAc7s7h',
  'KcQcJcTc7c',
  '8c7d6c5s4d',
  'Ad5d4s3h2c',
  '7c6c5c4c3c',
  'AcKcQcJc9c',
  'Tc9c8d7d6h',
  'KsJsTs8s6s',
  'QhJcTd9d8h',
  'JcTs9h8h7c',
  '6s6hAhKc8h',
  'Ts9s8s5s4s',
  'AsKsJh9h2c',
  '4s4h4d8s3s',
  '7s7h7c7dAd',
  '8c8d4c4d7c',
  'Th9c8c7h6s',
  'QsQhQd6h6c',
  'KsQsJcTc9h',
  'QhJs9d8h6h',
  '8s8h8c8dAs',
  'AsAhJdTs4s',
  'JsJd3s3d5h',
  'QsQhKs9h8s',
  'KcQcJcTc9c',
  'QsQhQcAd9c',
  '2s2c2dAcKd',
  '9h9d6c4c2c',
  '4s4c2s2h8s',
  'AsKs7s5s2s',
  'KhQsJsTh9s',
  'JsJhJcJdAh',
  '7c6c5c4c3c',
  'KhQhJhTh2h',
  'TsThTcQsJd',
  'JsJd2s2dKh',
  '7s7dTs4c2s',
  'AhAcKd6s2d',
  'QcQdKh8s6d',
  '2s2h2c2dKd',
  '7h7dAsKhQd',
  'TsTd2s2c9h',
  'Td8d7h5d4h',
  'Ts9d8c7s6s',
  'KsJsTs9s7s',
  'AhAcJsJh9c',
  'JhTh9h8h7h',
  'AsAhAdTs9d',
  'AdTd9d6d5d',
  '7s7h7dAc6d',
  '8s8c8d7h5c',
  '7s6s5s4s3s',
  'AdKdQd6d3d',
  'Th9c8d7c6h',
  'QsJdTc9s8d',
  '4s4h4c4d3s',
  'AsAhAc3s3h',
  '5s5c5dJh9s',
  'Th9s8d7s6c',
  '5h5c5dQs2h',
  'QdJdTd9d8d',
  'AcKcQc6c5c',
  'QcQd4c4dKd',
  'KhJh9c5d3c',
  'AhJc7c4d3s',
  'AsAhAcAdQh',
  'Ac5c4d3h2c',
  '7s7h7c7d8c',
  '4h4c4dQsQd',
  'AsAc7h7cKc',
  'JsJhAh8h2h',
  'AsAhAcAd6c',
  'AcKcJc9c5c',
  'AdKdQdJdTd',
  '4h4c4dAhKc',
  'AcKcQc6c3c',
  '4s4c4dTc6c',
  'TsThTcQsQd',
  'AsAhAcQcQd',
  'As5s4s3s2s',
  'Th9h7h4h3h',
  'QsJsTc9d8d',
  'QdJd9d5d4c',
  'QdJd7c5d2s',
  'KsQsJsTs9s',
  'QsJdTs9d8d',
  '8s8d7d6s2s',
  '7h7c7d8c8d',
  '3h3dKd9h7c',
  'Qh9s6s5d2c',
  '2c2dTh7s6h',
  'JhJcJdAhAc',
  '4s4h4c4dJd',
  '4s4h4c4dKd',
  'Ts9s8d7h6c',
  '8s8c8dAhTs',
  '8h7h6h5h3h',
  'AsAhAcAdKd',
  'KsKcAd8h4d',
  '8s7h6s5c4h',
  'KdQcJd9s7d',
  'KsKc9d6c5c',
  '6s6h6c5s5d',
  '8s8h8d7c4s',
  'QsQhQcAd3h',
  '9h9c8c8d5h',
  'QhTc7d6h3h',
  'AhAcAd6d2h',
  '9d8c7d6c5s',
  'AcKhTd5h2d',
  'KcKdQhTh8d',
  'AhJhTs6s4h',
  'KcQd9c6c4s',
  '6h5h4s3h2s',
  'AsAhAcKd5c',
  'JcJd6c6d9d',
  'KcKd8s8hAc',
  'ThTcTd5h5c',
  'KhQhJh4h2h',
  'KhQhJhTh9h',
  'AsAhAcAdJc',
  'AdKsQc8c7c',
  'QcJhTs9s8h',
  '8h7h6h5c4h',
  'QsQhJdTc2s',
  '8s8h8c8dJs',
  '3s3h3c3d8s',
  'AcKcQc8c6c',
  'AsKc7d6s5d',
  'QhQcQdAdKs',
  'Jh8h5h3h2h',
  '4s4h4d2h2d',
  'KsKhKcKd2h',
  '9s9h9c8c8d',
  '7s7h7cKd5s',
  'AhAdKsKh7c',
  '6s5s4s3s2s',
  'AhAcAdQsJc',
  '2s2d9c7d3c',
  '8s7d6d5h4s',
  'TsTc2c2d7c',
  'AsKh9h5d4c',
  'Jc8c5c4c3c',
  'KsKcKdAsAh',
  'QsQhQc9h8c',
  'Ts9s8s7s6s',
  '7h7dAcTc6c',
  '2s2h2d9c9d',
  '7d6h5c4d3d',
  'KsQsJs7s6s',
  'AsKcJc9h6s',
  'As8s7s6s3s',
  '7s7h7dTsTh',
  'AsAhAcAd7c',
  '5h5c2c2dAs',
  '9h9c9d3c3d',
  '4s4h4cTs5s',
  'QcJhTs9d8d',
  '9h9c9dQhQd',
  '6s6h6c8h8c',
  'AhKd7s5c3s',
  'KdQdJdTd9d',
  'KsKc7c7d4c',
  'JsJcJdTc2c',
  'ThTcTdQcQd',
  'AsAhJsJhKh',
  '7s7dQdTh3c',
  '9s9c9dQcQd',
  '5c5dQcJs3s',
  'QsQhQcAh4d',
  'Th9c8h7d6h',
  'AcKcJc5c2c',
  '8s8c8d7s7d',
  '6h6cKhQc5s',
  'Ah9c8s4h2h',
  '5s5c5d7s7d',
  'AdKdJd7d2d',
  'AsKsJdTh5d',
  'QsQhJhTc7c',
  '9c8c7s6h5c',
  '3s3dQsJh4d',
  'JsJhJcAhKc',
  '2s2h2c2dTh',
  'AdKdQd4d3d',
  '9s8h7h6h5s',
  'AsAhAd9s9d',
  'JdTd9d8d7d',
  'AsAhAcKc3s',
  '9s9h9dAdKs',
  'QsJsTs9s7s',
  'Ad5c4c3c2d',
  'Ts9s8s6s4s',
  'QsJsTs9s8s',
  'AsKsTs9s3s',
  'Ad5d4d3c2s',
  'TsThTdAhAc',
  '9h9c9dKs3h',
  '6h6c6dAhQh',
  'Ac5c4c3c2c',
  'AhAdJsJd7s',
  'QsQhQc4s4h',
  'ThTcTdQsJc',
  'KcQcTc6c2c',
  'Ad8s7s4h2d',
  '2h2c2dQc9h',
  '5s5h5c5d4d',
  'AhAcAdTs8c',
  '8s8h8cQsQc',
  '5s5h5c5dAd',
  'AsKd7c5s2s',
  'AsAhAcAdKd',
  'AcAdKcQsJd',
  '9s9h9c9dQs',
  '4s4h4c6s6h',
  'QcJcTc8c4c',
  '3s3h3c3dAh',
  'KhQsJh7c5s',
  'KhKcKd8s5s',
  'AdJc8s7c2h',
  'AsQsJsTs8s',
  'QhJsTd9d8c',
  '2s2hTs9d3h',
  'AdQd9d4d2d',
  'AhAcAdQd8c',
  '9s9h7h6c5s',
  'AcKcQcJcTc',
  'QsQhQcTh3s',
  'AcKhQhJdTd',
  '8s7s6c5c4d',
  'QsQhQcJsJd',
  'JsJhJcJdAc',
  '9s9dQdJd7h',
  'As5h4h3c2s',
  'AcKh9h7d3h',
  'JhJcJd4h4d',
  '8s8hJs4h3d',
  'KsKhKcKdAs',
  'TsTh3s3hJc',
  '2h2cKhJh4d',
  '8s8h4h4cJd',
  'TsThKhJd9s',
  'QsQd7c7d2d',
  '7c6s5c4d3h',
  'KsQsJs7s4s',
  'AdKdQdJd5d',
  'TsThTcTd9c',
  '5s5h2s2hAc',
  'AcAd7s7h8s',
  'JhJd6c6d7h',
  'AcKcJc9c2c',
  'TsThTcTdJs',
  'QsQhQcTsTd',
  'AsKs7s6s5s',
  '7s7cJs3h2s',
  '2h2c2dTh7h',
  '2s2h2c2d5s',
  '8s8cJh6d5d',
  'JhJcJdKcKd',
  '8s8h8c8dKh',
  'KsKc9d6h3s',
  'Ah5c4d3s2h',
  '7s7h7d5s5d',
  'AhAcThTc2s',
  'Jd9h8h5h2d',
  'AsAhAdQsQc',
  'JsJhJdKsKd',
  'QdJhTd9h8c',
  '3h3dKhJcTs',
  '3s3h3dAd5c',
  '9s9c9dTd7d',
  '9c8h7s6s5s',
  'AsAhAcAd4s',
  '7s6c5c4c3d',
  'QsQhAd8s6c',
  'Ts9c8s7s6s',
  '8s8h6s6dTc',
  'AdKc8d4s3h',
  '9c8d7s6h5s',
  '2s2h2c2dAh',
  'AdJd8d5d4d',
  '9c9dJhTd2h',
  '7s7h7c7dAs',
  '3s3h3c3d7c',
  '3s3h3c3d4c',
  'AdKsQhJdTh',
  '8h8c8dAsAh',
  'AsAhAd3s3h',
  '8d7h6h5d4c',
  '3s3h3d5c5d',
  '8s8h8dJh3s',
  '9h8h7h6h5h',
  'QsJsTs9s2s',
  'Ah5h4h3h2h',
  'JdTc9d8d7d',
  'AhJh9h8h5h',
  '9s9h9c9d6h',
  'TsThTcJc3c',
  'TsTh2s2hQh',
  'JsJh8c8d3s',
  'Ad5d4s3d2h',
  'Ac5h4c3c2h',
  'AcJc9d7h5s',
  'QhJhTh9h8h',
  'QhQd7s7c4d',
  '2s2h2c2d5d',
  'JcJdTsThAd',
  'QhQcQd3h3d',
  '9c9dTc8s6c',
  'AdKd9d7d2d',
  'JcTd9c8s7d',
  'TsThTdAc3c',
  'AdJc7d6s4h',
  'QdTd9d6d4d',
  'JsJhJcKcKd',
  'AhKh9h5h3h',
  'AdJhTc9c5d',
  'QhJc8h7c3c',
  'TsThTcTdJh',
  '8h8d5s5h7d',
  '6d5c4c3c2s',
  'QsQh3s3d6d',
  'KsKd8s8hJh',
  'AdKh9c8h2h',
  'AsAhQsQd8c',
  'AsAhAdKsKc',
  'AsAhAdTcTd',
  'KsKhKc9d2d',
  '3c3dAcTh5c',
  'AsKsQs9s7s',
  'AdKh8h4s2c',
  'QsQhJhJdAc',
  'AsAh6s6h3h',
  'KhKcKd9c6s',
  '4s4h4dQcTd',
  'QsJsTc9d7d',
  'As5s4d3s2d',
  'QsQcQdAd8h',
  'Ts7s6s5s3s',
  'AsAh6s6c3d',
  'JhJcTd6d4s',
  'AhKcQdJdTd',
  'AsAhAcAd2c',
  'JsJh8s8d5c',
  'KhQdJdTc9h',
  'KcQsJh9h7c',
  'QsJd9s5s4c',
  'JsJcAsTh9h',
  '9s9d6s6hAs',
  'AcAd3c3d6h',
  'AdJdTd4d3d',
  'Qd9d7d4d3d',
  'AhKh7c6d2h',
  'AhKhQhJhTh',
  'QdJsTc9h8c',
  '7s7h7c7dKh',
  'AsKsJs9s2s',
  'QhJsTd9d8h',
  'KdJdTd5d2d',
  '5s5h5d7h7c',
  'AhAc9s8c7s',
  '4s4h4c4dAd',
  '3s3h3c6c6d',
  'JhJcJd9c9d',
  'AsQsJs8c3s',
  'AsKs6s5s3s',
  'QhTd7h6d5c',
  'KsQc9d6d5d',
  'AdKdQhJsTd',
  'JsJhJdKsKh',
  'AhJh9d8s7d',
  'JsJhJd4c4d',
  'AsAh8s8h7h',
  'TsThTdQhQc',
  'KdQh7c5d3d',
  'Jh9c7h5s4c',
  '5s5h5c5dJc',
  '5s5h5c5d6s',
  'Ac9h4h3d2c',
  'KdTd8d7d3d',
  'AdKdQdJd2d',
  'QsQhQdKc5d',
  'QsQhKs7d5d',
  'KsKhKdAcAd',
  'KhKd7d6h4s',
  'QsQhQcQdKh',
  'AdKcQs5c4h',
  '6s6h6dJc2h',
  'AsAhAcJhJc',
  'QsQhQd6s6h',
  'Ks9h8c6s2h',
  '6s5s4s3s2s',
  '7s7h7dQhJs',
  '7c6d5d4d3c',
  'KdQdJd7d2d',
  'QsQdJcJd5s',
  'As8s7s4s2s',
  'JhJcJd7s7h',
  '9s9dJs6d3d',
  'AhAcAdJc8h',
  'AcKc8c6c2c',
  'KhJd8s5d2h',
  'KcKd8s8h5h',
  'JdTc9c8c7s',
  '9s9h9dJsJh',
  'AdKd6d4d3d',
  'AsAd5c5d4d',
  '5s5h5d7c6d',
  '9c9d8c8dTs',
  '7s7c7dQcJc',
  'KsKdAc4s2c',
  'AcKcQc4c3c',
  'QsQhQcQd3c',
  'AhAcAd7c3d',
  'KdQdJh9c3h',
  'KcQcTc9c3c',
  '4c4dAsKs7d',
  'AhKcQhJcTd',
  '6c5s4h3h2s',
  'KsQdJc4d3d',
  '3s3h3c3dKc',
  'AsAhAcQsTh',
  'KsKhKcKdJd',
  'AsAh3c3dTc',
  '8c8dAdJc6s',
  '5s5h5c5d6s',
  'AhKh8h6h2h',
  'KsQcJdTs9d',
  'JcJd8s8hQc',
  '8s8hQdJd5c',
  'KdQs9h5h2s',
  'AcJh6c5c2s',
  'QhJcTh9c8d',
  '8c8d3c3dQc',
  'Ts7h6h4h2d',
  '8s8h8dAsAc',
  'KhKcKdAsAh',
  'ThTcTdJs4d',
  'JhJcJdTs2s',
  'AcKcJc6c5c',
  'AhKdQsJh7h',
  'AcKcQc7c6c',
  'QdJhTs9c8s',
  'JsJhJcJd9s',
  'QcQd3s3h7d',
  'JhJcJd6c6d',
  '4s4h4dKc2c',
  'Ad5d4d3d2d',
  'AcKc8c7c3c',
  'AsAhAc4c4d',
  '6h5h4h3h2h',
  '2s2cTd9s8s',
  '8s8h8c8dJh',
  '6s6h6c8h8c',
  '5s5h2c2dJc',
  'Ah5s4c3c2s',
  'JhTh9d8s7s',
  '6s5d4d3c2s',
  '6c6d2s2dTs',
  'Td9d8d7d6d',
  '3c3d2s2cTh',
  'KsKhKdQc7d',
  '2s2h2dKh6s',
  '2s2h2cJsJh',
  'AsJc8h3c2h',
  'AsKs8s7s6s',
  '3h3c3d8s8h',
  '9s9c9d6s6h',
  'JsJhJcTs7h',
  '8s8c8dAsQh',
  'AhAdKsKh6s',
  '5c5dJd7s2d',
  '6s6h6cAsAh',
  '7s7h7c7dTd',
  'QsQhQd7c7d',
  'QcJsTs9c8h',
  'ThTcTd5h2s',
  'KhQhJdTh9c',
  'AcAdJsTd3c',
  'AdKd8c7h2s',
  'QcQdJsJdKh',
  '9h8s7s6c5c',
  '7h7c7dKsKh',
  'AcKsQhTh8s',
  'JdTd7d5d2d',
  'KhKc4s4d5s',
  '2s2cJs7c5h',
  'Kd8d7d6d5d',
  'TsThTcJh8s',
  '8s8h8c8d6d',
  'KsKhKcKdJs',
  'QsQhQcQdTd',
  '9s8c7h6c5c',
  'AcAd7c7dTh',
  '9s9h9c9d8c',
  'QhQc7s7d4s',
  'KcQhJd7s2h',
  'JhJcJdAhAc',
  'Th9c8h7d6c',
  '5s5h5c5d7h',
  'KcQc9s8d5c',
  'JcTd9d8h7d',
  '7s6s5s4s3s',
  'Th9d8c7d6s',
  '7s6s5s4s3s',
  'ThTdQhJh9d',
  'KcKd9h9dAh',
  'AsKsQs8s2s',
  'AdJdTd9d7d',
  '8s8h8c8d4d',
  'AsAhQdTh8d',
  '5h5c5dQsQd',
  '3h3c3dAc9s',
  '6h6c6dAsAh',
  '7s7h7c5d2d',
  'JcTc9h8h7h',
  '2h2dAcKdJd',
  'QcQdJsJc5c',
  '2s2h2dAd8s',
  'JcTc9c7c6c',
  'KsKdJsTh7s',
  '2s2h2c9c4c',
  '3s3h3dAd8h',
  'AcJc7c6c4c',
  'QhQcQdTd2d',
  'TsTdAsKd5d',
  '8c8dAsJh6d',
  '6s5d4h3d2s',
  'Ts9s8s7s6s',
  'JsJcKd8c3s',
  '7s7h7c7d9c',
  'JsJhJcAdKd',
  'ThTcTd7c4d',
  '9s9c9dAhAc',
  '6h6c6d9c8d',
  'AcKsJsTd4h',
  'AhQhJh8h4h',
  'TcTdAd5d3h',
  'KsJsTs5s4s',
  '7d6d5d4d3d',
  'JsJhJd6c6d',
  '4s4dJhTc9s',
  'QsJs8s6s5s',
  'JsJhJdKh8c',
  'AdKcQs9d6d',
  'KsKhKc7h7d',
  'JcTd9h8d7c',
  'AsKd8s7c2s',
  '4s4h4c9d7h',
  '5s5h5c4c2h',
  'AsKsQs9s8s',
  'Ad5s4d3s2s',
  'QcQdAc7d4s',
  'AcAdQsQd5s',
  'AsAhAcQsQd',
  '3s3h3c3dKh',
  'KdTd9d5d2d',
  '9h9d6c6dTc',
  'JhJd4s4hQh',
  'JsJhAdKc2h',
  'AcKsJc4s3h',
  'As5s4s3s2s',
  'KsKcKdQsQd',
  'QcQd8s8hAd',
  '6s6h6c6d7h',
  '8c8dTs9s7c',
  'AhAcAdQc4h',
  '9s8d7s6h5c',
  '9c8c7c6c4c',
  'JsJcJdAdKc',
  '7h6h5h4h3h',
  '4h4c4dQh9s',
  'TsTd8s8h4d',
  '5s5h5c9c9d',
  'JcTc6d4d2s',
  'JsTs8s7s2s',
  'AdKd6d5d2d',
  'AsKcQdJcTs',
  '2c2dJs8c5c',
  '8c7d6s5s4s',
  '6s6h6cKsKh',
  '4s4h4c9d5s',
  'AhAcAd8s8c',
  'AsAhAcJhTs',
  'QsQhQcQd9d',
  'AdKdQd9d7d',
  'AcKc9c4c3c',
  '9c8c6c5c2c',
  '3c3d2c2d8h',
  'KdQdJd8d3d',
  'KsKhJsTh6c',
  '8s8h2c2dAs',
  'TsThTd8h6d',
  '9s9h9c9d6d',
  '8s8h8cAsQd',
  '4c4dAc8h6d',
  'TsThTc4c4d',
  'AcJc9h8s6s',
  '9s9h9c7h4h',
  '8h8cJh7s5s',
  'QcJcTc9c8c',
  'QhQd7s7dTd',
  'AsAh9s9hKh',
  'As5s4c3d2s',
  'KhKcKdQsQc',
  'QhQdAcKs4d',
  'KsKhKcKd9h',
  'JsJdAh5s2c',
  'JsTd9d8h7d',
  'Ts7s6s3d2d',
  '6s6h6c6dTh',
  '7s7hTc9d8s',
  'KsTh6h5c4d',
  '2c2dAsKh9s',
  '7d6d5d4d3d',
  '9s8s7s6s5s',
  '9s9h9cKsKc',
  'AsQs8s4s3s',
  'AsAhAcAd2s',
  'QhQcQdJc5d',
  '8s8h7s7d6c',
  'KdQdJdTd9d',
  'Ad5s4c3c2c',
  'AsAhKh7c5s',
  'QsQhQcQd3c',
  'Js7s5h3h2s',
  'KsKhTs7c4h',
  'QsJcTs9h8s',
  'QsQhTc9c6s',
  'QhQcAcKdTh',
  'JcJdQd7c3h',
  'KcTc9c8c7c',
  'QhQcQdAsAh',
  'AsAhQcJh8c',
  '3h3c3d6s2d',
  '3h3c3d9d8s',
  '9h9c9dThTd',
  'AsAc7c7dKc',
  'QsQcQd6c6d',
  'AdKsQh9s4d',
  '7d6d5d4d3d',
  '4s4hAdJs7h',
  'AcTc7c6c5c',
  'KsKd4c4dAd',
  'Ks8s7s6s2s',
  'QhQcQd9d6d',
  'AhKc9c8c6d',
  '8s8h8c2s2h',
  '2s2cTc9c7s',
  'QcQdAdKd2h',
  '5s5h5c5dAd',
  'Ad8d7d6d2d',
  '5s5hKc7h2c',
  'AdJd9d7d5d',
  'JdTd9d8d7d',
  'KsQc7c4d2d',
  'QsQhQcQd8s',
  'ThTd9s9hAs',
  'QcJdTd9d8d',
  'KhQhJh8h7h',
  'Td9d6d5d2d',
  'QsQhQcQdAc',
  'KhKcAh8c3s',
  'QsJh9d5c4d',
  'QsQd6s6d5c',
  '9s9h4s4h5s',
  '5s5hTc3c2s',
  '2s2h2d5s5h',
  'AsAd6d5h3c',
  'KhKcKdJsTc',
  '3s3h3c2h2d',
  'JsTs4s3s2s',
  '8s8h8cJc9c',
  'JhTh9h8h7h',
  '8c8dAh6s5s',
  'KhKc3s3d2c',
  'AhQsTd5s3c',
  'AhJs7h5d2s',
  '8s8h8c8d4h',
  'AcKdQc8d6d',
  'JsJh7h7dTd',
  'QcJsTc9d8h',
  'AsKsTs5s2s',
  'AcAd7s7h5c',
  '9s9h9d3h3d',
  '7s7h4h4d5d',
  'AsAhAc8s8c',
  'KdJd7d5d2d',
  '2s2h2c2d7h',
  '5h5c5dTc9d',
  '6h5s4c3c2d',
  '7s6d5c4s3c',
  '9s9hAhTd3d',
  '2s2hJh7c5h',
  'JdTd9d8d2d',
  'QcQd8d5h4d',
  '3s3hAdKd2d',
  'AsJh9s4c3s',
  '5s5h5c6h3h',
  '8s8dJs6d2h',
  'AdKdTd5d2d',
  'QcJcTc9c8c',
  'KhJh9h7h4h',
  'QcJd8h6d4h',
  'AsAd6s6h5c',
  'Ac5h4s3s2d',
  'KhKcKd3h2d',
  'KcQcJcTc9c',
  'AsAd2s2dJs',
  'JsJhJcKd7h',
  '2s2h2c2dQd',
  'QsQhQcQdAs',
  '8s8h8d3s3d',
  'AsAhJhJc8d',
  '7s6s5s4s3s',
  'AsKs9s8s4s',
  'KhJhTc6d5d',
  'JsJhJcJd7h',
  'JsTs9s4s3s',
  'AhAcAdJs7s',
  'AsAcAdQc2c',
  '8s8d5s5d9s',
  'AcKcTc7c5c',
  'QsJsTs9s8s',
  '8s8d7c7d9s',
  'AdJs9h6h5s',
  'QhJh8h7h6h',
  '3s3h3c3d9d',
  'TsThTcTdJs',
  'AsJs8s5s2s',
  '4s4h4dKd7c',
  'KdQhJhTc9c',
  'QcQd9h9cTs',
  'KhKcQsJh6c',
  'QcQdAcTs6s',
  '7s7hKdJc6s',
  'AsAh9s7d6h',
  '2s2h2c2dJd',
  'AhKhQh8h7h',
  'Ah5c4s3d2c',
  '3h3dJc5d4d',
  'AcAd2s2hTd',
  'AcAdJsJd6d',
  'KsKd8s8h5h',
  'QhJh8c3c2h',
  'AsAhAcKs6c',
  '6s6h6c6d4s',
  'AdJd8d6d2d',
  'KdQd9d5d2d',
  'Ac5c4c3c2c',
  'QsJsTs9s8s',
  'ThTc5h5d8c',
  'AcKc9c8c6c',
  '4s4h4d8c2c',
  'AcKsQd3h2s',
  'TsThTcTdAs',
  'QdJd5d4d2d',
  'JsJc3c3d5d',
  'KdQdJdTd9d',
  'TsThTc8d3c',
  'JcJd4h4c5s',
  '4s4h4c4d8c',
  'AcKdQhTc6d',
  'AhAc5c5dKd',
  'JhJc9c9d5h',
  '8s8hAcTc9h',
  '2s2h2c7s7d',
  'AhKh9h4h2h',
  '8s8h8c8dTd',
  'TsThTcTd4s',
  'AsAd9h9dKc',
  '3s3h2s2d9s',
  '8h8c8dKsTd',
  'QsQhQdKsKh',
  'JsJhJcKcKd',
  'ThTcTdAc6h',
  '6s6h6cQcTc',
  '9c8d7s6c5h',
  '2s2h2cQdTc',
  'JsTh9d8h7s',
  'ThTcTd9c2h',
  'JsJhJd6h6d',
  'Th9h7c6h2s',
  'JhTh9h6h3h',
  'AcQs8d7h6h',
  'AsKc8s5s3c',
  'TsThTcTd6d',
  '6c5c4c3c2c',
  'JsJhAhTh6s',
  '9h9c7s7h8c',
  '5h5c3s3c4c',
  'AsKsQdJsTd',
  'AsAhAcKs7c',
  'JsTd9c8d7h',
  'JsTs9s8s7s',
  'JsJcJdQdTh',
  'QcQdJc8h6s',
  '5s5h5cTsTh',
  'Qd8d6d5d3d',
  'QhQcQd8c7d',
  '9s9h9cAcAd',
  '7h7c7dAc9c',
  'QhQcQdJsJc',
  '8h8c8dAd6d',
  'AhKh8h5h4h',
  '8s8h8c8dKh',
  '7h7c2c2d4c',
  'JsJcJdTs7s',
  '8d7d6c5c4c',
  '9d8d7s6s5s',
  '5s5h5cKs9h',
  'AsAhAc8c4h',
  '2s2h2dTsTc',
  '5h5dAc4h2c',
  'Kd8d7d6d5d',
  'AsTs6s5s4s',
  '2h2c2d6s6h',
  'QcQd6s6h9h',
  '2s2h2d9s9h',
  'Ad9d8d6d3d',
  'AsQsJs8s5s',
  'AcAd6c6dQd',
  'AsAhAcAdTh',
  'Ad9h5d3d2h',
  '7s7h7c7d5h',
  'As9h6s4h3h',
  '3s3h3c3d5h',
  'KsJsTs8s6s',
  'JdTc9d8d7h',
  'QhQdKc9c5h',
  '9h9c9dAsAd',
  '8d7d6s5h4s',
  'AdKh8d6s4s',
  'AsAhKs6d4s',
  'JdTs9d8d7d',
  '4h4c4dQc2c',
  'JdTh5c3c2h',
  'Kc7c5d4h3h',
  'AsKdQhJc6s',
  'KsQsJs6s3s',
  '2s2h2d5s5h',
  '9s9d4s4cJd',
  'QhQcQdJd2s',
  '8c7c6c5c4d',
  'JsTs8s7s6s',
  'AhJh7h5h2h',
  'AsAhAcAdKs',
  '6h6d9s7c3d',
  '7s6c5d4h3c',
  'JdTh9h8d7h',
  '2s2hAhKd4h',
  'AhJh7h6h5h',
  'QcJd9s7d6s',
  '3c3dJc9h6c',
  'AdKdTd8d6d',
  'Td9h8s7c6h',
  'KsQsJsTd9h',
  '9s9h7s7h6c',
  '4c4dAhJs3h',
  '6h5c4c3c2h',
  'ThTcTd6s2c',
  'KsKhKcKdAd',
  'AsKs7s6s2s',
  'KsQd4h3c2d',
  'QsJsTs9s8s',
  '2h2c2dJsJd',
  '6d5d4d3h2h',
  '3s3h3cAsKh',
  'AcKc6c5c2c',
  'AsAc7h4s2d',
  'Qs9s6d5h4s',
  'JdTs9s8s7d',
  'AsAhAcJs7h',
  '8h7d6d5c4h',
  'JsJhJcQd3s',
  'JsJcJdAsKs',
  'TsThTcTdAd',
  'AsAhAcAdQc',
  'KdJd5d4d3d',
  'AdKdQdJdTd',
  'JdTd9d8c7d',
  'JsJhJcJd9d',
  'Kh6h5h4d3c',
  '8s8h8d5c5d',
  'AhAcAd5c3h',
  'ThTcTd9s8d',
  'AsAhAcQsQd',
  'KhQcJcTs9s',
  'JhJc6c6d5s',
  'AdKs9c8s4s',
  '7d6d5s4c3h',
  '6s5s4s3s2s',
  '6h6c6d7s7h',
  'KcJc8h6s3h',
  'Jd9d8d7d6d',
  '2s2h2c2dQh',
  '8s8h8c3h3c',
  'AhAd7s7hQd',
  'AdJh8s5s3s',
  'KdQh9s8s4d',
  'QhJcTc9c4d',
  'AsAhAcQsJs',
  '4s4h4c3s3h',
  '7s7h7c7dTh',
  'KdJd9d6d5d',
  'QsQhQcQd8h',
  'AsAhAcAd3s',
  '8h8dAhKd2s',
  '7s7h7dAd8c',
  '9s9h9c9d6h',
  'JsJhJdAdQs',
  'AsKsQsTs5s',
  'QcJcTc9c8c',
  'Ad8h7s4d3d',
  'QhJhTh9h8h',
  'JsJhJd5s5h',
  'JcTc8c7c6c',
  'KdQdJd7d4d',
  'QsJhTd6c5d',
  '9h8s7c6s5c',
  '7s7h6h6c8c',
  '9d8h7h6d5s',
  'AsAhAcTsTh',
  'QhJc8h6c4d',
  '8s8h8c7s7d',
  'AsAhAd9c9d',
  'QhJh7h4h3h',
  'AsAhAcAd5d',
  '6s6hTd8d4d',
  '9c9d7s7dJh',
  'AcJdTs7h3h',
  'AsAhAdKs6d',
  'Jc7d6c3d2d',
  'KsKcKd8s8h',
  'Ac5c4c3c2c',
  'QsQhTsTdJh',
  '6s6h6c6d2d',
  '4s4h3s3hJs',
  'JsJhJd9s9d',
  '7s7h9s8d2s',
  '8s8h8c8d4c',
  'AsAhAdKh4c',
  'Ac5c4d3h2s',
  'AhAd8d7h6s',
  'Ac5d4s3h2d',
  '6h5d4c3d2h',
  '5s5h5c7c7d',
  '2s2h2cJc9c',
  'KcJc8c6c3c',
  'QhQcQdKhTd',
  'QsQhQcKh9h',
  '5s5h5c2s2c',
  '7h6c5c4c3d',
  '6d5d4d3d2d',
  '9h9c2s2hAc',
  '4s4hAd9c8h',
  'As5s4s3s2s',
  '8c7c6c5c4c',
  'JcJdKd9s7c',
  'AsAhAc6h2d',
  'QsJh8d5s2s',
  '6d5d4h3s2d',
  'JdTd9d8d7d',
  'AdKhQhJcTs',
  'KsQs5s4s3s',
  'QsQhQc6s6d',
  'AsAcAd5h3d',
  'TsThQs5d3h',
  'QhQd7s7hTh',
  '7h7dAsKs5h',
  '7h7c7dJh4c',
  'Js8h6c5s4s',
  'AsAcJcTh4s',
  'AdKc9c7s3c',
  'KsKd3h3d7s',
  'QsJsTs5s3s',
  '2h2c2d8s8h',
  'KdQcJhTs9s',
  'QsJsTh9c8s',
  'JhJc7s7c5s',
  'KsKhAhTd7d',
  'Js9c8c7h6c',
  'Jh9h6h3h2h',
  'QdJs7s5d3s',
  '7s7cKs9h4c',
  'AsJd9s8c3d',
  'AdKd7d4d3d',
  '7s7h7c7d4d',
  'AhKh8s5c2s',
  'AdKd8d7d3d',
  'AsAcAdKcKd',
  'AhAcJsTs7s',
  'KdJhTd7s5h',
  'QsQhJhJc5c',
  '8h7c6d5s4h',
  'KhQhJcTh9h',
  'KdJc9d8d3d',
  'QhQcQd7c6c',
  '2s2h2cAhQc',
  'AdKd8h6d5s',
  '9s9h9c6c6d',
  'KhQhJhTh9h',
  'Tc9c8c7c6c',
  'AdKhJh6s4s',
  '9s9h9dAh7h',
  'KsKh8s8hAh',
  'Ts9s6s4s2s',
  'JsJd7s7hAd',
  'AsAhKhKd8c',
  '6d5s4c3d2d',
  'QdJhTd9h8c',
  'KdJd9d7d5d',
  'QcQdJh9h6h',
  'AsAhKh6c4d',
  '8c7c6c5c4c',
  '6s6c6d9c9d',
  'AsAhAdKsKh',
  'AhKs9c5s4c',
  'KcTh8d7s2d',
  'KsKhKd9s8h',
  'TsThTcQcQd',
  '8h7d6h5s4h',
  '7s7h7c7d9d',
  'AdKdJd7d3d',
  '9h8h7d6d5h',
  'AhAcAdKdQh',
  '3s3h3cAcAd',
  'AdJd7s5h3h',
  'QsJs4s3s2s',
  'KsKhKdJcTh',
  'QsJsTs9s8s',
  '8h8c8d9h9d',
  'JsJhAdKc2s',
  'AsAhAd7h7d',
  'AcAdKd8d5c',
  'AdKdQdTd2d',
  'JsJhJcJd7d',
  '5s5h5cKc8s',
  '8s8c8dKsKh',
  '8c7h6h5d4h',
  'JsJhJcJdTc',
  'AcKdQc6h4h',
  'Ah9d8c7h3d',
  'JsTs9c8d7d',
  '6s5s4h3h2c',
  '9s9h9c6h6d',
  '7s7h7dAcAd',
  'JhJcJdTs8c',
  'AsAhAcAdKc',
  '6s6h6c6d5c',
  'Qc9c8c7c3c',
  'AdKh6h5c3d',
  '8s8h8d4s4h',
  'Td9h8d7h6c',
  '4s4h4c4d3d',
  'Tc9s8s7h6d',
  'AhQc8s7s5d',
  'QsQhQcQd5d',
  'AsAh7h7c4c',
  'ThTdJs3h2s',
  'KsKhKd4s4h',
  'Ac5h4d3h2c',
  '2s2hAsQh6d',
  '9s9h8c8dAc',
  'AsAhAcAdKd',
  '9h9dAc7s4d',
  'AhAcTsTd3d',
  '9d8d7d4d3d',
  'QsQhQcQd5s',
  'AsQd8s7s4s',
  '7h7c6s6c5s',
  '6s5s4d3d2s',
  'AsKs7s6s5s',
  'AsAhJdTc3c',
  'JcJdTsTcAs',
  'AsAhAdKd4d',
  '2h2cQsJh3c',
  '4c4dAd6h5h',
  'QhJh9h8h7h',
  '7h6c5d4h3s',
  'Js8s6s5s3s',
  '7s7h7cQhQd',
  'QsJsTs9s8s',
  '9s9hAc4d2h',
  'AhJh8h5h4h',
  'QsQhQcQdAc',
  'QsQh2s2hAd',
  'AhJdTd6c2h',
  'JsTh9c8s7c',
  '7s7h3s3hAs',
  'JhTd9d8s5s',
  '2h2c2dAh9h',
  'KdQd9d8d2d',
  '4s4c4d2c2d',
  'AsAcAdJdTs',
  'AsKsJs8s2s',
  'JsJh8h8cTd',
  'AdKd8h7d4h',
  'AsJs9s8s6s',
  '2c2dAh9c3d',
  '5s5h5c9d2s',
  'JhJd6s6d2s',
  '9c9dJd7s4h',
  'QcQd8s8hTc',
  '7s7h3h3c6s',
  'QsQhJsTh3h',
  'AhKhQh9h7h',
  '4c4dQsJcTs',
  '7s7h7c9h9d',
  'AhKsQd6s4c',
  'KdQdJdTd9d',
  'ThTcTd6c2c',
  'Tc6d5c4d2d',
  'JsJhJcJdQs',
  '6c5c4c3c2c',
  '7s7h7cAhAc',
  '8c8dAhKhQd',
  'JdTd9d8d7d',
  '8s8h8dJs6h',
  '4h4c4d9s9d',
  'JsJcJdAhAd',
  '4h4cQcJcTd',
  '5s5h5dQs3c',
  '6s6h3s3d5c',
  '9d8s7h6h5c',
  'AcKc9c6c3c',
  'Ac9d8h4s2h',
  'AhKhQcJsTd',
  '8s8hKd7s4h',
  '9s9h9c9d6c',
  '7s7c7dQcJd',
  '9h8s7s6c5d',
  '7h7dAd8c5c',
  '7s7h7c7d5d',
  'AsAhAdQsQh',
  'AhAcAdKh6s',
  '9h9c9dQhQd',
  '7d6d5d4d3d',
  '8s8c8d7s7h',
  'Ad5s4s3c2d',
  '4s4dKcTc3s',
  'AcKcTc9c3c',
  '7s7h7cAd4c',
  'AsKdQdJhTc',
  '9c9d4h4d6s',
  '7s7hAsQsJd',
  '7s7h7cQd5h',
  'AsKs9s8s7s',
  'JsJhTh9d7d',
  'KhKdTcTdAd',
  '7d6d5c4h3c',
  'KsKhKdAc8s',
  'ThTcTd7c3d',
  'AdQdJd7d6d',
  'AhJh7h6h4h',
  'JhJd7s7cAs',
  'AsAdKsTs4s',
  'KsKdAd8s6s',
  '8d7h6h5d4s',
  'As5d4s3d2s',
  '3s3h3dTc9h',
  '9c9dAdKd8s',
  'AhTh7h5s3s',
  'Ts9s8s7s6s',
  '8s8h8cAhKs',
  'KcQsJcTs9h',
  '8s8hQd7d2h',
  '2s2h2c4s4c',
  'AhAdQs8d3c',
  'QsQhJhJc9h',
  'QsJs8s5s4s',
  'AsJcTd6s3c',
  'QsQhQcQdTh',
  'Ac5d4c3c2h',
  'KhKdJdTh7d',
  'AsAhAcAdKd',
  '9c9d3s3hQs',
  '9s9dAcJc7h',
  '6s6h5s5h8d',
  'KhQh5c4h3c',
  'AcKdTs8h4d',
  'ThTc8s8c5h',
  'Jd7d6d4d2d',
  '8h7h6s5s4s',
  'KhKc8h7h2d',
  'JsJh9c9dKh',
  'QsJc9d7h4c',
  '2s2hJc9d4s',
  '6s6h6dAsAd',
  '3c3dQhJs7h',
  '2s2h2dAsAh',
  'AsJsTs9s8s',
  'KdQhJsTc5d',
  'KcKd6s6h5s',
  'AsAh5s5h7s',
  '9c9dKdTs7h',
  'QcJc9c7c4c',
  '8h8c8dJh6c',
  'JsJhJc4h4c',
  'JcTc9c5c4c',
  'TsTdAs7c4d',
  'AdTd9d8d4d',
  'JsJhJcQcTc',
  '6h6c4h4d8d',
  'Ah5c4h3d2h',
  'QsQhQcJd5c',
  'KdQdJdTd9d',
  'QcTc9c3s2c',
  '5s5h5c8s8h',
  '9h8s7s6c5s',
  'AsTs9s7s3s',
  'As9s7d3h2s',
  'JsJhTd6c5c',
  '8s8c8dJsJh',
  'AhJc9d4s3s',
  '8s8h8c8dQs',
  'QdJh9h7s3s',
  'AdJd5d3d2d',
  'AcAd8c8d2h',
  '6s6h6c5s5c',
  'AhAcAd6c6d',
  '7h6h5h4h3h',
  '6c5c4s3c2s',
  '8h8c8d9s9c',
  '5h5c5dTs7h',
  'QcQdJsJh7s',
  'JsJd3h3d7c',
  'Kd9d7d5d4d',
  'AdKdQdTd2d',
  'QsQhQcJsJd',
  '3h3c3d8s8h',
  'TcTd5s5h9d',
  'Ad9d8d7d5d',
  '8h8c8dJsJh',
  '8s8h8cKs5s',
  '7h6h5d4c3d',
  'KsKh5h5dJd',
  'JhJd3h3d4d',
  'AsJdTc6c2s',
  'AhJh9h6h3h',
  'As8c5c3c2h',
  '2h2c2dAs9d',
  '7s7h7dKhQc',
  '4s4h2h2cAs',
  'QsJsTs9s8s',
  'KhKcJh9s5d',
  'QsQhTsTh3d',
  '8h8c8d5h5d',
  'AsAhAc7s7h',
  'AsAh8s8hJc',
  'KsKhQhTs7h',
  '5s5h5c5dJd',
  'AsAdKsKhQs',
  '4c4dQcJs5c',
  '9c6d5d3h2h',
  'JsJhJcAs3h',
  'TsTcJs9h8d',
  '8h8c8d2c2d',
  'AhAcAdTsTh',
  'Qd8d7d5d4d',
  'QsQh4s4c6c',
  'AsAdKs8h4s',
  '9s8d7d6d5s',
  'Js8s6s4s3s',
  'Ac8d6s4s3s',
  'KhQsJhTd9d',
  'KhQhJh6h5h',
  'AhAc7s7dJc',
  'JsJhJdAs9d',
  'AhAcAdTd6s',
  'TsThQhJs5d',
  'QsQhQdJdTd',
  '6s6h6cAsAh',
  '9c9d8c8d3h',
  '7s7h7c9c9d',
  'Tc9c8c7c6c',
  'JsJd3c3dAh',
  'KhKd6s6hTs',
  '2s2dJh6h5c',
  'AsKdQhJcTc',
  'AdKsJc5h2c',
  'JcJdAs7d3d',
  'AsAhAcAdJs',
  '4h4c4dQdJd',
  'AsAhAcQd6h',
  'AcAd6h6cKd',
  '4s4h4d3s3d',
  '7s7h7cAh4c',
  'AsAhAdKcQh',
  'AdKd9d8d3d',
  '4s4hAh9c7d',
  'JsJhJc2c2d',
  'JcJd6c5s2d',
  'AsAd7c7dTs',
  'JsJhJc6s5s',
  'Td9d8d7d6d',
  'JhJd3s3h7s',
  'As9s8s6s4s',
  'AcKs7s5s4d',
  '5s5h5d9s9h',
  'KhKd4s4c7s',
  'AdKcQsJsTd',
  '7s7h7c7dKc',
  'Ac7c4c3c2c',
  '5s5d2h2d8c',
  'QsJsTd7d4h',
  'As9s8s6s2s',
  'AsAhThTc2d',
  '2s2h8s7s3c',
  'AsAd7s7h6c',
  'AsAhAcAdQs',
  '9s9h9c3s3h',
  'AsAhAc8h5h',
  '6s6d5s5h4d',
  'AsAhAd6s6h',
  'AsAhKhQs4s',
  'QsQhQcAhAc',
  'AcAdKsKh2h',
  '9s9h9c8h7h',
  '9s9d5s5hAd',
  'QsQcJcJdKc',
  'AsAhAc8s6s',
  'TsThKhJd4c',
  'AsAhAcKhKc',
  'QsQhQcKsKh',
  'AsAcAd6s6d',
  '9s9h9dAhKs',
  'Jd9d8h5h2h',
  '6s6h6c2c2d',
  'Ad9c7d6c5c',
  '8c8d4h4dKs',
  '5s5h5c5dAd',
  '8h8c8dJs9s',
  '8h7d6s5d4d',
  'AdKd9d4d2d',
  'QsJsTs8s3s',
  '5s5h5dAcTc',
  'ThTcTdQd3h',
  'AcKhQs7c3d',
  'TsTd9d6s5h',
  'AsAhJsTh5d',
  'KsKhKcKd5c',
  'Ts9h8d7h6s',
  'QcJhTd9s8s',
  'JsJhJcKs8c',
  'AcKc9c8c7c',
  'AdKhQdJcTs',
  'KsKhJcJdTc',
  'JcJd4c4d7h',
  '7s7hKs3h2s',
  'AdKd9d7d6d',
  '8h8c8d6c6d',
  '8h7h6h5d4s',
  'ThTcKs4d2s',
  'TsThTcTd2d',
  'ThTcTd2c2d',
  'JhTc9h8h7s',
  'KdQdJdTd9d',
  '6d5c4h3h2h',
  'TsThTdJsJd',
  '4s4h4c4d9s',
  '6c5h4h3h2s',
  'AhKdQsJc5c',
  'AsKcQsJhTd',
  'QsQh2s2cKc',
  'TsThTd9h5d',
  'JsJh9c5c3d',
  'QsJhTd9s8d',
  'AhQhJs9h6d',
  'Js8s5s4s2s',
  '2s2h2c2d8s',
  'AsAcKhKdTs',
  'Qc9s8s7s4s',
  '8c7d6h5s4h',
  '8h8c8d9s9c',
  'AhKsQhJhTc',
  'Tc9h8d7d6s',
  'AsKs9s7s4s',
  '3s3h3c3d7h',
  'AhAcAd9h9c',
  '5s5h5dQs7s',
  'AsAhAc8h7s',
  '8s8h8c8d6d',
  '7h7c7d9d5c',
  'AsKsTs8s3s',
  '6d5c4c3h2c',
  'AsAhAcTc6c',
  'JsJhJcJd4c',
  'AdKdJd7d6d',
  'AhAcAdKh4h',
  'KsKh3c3d4d',
  'AdJd9d7d5d',
  'AsAcAd5c5d',
  '9c8s7c6d5h',
  '8h7s6s5h4h',
  'Th9s8d7c6c',
  'AdJdTd9d3d',
  '5s5h5c5dTc',
  'KdQs8c3s2c',
  '2c2dAh9h6s',
  'Ah5d4s3d2d',
  'JcJdAd7h6d',
  'AdKd6d4d3d',
  '7s6h5d4c3h',
  '8s8h8dTh9d',
  'KsKc8c8d3d',
  'AhKh9h8h6h',
  '5s5c5dJd3c',
  '3s3h3dJd2d',
  'AsAhAd9s9d',
  'QsQh7s7d9s',
  'AhKh9h7h3h',
  'KsKcQhQc8d',
  '6c5h4h3d2s',
  'Ah8h7s6h4h',
  'TsTh8c8dKs',
  '6s5d4c3s2h',
  'QsQdJsJh3d',
  'Kd9h8d7d6c',
  '7s7h7c7d9d',
  'Ah5c4c3h2s',
  '8s8h8cJd4c',
  'QsJhTc9h8s',
  '4s4h4cTcTd',
  'QsQhQcQd4s',
  'QsTs7s5s4s',
  'AhAcAd6h5h',
  '8s8cKs6c3d',
  'JsJhJd8c4d',
  '9s9h9c9dJs',
  'Jh8s7c6c5s',
  'AdJd7d5d4d',
  '9s9h9c9d6h',
  '8s8d4s4dJd',
  'KsKhKcKdJd',
  'JsJdQs7c5s',
  'AhQh7d6d4c',
  'QsQhQd7s7h',
  'QsQhQcQdAh',
  'JcJd5s5dAs',
  '7s6s5s4s3s',
  '3s3h3dAdTh',
  'KdQsTh7s5d',
  '4s4h4c4dAs',
  'AdQdJd5d3h',
  'AdKd9d4d3d',
  'AhJh7d3s2h',
  'QhQcQd5c5d',
  'AsAhKsKd9s',
  'QcJc9c8c7c',
  '5h5cAh4d2c',
  'QsJcTh9d8h',
  'AsKs8s7s3s',
  'Qs6s5s4s3s',
  '8c8dQc9s5c',
  '8s7s6h5d4h',
  'AsAcAdKs2d',
  'JcTc9c5c4c',
  'QhQd7c7d5h',
  '3s3h3cJsJd',
  'AdKdQcJcTc',
  '7s7h7c7d3d',
  '8s8c8d7c4s',
  '9s9h9d6s6h',
  'JsJhJcQh2h',
  'KhJsTs4s3h',
  '8s8h8dTcTd',
  '4s4h4c4dJd',
  'KsKhKdAsAd',
  'QhTd9c5s4s',
  '3s3h3c3dJs',
  'AsAhAcAdKh',
  '4h4c4dQhJd',
  '5s5h5c5dAs',
  '7s7h7dQdJs',
  '6s5s4s3s2s',
  'AsAhAcAdJc',
  '8s8h8c8dTd',
  '8h8c8dTd9d',
  '5h5c5d8c7s',
  'AcQc7c6c4c',
  '2h2cKcJs7d',
  '8h7h6h5h4h',
  '7c6s5d4c3d',
  'Ac5s4d3h2d',
  '8d7d6d5d4d',
  '9h9c9dJd4c',
  '5s5h5c5d2s',
  '3s3cAd9h4c',
  'JdTd9h8h7c',
  'AsAdKsKd8c',
  '9h9d4c4dTh',
  'Jd8d7d5d4d',
  '5s5c5dAd8s',
  'AsAhAdKc4h',
  '2c2dAd4h3s',
  'QsQcQdTd6s',
  'JdTd9d4d3d',
  '3s3c3d6c5s',
  '9s9h9c9dJs',
  'KsQsJsTs9c',
  '7s7h7c4c4d',
  '3s3d2s2h7s',
  'JsJhTc8d3h',
  'Qh9h6s3c2h',
  '7h7c7dAsAh',
  'QsQhQcJh2c',
  'QcJsTc9d8c',
  '7s7h7c7dJc',
  'AhAcAdJd7c',
  '7s6s5s4s3s',
  'JsJhJc9d7c',
  '7s7h3c3dJc',
  'AhAcAdKsKd',
  '3s3h3dAdKc',
  'AhAc9c9dKd',
  '6s6cAd9d7d',
  'JhJc7c7d4d',
  '4h4c4dQsQd',
  '3s3h3c3d7s',
  'Ks9s4s3s2s',
  'KdJd9d8d7d',
  'AdKdQd9d4s',
  'AsAhAcAd9h',
  'AdJd7d6d4d',
  'AsAhAcJd8c',
  'TsThAc6s2s',
  'KcQcJcTc9c',
  '8h8c8dAhAc',
  'AsAhAcAd9h',
  'QhQcQd4h4d',
  '8d7d6d5d4d',
  'AcAdJhJdTd',
  'QhJs5h4c3s',
  'AsAhAd9s5s',
  'KcQsJc9d7c',
  'AsAhAdKs3c',
  '7h7c7dQsQh',
  '9d7d6d5d4d',
  'AcKdJc9d3s',
  'TsThTcTd9c',
  'AsAd8s8cTc',
  '6s6h6c7s3s',
  '2h2c2d4s4c',
  'KhKc6h6dAd',
  'AhAcAdKsKh',
  'KsQdJsTs9c',
  '7s7h7d9h2s',
  'As8s6s5s2s',
  'AdKh6c5h3c',
  'JsJhJd7h5c',
  'AsAhAc6s3s',
  'QcJhTc7c2d',
  '8c8dKcQdTs',
  'Ks9s5s4s3s',
  'Ac5c4c3c2c',
  'AsAhKcQd3c',
  'AsKsJs9s6s',
  '3s3h3dKdQs',
  'AsAhAcAdJs',
  '9s9h9d5c5d',
  'JsJhJcJdAs',
  'KdJdTd5d2d',
  'TsThTcTdJd',
  'AsKh8s3h2c',
  '5s5h5c5dAs',
  '4h4c4dQh9c',
  'JsJhJcJdQs',
  '8c7c6c5d4s',
  '7h7c7d2s2h',
  'JsJd3s3cTh',
  'QsQhQcQdTd',
  '5s5h5dJc9d',
  '8h8c7s7h2d',
  '2s2h2c2d9c',
  'AhAcAd7h7c',
  'AhAcAdQcTc',
  'QsQhQc9h7h',
  '5s5d4c4dQc',
  'Ts9s8s4s3s',
  'AsAcAdKd7h',
  '9d8c7c5d2c',
  '9h9c9dAcAd',
  '4h4c4dKc5h',
  'KhQcJcTh9h',
  'AcKs8s7c5s',
  'KsQhJdTs9d',
  'QsQcQd4h4d',
  'KsKhKdTs8c',
  'AcAdKhTh3c',
  '7s7h7c7d9s',
  'AdTh9d5s4h',
  'AsAhAc6s6h',
  'AsQsTs6s3s',
  'KhKcKdJs7s',
  'AhTh9h5h2h',
  '9h9d4c4dTs',
  '3s3dAhKd2d',
  'AsAh7h7c8c',
  'AcKdQsJhTc',
  '6s6h6cTsTc',
  '8s8h8cAsAh',
  'AsKs9s4s3s',
  '8s8c3s3hKs',
  'QsQhQcKd2c',
  '3s3h3c3d7h',
  '9h9cQsJh3h',
  'AsAhAcAdTh',
  'TsThTdAsAh',
  '7d6d5d4d3d',
  'AsAhAc7c7d',
  'Td9s8h7h6s',
  '8s8h8dJh9h',
  'KcKdJd8d5d',
  'Kd8c7h5d4d',
  'Th9h7h6h5h',
  '9s9h9cAdKs',
  'JdTc9d8s3h',
  'QsJdTs9c8c',
  'KdQdTd8d4d',
  '9s9h9c3h3c',
  'KcQdJsTh9d',
  'AdKd7s6s2h',
  'JsJhJc2h2c',
  'TsThTcTdAs',
  'Ah5d4s3d2h',
  'AsAhAc8s8d',
  'JsTh9s8h6s',
  '6c5c4c3c2c',
  'AsAdKsKh5h',
  'KsQhJc9s6c',
  '8s8h8cAcAd',
  'QsQhQcQd4d',
  'AsAh5h5c4d',
  '8c8dQs9s7h',
  'QsQh6d3s2c',
  'AsAhKdJd3d',
  'JcTh6s5c2s',
  'TsTdAs7h2d',
  '8s8hJdTs4d',
  '9h9c9dJhTs',
  '9c9d7c7d4d',
  '8c8d9d7h5c',
  'ThTcAhKd8h',
  'AdKdQd9d7d',
  '8c8dKsQs6c',
  'QdJhTs9d8s',
  '9s9h9c9dQs',
  'QsQcQdTd7c',
  '2s2h2d5s4s',
  '8s7s6h5c4d',
  'AhAcAdTh8h',
  'AsAhAcAdJc',
  'AsKhQhJcTh',
  'AsAhAcKcQc',
  'JhTh9h8h7h',
  '9c9dAcKcQc',
  '9h9cKdQdJs',
  'JcTc7h5c4d',
  'AsJd8d3c2c',
  '9c8c7c6c5c',
  'JsJhJd4s4d',
  '9c8c7c6c5d',
  'AdKdQd8d7d',
  '7s7h7cTh3h',
  '7s7h7c4c4d',
  'TcTd7c7d9h',
  'KsKh6s6hJd',
  'AdQd9d5d2d',
  '7h7c7dAcAd',
  'AsAhAd8c6h',
  'AhKsQhJd5c',
  '9s9h9cAhKh',
  'AcTc8d5h4s',
  'JsJhTc8d2d',
  '7s7h7cAd9h',
  'AsAcTd8h7c',
  'Kd9d7d4d2d',
  '2s2h2c2d7c',
  'AdKhQcJsTd',
  'TsTcTd7s7h',
  '8s8h8c8d6d',
  'KsKhKc8h7h',
  'Tc9c8c7c6c',
  '2h2c2d8h7d',
  '8s7d6s5h4d',
  'JsJhJdAc8d',
  'AhKhTh6h2h',
  '7s7c7dKhKd',
  'AcKh8h5h3h',
  'TcTd7d6h4d',
  '8h7c6d5s4h',
  '5s5hKc8d3c',
  'AsAhAcAdKh',
  'QdJs9c5s3s',
  'JsJc7s7hTd',
  'AsKsJs7s6s',
  '7d6d5h4h3c',
  'JsJh7h7d5s',
  'TsThTcJd6c',
  '4s4h2s2hQc',
  'AsAhAcAd6h',
  '6s6d5s5c7c',
  'AdKd6d5d4d',
  'JsJhJdTs6h',
  'QsQhQcTd6h',
  'AsAhAcAd6d',
  '8h7c6c5d4h',
  'AdJdTd5d2d',
  'QsJsTs9s8s',
  'AdTd6d5d3d',
  '8s8h5h5dAh',
  'Tc9c8d7s6d',
  'AdKdQdJdTd',
  'ThTcTdJs7h',
  'JcJd8s8d4c',
  'AhKhQh8h7h',
  'AsKs7s6s2s',
  'AcKdQcJcTs',
  'AsAhAdKh4h',
  'AhTh9c6c5h',
  'KhKcKd6h6d',
  'KcKd4h4cAs',
  '7s7h7c6s6d',
  'JhTh8h7h5h',
  'Ts9d8h7s6d',
  '9h9c9dKsKh',
  'ThTcTdAcAd',
  '9h9c9dKs6h',
  '5h5dJd4s2d',
  '9s8c7d6h5h',
  'QsQhQd6s4c',
  'AsKsQs5s4s',
  'AsJhTc9h3c',
  '7c6s5h4d3s',
  'AcKc9c8c3c',
  'KsQsJs7s3s',
  'QsQhQdTcTd',
  '5s5hKs7d3c',
  'JsTs9s7s5s',
  'JcTc9c7c6c',
  '7s7h7d8d2d',
  'QcQd4c4dKs',
  '9h8h7h6h5h',
  '4s4d2s2hKc',
  'QcJcTs9d8s',
  '9s9h9d5h4h',
  'JsJh2h2c8h',
  'AsKdQcJhTh',
  '6d5d4d3d2d',
  'Th8s7s4s2d',
  'AhAd8s8c9h',
  'KsQhJcTc9h',
  'JcTd9h6h3s',
  'AcAdKh7h6d',
  '9d6d5d4d3d',
  '7d6s5c4c3d',
  'KcQcJsTc9s',
  'JhJcKh7h3d',
  'AdKdQd6d3d',
  'Qs7s5s3s2s',
  'QhQcQdAsAh',
  'QsQcJsJdTc',
  'JsTs9s8s7s',
  'KsJs8s7s2s',
  'KsKhKcTs9h',
  'JdTd9h8h7d',
  'AsKsTs8s4s',
  'AsAdKs8d2h',
  'Ts9d8s7d6s',
  'AsAhAcAd7s',
  'Ad9d8s5h4c',
  'QcJhTc9d8s',
  'Td9d8d5d3d',
  'JsJhTcTdAs',
  'AsAhAc9h3s',
  '7s7c7dKsKd',
  'JsJd9h7h2c',
  'JcTd8h5d2h',
  'AsKsQs7d4h',
  'QsJhTh9s8c',
  'KcQdJcTh9c',
  'QsQdTd7h3c',
  '7s7h7dTh8h',
  'JhJc7h7dAs',
  '5s5h5cJsJh',
  'QdJd9d7d3s',
  'AsAhAcAdJh',
  '8s8h8c8dAd',
  'AcJcTc6c3c',
  'KsKhKdTsTd',
  'AcTc7c5c2c',
  'AhKhQhJhTh',
  'AsJs9s8s5s',
  'KsKhKcKd2s',
  '8h8c8dAs6d',
  '3s3h3d6h2h',
  'QsQhQcAcAd',
  '4h4cAcTh7c',
  '8s8h8c8dQs',
  'QsQh9c9d2c',
  'KcQc9s4d2c',
  'QdTh9d8d5h',
  'QhTd9d7s2h',
  '6d5s4s3s2c',
  'JsJhTd9c2h',
  '2s2h2dJhJd',
  'KdQdJdTd9d',
  'AsAhAcKcKd',
  'JcJd9s9hTh',
  '9s9h9d7s2d',
  'JsTs9s8s3s',
  'AsAhAcKhKc',
  'AdTd7d6d4d',
  'QsQhQcQd9s',
  'AsAhAcAd7c',
  'AsTs8s7s5s',
  'KsKdJd9h6c',
  'JsTs9s8s7s',
  'QsJs8s7s6s',
  'ThTcTd7h7c',
  'AhAcAdJsTs',
  'Jc9c8c7c2c',
  '7d6h5d4s3d',
  'QcJcTh4h3d',
  'AsTs7s6s5s',
  '8s8h8c2s2d',
  'JsJhAhQh7h',
  '7s7h5h5cAc',
  'QsQhQcQd2s',
  '8h8c8d6s5s',
  'AsKsJs5s2s',
  'Td9h8c7s6c',
  'Ac5c4s3c2h',
  'ThTcTd8s8c',
  'QhJcTh9c3s',
  'AsAhAdKc3d',
  'TsThTd9h9d',
  'Th9h8h7h6h',
  'JhJcAdKh2s',
  '5h5c5d9d7s',
  '2h2c2d8c8d',
  'TsThTcAsAd',
  'QsQhQcQdAd',
  'JcTd9c8h7h',
  'TsTcTdAd3s',
  'Jc9d7s6d4d',
  '8h8cAsJhTd',
  '7h7c2s2cQd',
  'AdKd7d3d2d',
  'KdJd8d5d3d',
  'AhAcKhKcQd',
  '6h6c7c5c4d',
  'QsQhQcTsTh',
  'JsJhJcJdKh',
  'KdQcJdTh9d',
  'KsKhKdQdJd',
  'JdTd9d8d7c',
  '8s8h8c8dJh',
  '7s7h7cKhKc',
  '9s9hAh7s3s',
  'AsQsJsTs2s',
  'AcAd3c3dJs',
  '7s6d5s4d3d',
  'KdJd9h7d5d',
  'AhTh8h7h2h',
  'AsAhAdJcJd',
  'AcAdKs5h3h',
  'AhQdJdTc2c',
  '4s4h4cJcJd',
  'Qd8d7h5h3h',
  'JdTd8d7d2d',
  '6c5c4c3c2c',
  '4h4c4d2h2d',
  'AcJc9c5c2c',
  'TsTdAdKc2c',
  '7d6c5s4c3d',
  '4s4hAcKs6s',
  'AsKs9s5s2s',
  '6s6h6d9h9d',
  '6s6cQh8s4s',
  '7s7h7cAsAd',
  'Ac9c6c5c3c',
  '7s7h2h2c3d',
  '7c7dAsJs2s',
  'AdQdTd7d6d',
  'AhKh8h7h3h',
  '4s4h4cKd8h',
  '6s6h6dAh4s',
  'As5s4s3s2s',
  'JsJhTc7c2d',
  'AsAcAdKsKd',
  'AsAhAdKsKd',
  'KsQs7s6s2s',
  'Jh8d7s5d4d',
  'AhKcJdTh3s',
  '9s9h9d6d4d',
  '8s8h8c8dKs',
  'AsAh3s3d5h',
  '4s4h4c4d3h',
  'KsKhKdAsAd',
  'AsAh7c7d8h',
  'KcTc6c3c2c',
  '9h9c9dAs2c',
  'AsAhAdTsTh',
  'JdTh9h8c7c',
  'AhKcTs8s3s',
  'QhQcQdAh4s',
  'AhJd4d3s2d',
  'AcKc8c5c2c',
  'AsKsQh7c3c',
  '2s2h2d9s9h',
  '6h6cQd9d2c',
  'KsQsJsTs9s',
  'KhKc9h9cJc',
  '2h2c2d9h9c',
  'QhQd2c2dAs',
  '7s7h7cTcTd',
  'TsThJs8h5d',
  '6d5d4d3d2d',
  '8s8h8c8d7s',
  'AcKcTc8c3c',
  '2s2h2c2d6s',
  '8h7s6s5c4c',
  'AsAhAdKsKh',
  'Td9d8d7d6d',
  'AsAhAd8d7s',
  '5s5h5d9h9c',
  '4s4h4c4dAs',
  'AdJdTc7d6d',
  'Tc9c8c7c6c',
  'KdTd9d6d4d',
  '7s6s5s4s3s',
  '4h4c4dKcKd',
  '9s9h9c9d6h',
  '9s9h9c9dJd',
  '4s4h4c4dAh',
  '7s7h7c7dAh',
  'QcQd6s6hAc',
  'KsKcKd6d2h',
  'Tc9h8c7s6s',
  'AcTd8d3s2c',
  'AhAcAdQsQd',
  'QsQhQcJc6h',
  'JsJcJdAc7h',
  'AsAh7s7d4d',
  'QcQd9s9h2c',
  '7s7h7c7d9s',
  '9c8d7s6s5s',
  '8s7s6s5s4s',
  '8h7c6d5s4s',
  '7d6d5s4s3d',
  '7s7h7c7d6d',
  'QsQhQcQdAd',
  'KhQh9h7h3h',
  'QsQh7s7cJh',
  '7h6h5c4s3d',
  'AsKsQsJs9s',
  '8s8h8dJsJh',
  'QsTs9s7s6s',
  '7s7cQs5d4d',
  'JcJdKsQc6s',
  'JsJc9s9dTd',
  '7h7cAsJd2s',
  'AsKd8c7c4h',
  '3h3cQdTs5s',
  'JsJhJc6h2c',
  '8s8h8c8dKs',
  'ThTcTd3c2d',
  '2s2h2dKh8d',
  'Ad5h4d3c2s',
  '9h9c9dAcAd',
  'KdJdTd5d3d',
  'AcJc9c8c3c',
  'KsQsJsTs6s',
  'KhKcTsTh3c',
  'JsJhQh7h6d',
  'QsQhQcQdKd',
  'QdJdTd9d8d',
  'AcKcQc6c3c',
  '3h3c3dQsQd',
  '7s6s5s4s3s',
  '6s6h6cAhJh',
  'AhKhTh9h5h',
  'KsQdJcTh9h',
  'AsAhAcKcKd',
  '8s8h8cJd6h',
  'AsAcAdKh4c',
  'AsAhTsTh4d',
  'QcJc7c5c4c',
  'KhQhJcTh9c',
  'Ts9h8c7s6h',
  '4c4dTd9d7d',
  'AsKs5s4s2s',
  'QcQdAc9d7c',
  '8s8h8c8dAd',
  'AcKh8c5h4h',
  'AcJc8c6c4c',
  '9s9h9cTs3c',
  '7s7h4h4cAd',
  '2s2h2dAd7d',
  '3s3h2s2h8s',
  '9s9h7c7d5d',
  '9h9c9d7s7h',
  '7s7h7c7dJd',
  'QhQcQdTsTh',
  'TsTcTd9s2h',
  '6d5h4h3s2d',
  'QsQhQc6c2c',
  'QhQcAhKcJh',
  'AsAh6s6h7h',
  '4s4c7c6s3d',
  '6h6c6dJcJd',
  '8s8h8c8d5s',
  'JsJh7s7h9h',
  'AsAhAcJcJd',
  '8s8h8c8dQs',
  'JhTh9h5h2h',
  'QhQcQd2h2d',
  'AcKcQc6c5c',
  '3s3h3c3dAh',
  '6s6h6dAs4d',
  'ThTcTdKsKh',
  'TsThAhKs7d',
  '3c3dAc8h7c',
  'AcKdQcJdTh',
  '3s3h3c3d2c',
  'AhAc8s8hKd',
  'AsAhKcKdQc',
  '4s4h4dQh8d',
  'KsKhKdTh9s',
  'QsQhQdAh5c',
  '6h6cJs5h4h',
  '8s8dJd7c6d',
  '8s8h8d2s2d',
  'JsJhJdAd6s',
  'QcJdTs9h8h',
  'AcKcJc7c4c',
  'AsAh3h3cKs',
  'AsAhAc9s8d',
  '6s6h6cAh4c',
  'KsQhJc8h2d',
  'QhQcQdKsTd',
  'AhKdQhJcTh',
  'TsThTcKcJh',
  '2s2h2c8h8d',
  'JdTd9d8d7d',
  'JsJhAh6h4d',
  'ThTd8c7s3c',
  '6s6h6cAhAc',
  'KdQd7c4s3s',
  'AsAh8c7h3h',
  'AsAh8c7c3s',
  '6d5h4h3d2s',
  '5s5h5c7d6h',
  'KsKhKcKdAh',
  'QsQh9d7c2h',
  'QhJhTh9h8h',
  'AsKs9c7c6c',
  '2s2c2dAsKh',
  'QcQd4h4dJd',
  'JsJd9s9dQc',
  'QsQd6s6h5h',
  'KdQdJhTc9c',
  'AsAhAdKd6s',
  'JsJhJdTs3h',
  '7s7d5c5dTd',
  'Ts9c8h7s6s',
  'QcTd7c4h2s',
  'AsAhAd8c8d',
  'JsJd8s8d7d',
  'Ad5s4h3c2d',
  'TsThTdKdQd',
  'QhJd8d7d4h',
  'AsAhAcAdKc',
  'QhJd4c3s2d',
  '8s7s6s5s4s',
  '3h3dJc4s2h',
  '7s6s5s4s3s',
  '2h2c2dJcJd',
  'KsKhThTd7d',
  '5h5c5d9s4d',
  '6c5s4s3s2h',
  'AsAhJhJc5s',
  'Qs8d6d5s2d',
  '6h5h4h3h2h',
  '7c6d5d4c3h',
  '5s5dAh9h7d',
  'AcKhJd7c2c',
  'AdKhQcJdTs',
  'Ac5d4c3s2c',
  'AsAdTd6d5d',
  'KsQsTs8s3s',
  '7s7h7dJd5d',
  '7c6d5s4h3h',
  'Ac5s4c3s2s',
  'Ts9c8c7s6d',
  'As5s4s3s2s',
  '7c6c5c4c3c',
  'QcJhTs5c4h',
  'KsQs8s6s4s',
  '8h8c8dAs9c',
  '9h9c9d7s3d',
  'AsAhAcAdTd',
  '2s2h2dTs7c',
  'KsKh8h8c7h',
  'KcQhJc6c2s',
  '4s4h4dAsAd',
  '7c6c5c4d3c',
  'Ad5s4d3c2d',
  '9h8s7s6c5h',
  'Jd8h7d6c2c',
  '7h7cTc9s2h',
  '7s7cQsJhTh',
  '6s6h6c6d5c',
  'AhAdQdTd4s',
  'QdJhTd9d8s',
  'JsJdQhTd8s',
  'KdQdJd5d3d',
  '7h7cTh4d3h',
  'AsAh9s9h4c',
  'AcAd2h2c3d',
  'TsTh7s7h2c',
  'QhJdTd9h8s',
  'AsJs9s8s6s',
  '9s9h9dKsKh',
  '4s4c9d5d2h',
  '6c6dKhJs5s',
  '7h6c5c4h3s',
  '9s9h9cJsJh',
  'TsThTdJc5d',
  '6c5h4h3d2h',
  'JcTs9h8h7c',
  'QsTs7s5s2s',
  '5s5h5c5d9s',
  '9c8c7c6c5c',
  '9s9h9cAs2c',
  '5s5h5dAhKd',
  '2s2hKdQc3d',
  '7s7h7c7dQs',
  'TsTd8c8dAd',
  '6h5h4h3h2h',
  'TsThTdQdJc',
  '6h5h4c3s2h',
  'JdTh9d8s7h',
  'AsKcQh9h7c',
  'AsAh3s3h7d',
  '9h9c9dTcTd',
  'AcTc8c6c2c',
  'QsQhJsJh9h',
  'QdJdTd7d3d',
  'JdTd9d7d3d',
  '3s3dKcJh8d',
  '4s4h4c4dKh',
  'AsAd6c6d3d',
  '9h9cJcTc8h',
  'Ad9d8d7d3d',
  'AcTd9c4c2h',
  'AsAh7s7d6c',
  'AsAcAdKs9d',
  'QsQhQdTcTd',
  'ThTdJc8d5h',
  'JsJhThTc7d',
  '8d7d6d5d4d',
  'KsKhKd5s5h',
  '3s3c3dJsJh',
  'QsQh7s7dAh',
  'JhTs9c8c7c',
  'JhTs9h8s7c',
  '6h5d4s3c2h',
  'TcTd7h7cKc',
  '9s9h9c9d7s',
  'QsQcQd8c5d',
  'AcAdKhJc5c',
  '2s2c2dQdJs',
  'AsKs7s6s3s',
  'AsAdQcJh9s',
  '4s4h4dAhTd',
  'AsAhAcAdJc',
  'QcJcTc9c7c',
  'QsJs9h3c2h',
  'AdJd9h7d5s',
  'JdTc9c8s7d',
  '8s8h8c8dTd',
  'AsAdKsKd9c',
  '5s5h5c5d7s',
  'JsJhTsTdAc',
  'AhAcAd6s2h',
  '9s9hAdKs8s',
  '4s4hKcJc2s',
  'AhAcKcKd8d',
  'QhQd8c6c2h',
  'Td9d7d4d3d',
  'QcQd2s2hAs',
  '6d5c4h3h2s',
  'TsTcTd2s2h',
  'Ts8c4c3c2c',
  'QcQdTh7c4h',
  'KsJs7s4s3s',
  '9s9h9d5s5c',
  '9s8d7s6h5s',
  'KsKhKcKdTc',
  '4h4d9h7d3h',
  '8s8h8dAhKs',
  '8s8h8c7c7d',
  'JsTs9s7s2s',
  '5s5h5c5dJc',
  'AsTs6d3s2d',
  'AsKhQh9h8d',
  'AhAcAdTcTd',
  '9d8d7d6d5d',
  'KhKcKdJd3c',
  'AcAd7s4c2s',
  '8c8dAs9h6h',
  '8s8dAd9c2h',
  'TsTdAsKs5h',
  'Jh9h8h5h4h',
  '7c7d2s2dJh',
  'JhTs9h8h7h',
  'QsQcJsJh6h',
  'Jh9h8h6h4h',
  'TsThTd8s8h',
  'AdKdQcJcTh',
  '7s7h7c7d9h',
  'KsKd7s7hAs',
  '4s4hQhJd6c',
  '8s8h8c8dJs',
  '9h8h7s6d5d',
  'AsKh8s4s2h',
  'Js8d7d5s3s',
  '9h8s7s6d4h',
  '7h7c7dAd4c',
  '9s9h9d8h6s',
  'AhAc6s6h9c',
  '9h9c9dJsTh',
  'AdJh8c7s2h',
  'AsAhAd8h8d',
  'Ts8s5s3s2s',
  'AdKhTc6s4h',
  '2s2c2dQd3h',
  '2c2dQhTd6d',
  'As7s5s4s2s',
  'AhJhTh8h3h',
  'AsAh6c6dKd',
  '9h9c9dAcAd',
  'AhAcAdKd3c',
  'Kd6d5d4d2d',
  '9s9h9c9d4s',
  'AsAhTcTdKd',
  'Qs9s6s3s2s',
  '7d6d5d4d3d',
  'Td9d8d7d6d',
  '7s7h7c7dQs',
  'AhJd9c7d6c',
  '8s8h8dJhJc',
  '9s9dAc7h2c',
  'JcTc9c4c3c',
  'JsJhJdTc4c',
  'QsQhQcKc9s',
  'AhKd7d6c2s',
  '8s8h4s4h9s',
  '8h7h6h5h4h',
  'Kc9s6c5h3d',
  'Kd8d6d5d4d',
  'QsJsTs9s8s',
  'AdTd7d4d3d',
  'Th9d8s7c6s',
  '7h7c7d3s3h',
  '8s8h8c8dKh',
  'As6s5s4s2s',
  'KcQcJcTc9c',
  '2s2h2c8s8d',
  '8c8d2s2d6d',
  '3s3h3c3dAh',
  'AhKhTh6h5h',
  'Kd9d7d3d2d',
  'TsTdQdJd8c',
  'QdJd8d6d2d',
  'TsThTcTd6c',
  'AdKcQs5d2s',
  'JsJhJcJd8s',
  '5s5dAhJs9c',
  '8h8c8dAsTs',
  '2s2h2c8s8h',
  'AdKcQdJhTd',
  'KsJs9s8s6s',
  'JcJdTsThAs',
  'AsKsQsJsTs',
  '9c9d2h2c4c',
  'AsTs5s4h3d',
  'AsAhAc9h8h',
  '9s9h9c9d4c',
  'TsThTdAs8h',
  'AcKcJc6c2c',
  'JhJcJdTh6c',
  '3s3h3cAsAh',
  'TsThTc8s7s',
  'KhKcKd5s5h',
  '2c2dAh9d7c',
  '5h5c5d9h9c',
  'KdQhJdTs9c',
  'AdKhQs5d3d',
  '7d6d5d4d3d',
  '3c3dAh8d4d',
  'Ts9h8s7h6c',
  'AdKdTd8d4d',
  'TsThTd4c4d',
  'QcJc7c6c5c',
  '9s9c9d7h7c',
  '7s7h9s6d4d',
  'AsAhAd7s7d',
  '7h6d5d4c3h',
  'KhQhJhTh9h',
  'AsKdJh6s5c',
  'AsAhAcTsTd',
  'AsAh5s5hJd',
  'KsKhKcTh6h',
  '8s8hKcJs7h',
  '8s8h8dKhJd',
  '9h8c7c6d5c',
  '2s2h2d7h4s',
  'AsAhAcAdQc',
  'QdJd9d8d3d',
  '8c8dAcKs2s',
  'JsJhJcJd3s',
  'QsJs9s8s5s',
  'QsQhQcTc6d',
  'Ad5h4s3d2c',
  'QsQhQcAs4d',
  'JcJd7s7h2c',
  'JhJcJdQsQh',
  '7s7h7c3c3d',
  'AsAh4s4hKc',
  'TsThTdJc9s',
  'AhAdQsQd5s',
  'QdJdTd8d7d',
  '8c7c6c5c4c',
  '7s7h7c8s8d',
  '4s4dQs7h3c',
  'KsKhQcQd2s',
  'KhJd9d7d6c',
  '3s3d8c5h4c',
  'TsTh9s9d7s',
  '8s7c6c5s4d',
  '3h3cTs8h6h',
  'KdJh7c3d2c',
  'AsAhAcAd7h',
  'AhAcAd8c8d',
  'AsAh7h7d8d',
  'AsKs9s7s5s',
  'QsQhQcQdAd',
  'AcAd3c3dTs',
  'KdQcTc7s5c',
  'JsJhJcQs2d',
  'QdJdTd9d5d',
  '9h9c6d4d2c',
  '7s7h7dAdTc',
  'AhAcAdKcQc',
  'AhAd7c7d4c',
  'AsQsTs9s7s',
  'AsAcAd3c3d',
  'KhKd7s7h8c',
  '3h3c2s2hKh',
  'JsJhJcJd5d',
  'QsJs8s6s5s',
  'KdQhJsTd9c',
  'AsAhAdKh8c',
  '6s6h6c6d7s',
  '6s6h6c6d7c',
  '9c9d4c4d6s',
  '7h7c7dAh3c',
  'AsAh9c9dTs',
  'Ad5d4d3d2d',
  '9s9h9c9d2s',
  'TsThTcTd5s',
  'QsQhQdAs7s',
  'Ac8s7s6d5h',
  'AsAdKcQdTs',
  'QsQhQcQd3s',
  '9s9h9d7d4s',
  'JhTd9s8c7h',
  'As5s4s3s2s',
  'QsQhQcQd7d',
  'AsAhAcAd3s',
  'KhQcJh7c4h',
  'Qd9d8h4s3d',
  'KsKhKc6h6c',
  'QdJcTh9c8d',
  'AsAhTh8d4h',
  '9h8h7h6h5h',
  '7d6h5h4s3h',
  '3s3hKh8c4d',
  '7s7h7d9d6d',
  'KhKdJd6d4h',
  'AhJh8d4c2c',
  'JcJd8c4s3h',
  'QcQd5s5h9h',
  'JsJhJcJd4c',
  '9s9d7s7h3d',
  '7c6d5h4s3s',
  'KsQsJcTd9c',
  '4c4d2h2c7s',
  'AhAcAd7s7h',
  'KsKhJc9s3h',
  '3h3c3dAhAd',
  '6c5c4s3d2h',
  'KdJh5c4d3h',
  '9s8s7s6s5s',
  '3s3h3d6s6h',
  'JcJdQs8h5s',
  '9s9h9c4c4d',
  'KsKhThTd5s',
  '9s9h9c6s6h',
  'AsAhAcAdJh',
  'AhAc8s8c6s',
  '7s7h7c7dAd',
  '6s6h4s4d7d',
  'AhJhTh9h5h',
  'KsKhJc9d2h',
  'AsKsJsTs8c',
  'QdJc9s8h7c',
  '8s8h8c9s2h',
  '5h5c5d6c6d',
  '8s8h8cAsTd',
  '8s8hAc6c3c',
  '6h6c6dQd9c',
  'KcKdJsJd5c',
  'AsKs9s6s4s',
  'AhKd9h4h3h',
  '5h5c5d9c9d',
  'Td9d8d7d6d',
  'AhAd3s3h6d',
  '9h9c9d8c3d',
  'JsJhJcJd6s',
  'AsQs6c4d2h',
  'TcTdQdJd2s',
  'Tc9c8c7c6c',
  'JhTh8c7h3c',
  'JcJd9s9h7s',
  '7s7h7dAdKc',
  'KhTh7h6h5h',
  '9h8h7h6s5h',
  'JsJhJdAh6s',
  'QsQhQcQdAh',
  'JsTs9s8s7s',
  '7c7dAcTs8c',
  'AsAhKsQs6d',
  'JcTc7c6c4c',
  '6c6dKd7c4s',
  'AsAdKsKd9s',
  'QsQd2h2d7d',
  'AdJd9d3d2d',
  'QcQdTh5s2c',
  'JsTs4s3s2s',
  'QcQdJsJd8h',
  'KcKd7s7cAd',
  'TsThTcTdAh',
  '7h7c7dJh4d',
  '2c2dJh8h3h',
  '9c8s7c5h3c',
  'Qd9d6d5s2c',
  '6c5h4s3s2s',
  'AcAd7s7hJs',
  'AdKdJdTd7d',
  '6c5s4d3h2s',
  '9s9h9dJsJc',
  'AhKcQdJhTh',
  'AsAhAd7s7h',
  'Ad5d4d3h2d',
  'QhQcQdJdTs',
  'QhJsTh9h8h',
  'QhQcAc4h3s',
  'TsTh2h2d3c',
  'KcTc5c4c2c',
  '9h9dJhTs3c',
  '7s7hKc9d3s',
  '3s3h3d6s6h',
  'Ts9s8s7s6s',
  '5s5hAcQc3h',
  'AhKcQdJh5s',
  '3h3c3d9c4s',
  '6c5h4h3d2c',
  'JcTc9s8h7d',
  'As5s4d3d2c',
  'KsKhKcAc6h',
  'KcKd8c8d4d',
  'KdJsTs6d3h',
  '9c8h7c6h5d',
  '2s2h2c9d7d',
  '8s8c8dQhJc',
  '9s9h9cKhKd',
  'KhQh6h4h3h',
  'AhKsTs9d8c',
  '8s8h8d4c4d',
  'JhJcAcKs3h',
  '8s7d6d5h4c',
  'KhQs9c6c5c',
  '8c8dJc7s6s',
  '4s4h4c4dJh',
  'JsJhAsKh2c',
  'QsQhQdAs9s',
  'KhKcKd4c4d',
  'AdKhQhJcTc',
  'JsTs8s5s2s',
  'JsJhJc9s4h',
  '7h6d5d4s3d',
  'QsJsTs9s8s',
  'AsAhAcAd9s',
  'KsKhKd8c8d',
  '3s3d2h2cQc',
  'Ac5d4d3c2c',
  'JsJhJdAh2d',
  '6c5c4c3d2d',
  'Ad5s4h3d2h',
  'QsJs7s6s4s',
  '7h6c5h4d3s',
  'AsQsJs6s3s',
  'KcKdTd9d7s',
  '2h2c2dAs8h',
  '6s6hJh8s5d',
  'AhAcAdKhKc',
  'AhAcAdJcJd',
  'AsAhAcKcJc',
  '8s7d6s5h4h',
  '6c5c4c3d2c',
  'KcKd8c8d6c',
  'AhKdTs4s2d',
  'QsJs9s7h3c',
  'ThTcAd6c4s',
  'JsJh4s4hKd',
  'QsJs9h7h5c',
  '2h2cAcKh8s',
  'QsQhQcTsTh',
  '4s4h4c4dTh',
  'KhQhJhTh9h',
  '7s6h5c4d3d',
  'AhKdQsJhTs',
  '8h8cAsKd4h',
  '6s6h6cAcAd',
  'QdJdTd9d8d',
  '6s6h6c5c4c',
  '7s7h7c7dQd',
  '3s3h2h2cKs',
  'JsTs8s6s5s',
  '9s9h9cAsAh',
  'JdTs9c8s7d',
  '4s4h4cAh6h',
  'TcTd9c9d6h',
  '9s9h9cQh7c',
  '9d8s7d6s5h',
  'KhKcKdAc8c',
  'QdJdTd5d3d',
  'TsThAs3d2h',
  '6d5d4d3d2d',
  'AdKd5d3d2d',
  '8s8h8d9s2s',
  '7s7h7c7dAh',
  '8h8cKh3h2d',
  'JhTs9c7s6s',
  'AsTs6s5s3s',
  'AsAh9c8d2h',
  '7s6d5s4c3d',
  'AsAhAd9c9d',
  'QsJsTs9h8c',
  'QcQdJcJd4s',
  'QsQhQcQd2d',
  '7s7h2s2dQh',
  '6s6h6c6d3s',
  '3s3h3d9s9h',
  'AsAdQsQh9c',
  'QsQhQcQdKh',
  'KsKcKdQd9s',
  '9h8c7h6s5c',
  '5s5hJd9s7c',
  '5s5h5cAsKc',
  'AdKdQd7d5d',
  '6s6h6cAc5h',
  'Td9h8s7d6d',
  'TcTd3c3d8c',
  '6s6h6c2c2d',
  '6d5c4h3d2s',
  '3s3c3dAcAd',
  'AsAc7s7hJh',
  '9d8s7d6c5c',
  '6c6dAcKd4h',
  'AsAh5h5cQs',
  'Ts9d8c7h6d',
  'KhKcKdJd4h',
  'Ac8c4c3c2c',
  'AsAcAdJsJc',
  'QsQhQd8s4d',
  '7s6h5s4d3d',
  'AsAhAcAd5s',
  '6s6hKc7s2d',
  'JhJdTh7c6h',
  'QsJsTd9h8h',
  'TsTcTd5d4d',
  '7h7c7dQd5c',
  'AsAhAdJd3c',
  '9s9h9c9d3d',
  'JcJdKhQs4d',
  '8s8h8c8d3s',
  'QhJh9s5h3h',
  'AcAd7c7dKs',
  '2h2c2d4h4d',
  '2s2h2c2dTh',
  'TcTd9h9c5d',
  'KhJc6d5c4d',
  '7s5c4h3s2c',
  'AcKcQcJc4c',
  'QhJcTs9d8h',
  '7s7h7cAdJc',
  'Qs9s6s4s2s',
  '4s4hQs8d7s',
  'QhJh9c7h3c',
  '9d8s7c6h5d',
  '9s9d2s2cKc',
  '5s5hTs7d4c',
  'KsKhKcKd8c',
  '5h5c2c2d8s',
  'KcQcJdTc7d',
  'Jc8h7d5c4d',
  '9c9dAcJh8s',
  '2s2h2d9h5d',
  'ThTcTdJcJd',
  'Th9h8c7c6d',
  'JdTc9c8d7s',
  '8s8dKdQc9d',
  '5s5hAhKh8d',
  'JdTs9d8h7s',
  'AdJd8d7d2d',
  'AsAh8c8d7h',
  '7c6c5s4c3d',
  'AdTd7d4d3d',
  'Ac7c6c4c3c',
  'KsQsTs8s5s',
  'AhTh9h6h5h',
  'KcKdJhJcAs',
  '7s7h7cJcJd',
  '5s5h5c5d7d',
  '3s3cAdKc9h',
  'Ad5d4c3h2h',
  'AhTs9c7s4d',
  'Ac5s4d3h2h',
  'AsAdQsTd8h',
  '7d6d5d4d3d',
  '7s7h7dQs2d',
  'QsJs9s7s3s',
  'AhKsTh9h4h',
  '8s8h7s7hKd',
  'JsJhJdQc8c',
  'TsTc6s6hAc',
  '9s9h9c9d4c',
  'QdJh6c5d3d',
  'AsQsJs7s6s',
  'KhTh9h6h2h',
  '6c5s4s3h2d',
  'QhJh8h7h4h',
  'As5s4c3h2h',
  '7s7c7dQsQd',
  '7h7c7d9s4c',
  'QcJhTs9s8s',
  'JhTd9s8s7d',
  'Ts9s7s5s2s',
  'AsAhAdQd7s',
  'QcJsTd9s8d',
  'JsJhAcQsTh',
  'QcQdKsTd7c',
  'KcJc5d4s3s',
  'Qh9h8h5d2h',
  'JhJcTcTd5h',
  'KcQcJc5c3c',
  'KcQsJhTd9d',
  'TsThTcAd3h',
  'AsKsQsJs2s',
  'JsJhJcJd6d',
  '4s4h4dAc9h',
  'AsKsQsJsTs',
  'QdJd8d5d2d',
  'KcTc6c3c2c',
  'AsAd2s2dKc',
  'TsThTcTd8h',
  '9s9h9c9d3s',
  '3s3h3c3dJh',
  'QsJs8s4s3s',
  'AcAd8s8cKs',
  'JsJhJcJdAh',
  'AcKdQhJcTs',
  '9h8h7h6h5c',
  'KdQsJhTd9c',
  'AsAhAcAd9s',
  '7s7h7c7d6c',
  '3c3d2s2dJs',
  'JsJhJcTc9d',
  'AdKdQd5d3d',
  'KsQs9s8s2s',
  '4s4c4dAcAd',
  '9h9cJh7c5c',
  '3s3h3c3dAd',
  'KsKhKdJc6c',
  '8s8dQdTd3h',
  '9s9dKsTh6h',
  '9c9dAs6d5d',
  'JdTd9d8d7d',
  '2s2h2cJh8d',
  'QdJs9h6c2d',
  'AsAh9c9dQc',
  'KhKdQsQh2d',
  'JsJhJcQd6d',
  'JsJh5s5dAd',
  'AsKsQdJdTd',
  'AcKdTc5s2d',
  '8s7s6s5s4s',
  'KdQd8c7c4d',
  'Tc9d8d7c6s',
  'AsAh7d6d2d',
  'QcJhTs9h8c',
  'AsJsTs9s5s',
  'KsKh8c8dJd',
  'AdJd5d4d2d',
  'ThTcTdAdKd',
  'QsQhQc2s2d',
  'KhKdQsQcTd',
  'Ts9s8s7s6s',
  'QhQcQdTcTd',
  'Js9h8c7h4d',
  '8s8hAcTc4d',
  '2s2h2dKsJc',
  'AhQhTh8h2h',
  'AsAdJhTd9s',
  '5s5h5c5dTd',
  '5s5d2h2c4d',
  '7c7d3s3d2s',
  'KsQhJsTh9s',
  '4h4c4dAdKs',
  '4c4dAhQd9c',
  'KdJd8d4d3d',
  'Ad5s4h3s2h',
  'JcJd3s3d5c',
  'Tc9c8c7c6c',
  '6h6cQcJd2c',
  'Th9d8d7c6d',
  'QhTh8h6h2h',
  'QhQcQdAc8s',
  'Ac9c8c7c5c',
  'QcJsTc9h8s',
  'KsTs9s3s2s',
  'QhQcQdAcTs',
  'JcJdThTc4d',
  'QsQcQdThTc',
  'Ad9s8h5d2s',
  '4h4cAcJd7h',
  'QsJhTh7d4h',
  'QsQdJcJd6s',
  'AsAhQsQh7s',
  '8h8c8dAhAc',
  'AsKsQsJsTs',
  'AhAc9h9d2s',
  '6s6hTh9h8c',
  '5h5cAc4d3s',
  'Ac8d6s5c3s',
  'AhAcAdKh6c',
  'KdQd8d5d3d',
  '4s4h4c4dTc',
  'AsAdKcKd5c',
  '8c7s6d5c4d',
  '7s7hAcKcTd',
  'QsQhQcQd3h',
  '2s2h2d5s5d',
  '7s7h7cJhJd',
  '5s5h4s4d7s',
  '8c7c6s5d4c',
  'JsJd7s7d6c',
  'QhJhTh8h5h',
  'As5s4d3s2d',
  '3s3h3dQsQh',
  'KcKdJhTh7c',
  'QhJcTd9s8s',
  'QsJdTc9s8h',
  '8s8h8c8d6d',
  'JhJcJd9s9h',
  'KsQsJsTs9s',
  'QhQd2s2c5s',
  'As5s4s3s2s',
  'KsKhJd8h4c',
  '7s7h7d9s5d',
  'AhKc9s8c6d',
  '8h8c8dAs5h',
  'QsQhQcAdKd',
  '6s5h4c3s2h',
  'AhAcAd7h4s',
  'QsJhTs9c8h',
  '8s8h8c6s6h',
  '9d8h7s6s5d',
  'AsAcAd7h7d',
  'AdKd5d4d2d',
  'JhJd8s8dAh',
  '8c8d7h7d9s',
  'AsAhAdQhQc',
  '8s7s6s5s4s',
  'KcJc9c7c2c',
  'AhAcAdJsJd',
  'KhKcQcQd7h',
  'KsKhKcTc8s',
  'AhKs9d5c3s',
  'AsAhAc9c9d',
  'Qd7d4d3d2d',
  'Kd9h7d4h2h',
  'JsJcJd6s6c',
  'JdTh9h8c7c',
  'QhQcTs6h5c',
  '7s7hAs6d5c',
  'TsThTc3s3h',
  'QsJs5s4s3s',
  'QhJd9h4c2d',
  'AhAcAdTh5h',
  'AhAcAdTc9s',
  '2s2h2c2d3s',
  'QsQhQdAcAd',
  '4s4h4c4dJh',
  'TsTcTdQd6c',
  '8h8c8dTd3d',
  '9s9d2c2dTs',
  '6h6c6dKcKd',
  '7s7h7c7d6s',
  'AsAhAdKs8c',
  'QsQhQdJs4s',
  'KhKcKd2s2d',
  'JsJhJdQhTd',
  'KhQhJsTc9c',
  'JcTc9c8h7s',
  'TsThTc9s2c',
  '7s7c7dAh5d',
  'AhAdKd3s2c',
  'KsKhKcKd2d',
  '7s7h7cAsAc',
  'AdKdQd7d5d',
  '8s8h8dQsQc',
  '8s8h8c8d4d',
  'JsJhJdQd9d',
  '9s9h9cTsTc',
  '2s2h2c2d3c',
  'KsKhKcJdTs',
  '5h5c5dKhKc',
  'KcKd3c3dAc',
  'AdKsQcTh9d',
  '9s9c9d5s5d',
  'AdQdJd7d6d',
  'AsAh9d7h6c',
  'QdJdTs9s8h',
  '6s5s4s3s2s',
  'AsKdQhJdTc',
  'AsAhAc7c6d',
  'QhQd9d7s4d',
  'AsAhAdThTd',
  'AsKs8s7s2s',
  'JcTc8c5c3c',
  '6s6h6c6d9s',
  'AdKdTd9d6d',
  'JsJhJdAs2h',
  '8h8c8dKcJd',
  '3s3h3dAdJh',
  'Js9s7s5s4s',
  'AhAcAdKhKc',
  '9h9dKd6c4h',
  'AsAhAcAd8h',
  '5s5h5cAsAh',
  'AcKh7d6s2h',
  'Ac9c8c7c4c',
  'AhKc9h6h3c',
  'AsAcAd9h9c',
  'TsTc8s8d4h',
  'JdTh9d8d7s',
  'AsKsQs4s2s',
  'JsJhJcJdAd',
  'KhKcKd2s2d',
  '6s6cAc5h4c',
  'KsKhTcTdJc',
  '6h6c6d8c5d',
  'Qc6c5c3c2c',
  'AsAhAd7h7d',
  'AsAhKh6d2d',
  '3s3c3dAdKh',
  '8s7s6s5s4s',
  '8s8d2s2h4c',
  'KsQsJsTs9s',
  'AsAhAcKcQh',
  '9h9dQh7d6d',
  'AsKhQs5s2h',
  'QhJcTs9c8s',
  '3s3hKsTc7d',
  '2s2h2c5c5d',
  '8h8c9s3s2h',
  'AdKdQdJdTd',
  'AsKsQsJs5s',
  '7h7c7d2s2h',
  'Qd8d7d5d4d',
  'KsKhKcKd3s',
  'QdTd7d6d4d',
  '9s9hQd6c2d',
  'QsJcTh9h8h',
  'QhTh5h4h3h',
  'QsQhQcQdJh',
  'JsJh4s4dTs',
  '4s4h4c4d6c',
  '5s5h5c5dQd',
  '8h8c8dTc6h',
  'QsQhQd2h2c',
  'AhAcAd9s9d',
  'QsQhQd5c2c',
  '9s9d5s5hKh',
  '9s9d8h8dTh',
  '9h9dAdKcQc',
  'KsKhKcKdTh',
  '9s9h9dJs7c',
  'AhTh7h4h2h',
  'AsAhAc6s6d',
  'AcTc8c7c6c',
  '7s7h7c7d8d',
  'KsKhKdQh6s',
  '4s4h4d7s7h',
  'AhJc9d8s6c',
  '9s8d7h6s5c',
  '6h5h4h3h2h',
  '7s7h7c7dAh',
  'JhTs6s4c3d',
  '8d7h6d5c4d',
  'AsAhAcAd8c',
  '9c8c7s6s5d',
  'Td9d7d6d3d',
  '2h2c2dKsKh',
  'KsJs9s7s5s',
  'QsQhQcQdAh',
  '8h8c8d3d2s',
  'AsJh8c6h5c',
  'AcKhQcJsTs',
  'QcQd9c8s5c',
  '9h9d5s5hQs',
  'As7s6s4s3s',
  'KsKh7s5c2s',
  'KcQcJcTc9c',
  'Ks7d4h3h2h',
  '6s6h6c6d4h',
  'ThTcTdJd7c',
  'JsJh5c5d7c',
  'AhJhTh3h2h',
  '8h8d2c2d5h',
  '8s8dKsJsTc',
  'AsAd9d8d6s',
  'AcAd3h3c7s',
  'JsJh8s8h5c',
  'AsKs9s7s3s',
  '7s7h7cJh5d',
  'Td9d8s7s6c',
  '2s2h2c2d9h',
  'AdQdJdTd2d',
  '9h9c9dQh8d',
  'AsAhAcAdKh',
  '9s9d5s5hJh',
  'QhJsTs9h8s',
  'TsThTcTdKd',
  'JdTd9d8d7d',
  'Ad5c4h3d2s',
  '9s9h9dAhAd',
  'KsQs9s6s4s',
  '4s4h4dAcAd',
  'AcKc8c7c5c',
  'AhKcJd7s6c',
  '7s7hJhTd3h',
  'AhAcAdTs2c',
  'AhKcQc8s5h',
  'KsKhQsTd3h',
  '5s5hKcTd9c',
  'Ac5h4h3c2d',
  'AhAcAd2h2c',
  'Qc9d5s3d2d',
  '7h6h5h4h3h',
  'TsThTcTd5c',
  '3h3c3d9s4d',
  'AsAhAcTsTh',
  'JsJhJcJd6h',
  '6s6h6c6dQh',
  'QdJcTd9c8s',
  'TsThTcTd7d',
  'AsAhTcTd3s',
  '6s6hTh9d2c',
  'AdJd7d5d4d',
  'KsKhKcKd9s',
  'Ts9c8s7d6h',
  'KsKh8c8dQh',
  '2s2h2c4c4d',
  '9d8c7c6c5c',
  '9s8h7c6c5s',
  '3s3h3c3dJc',
  'TsThTcTd7d',
  'AhAcAdJc6d',
  '7s7h7c7dQs',
  'ThTcAdQs4c',
  'JsTh9s8h7d',
  'QsTs7s6s2s',
  '9s9h9c9dTc',
  'AsAhAcAd9d',
  '7c6d5s4c3c',
  '8s8h8dTd9d',
  'KsKh5h5dAc',
  '2s2h2c2d5c',
  'Js8h6h3d2h',
  'QcJcTc9c8c',
  'JsJh7h7d4h',
  'QhQcQdJd4c',
  'QsTh9s8c5h',
  'KhQhJs8h4s',
  'AsAhAdJd6h',
  'AcQc9d7d5s',
  'AdKs9h7h2s',
  'AcKc9c7c3c',
  '9s8d7h6d5s',
  'KsKhQs6c2h',
  '3c3dJs8h4d',
  'TsTd7s7h3s',
  'QdJhTh9d8h',
  'JsJhJcJd6d',
  'AdKcTh6d3c',
  'QdTs8d7s5c',
  '6h5d4d3s2c',
  'ThTc8s8h7c',
  'AcKhQd9d4c',
  'Td9d8c7h6c',
  '4s4hAhJdTh',
  'JsTs9s8s7s',
  'Qs9s7s3s2s',
  'ThTcJh9h6h',
  'Jd9c8d5c4h',
  '7d6h5s4c3d',
  'QhJsTc9h8d',
  'AsKhQsJcTh',
  '4h4c4dAcJd',
  'QcQd7c7dAd',
  '8s8h9s3s2d',
  'AsAhAcAd6d',
  'JdTd7d5d4d',
  'QsQhQcQd4h',
  '9h8s7h6h5s',
  'JcJd5c5dKs',
  'QhQd7h7dAd',
  '8h8c8d7c3h',
  '7d6d5d4d3d',
  'QsQhQc9h4h',
  'KhQhJhTh9h',
  'Ah5c4c3d2d',
  'JhTh8h4h2h',
  'QsQhQc7h7c',
  '6d5d4h3s2h',
  '3s3h3dAdTh',
  'Jh8h7h5h3h',
  '5c5d4s4h8h',
  '8s8h8c8d6h',
  'TsThTd8d2c',
  '9c9d2s2hAc',
  'Ac5s4d3h2h',
  '5s5h5cAd6d',
  'AcAdTs9h5d',
  '6d5d4d3d2d',
  'AcKsTc8d3d',
  '8s8hAsKh3s',
  'KdQhJc4s3s',
  '9h8s7d6d5h',
  '3c3d9s8s5h',
  '4s4h4c8c8d',
  'JhJcJd8c7s',
  'JhJd9s9h5d',
  '9c8c7c6c5c',
  'KcQcJdTh2c',
  'JdTs8c5d3s',
  '8s8h7c7d5c',
  '3h3c3d7s7h',
  'KdQdJcTh6h',
  'AcKcQcTc9c',
  '7c6c5c4d3h',
  'JsJhJd7d4d',
  'QhJd7c6d3h',
  '8s8hAdKd7c',
  'AsKs9h7h3s',
  '5s5h5cKcKd',
  'AsKh9h7s2s',
  'AsAc2s2d9s',
  'QsQhQcQd7c',
  'TsThTcTd4c',
  'AsAd4s4h3d',
  'AsAhAcAd7h',
  '7h7c7dJsJd',
  'AhAcAdKcKd',
  'AsKsTs6s4s',
  '7s7h7c7dAs',
  '9s9h9c9dQs',
  '4s4dJd8c7s',
  'AsAh6h6dKd',
  'QhJsTd9c2s',
  'KsKhKdTcTd',
  'KsKc8s8hAc',
  '8s8h8c8d7c',
  '4s4d9s7s3s',
  'QsJsTs9s8s',
  '6s5c4h3d2d',
  'Ts9h8d7h6c',
  '3s3h3d2s2c',
  '2c2dQd8d7c',
  'QsQh2s2hAc',
  '6s6h6c7h4d',
  'AdKdJd8d6d',
  'TsThTcTd7s',
  '9c8h7h6d5d',
  'AsAhTs9c5h',
  'AhKd7s4h2h',
  '2c2dQdTh5s',
  'AdKh6c3h2d',
  'Tc9c8c7c6c',
  'QhJhTh8h7h',
  'QdJd8h4h2h',
  'As5s4s3s2s',
  'KsKhKd6c3d',
  'KsKhKcQs7s',
  'AdKcQdJdTc',
  'As9s7s4s2s',
  'AsAhAcAd9h',
  'AhKcQhTc8d',
  'AdKhQh7s5c',
  '7s7h7c7dJc',
  '2h2cKc7s3s',
  'AsAhAcAdJc',
  'AcKcQdJh4h',
  'AcKs9h5s3c',
  '4s4c4d7c2d',
  'Qc8h6s3h2d',
  'AhJs9s6d2c',
  'AdJdTd8d3d',
  '8s8h8c8dQh',
  'TsThTcAsAh',
  'QsQc7s7dJh',
  'KcQsJh9h4c',
  'KdQdJcTc9h',
  'JsJhJc6h6c',
  'AhAdJsTd5h',
  '6s5d4s3c2d',
  'QsQhAdKh2h',
  'AsKs8c6d3h',
  '8s8h8c8dAc',
  'AsAhAcKdQc',
  'AsJc9s6h5s',
  '8h8c8dAcKh',
  'JhJcJdTd2d',
  'AcKc8c7c2c',
  'Qd8s7d4s3s',
  '8s8h8cQh2s',
  '9h9c9d6c6d',
  '9s8h7s6h5s',
  '2s2h2dJsJd',
  'KsKhKdTs6s',
  'AdKd9d7d3d',
  '2s2dQdJc4s',
  '8s8h8c8dAs',
  'QsQd7s7dAd',
  '8h8d2h2dJd',
  '3s3dKsTs2s',
  'KhKd8s8hJh',
  'JhTd9s8d7c',
  '4s4h4c3s3h',
  'KdTs7c3d2s',
  '2s2h2c2d4d',
  '6h6cAs3c2s',
  'QcJsTc9s8h',
  'QsQhQcQd6h',
  'JhJcTsTd9c',
  'JhTc9s8s7s',
  'AcAdKsKd7c',
  '3s3h3c9s9h',
  'AsAhKsQd5s',
  'KhKcTs8s5h',
  '9s9c9dAsAh',
  '4s4h7s6s5s',
  'KsKh8c8d7h',
  'QhJcTc9s8s',
  'AsKcQsJdTc',
  'AsKc9d7h3h',
  'JhJdKsQcTc',
  '9h8h7h6h5h',
  'AsKcQsJdTd',
  'JhJdTcTdQh',
  '8s8h8cAsAd',
  'Th9s8s7d6s',
  'Ah9d8s6c4c',
  'AhKh9s5c4s',
  '9h9d5s5h6d',
  '8h7h6c5h4d',
  '5s5h5c8c8d',
  'KsKhKd9s9h',
  '7s7h7c7d8s',
  'Th9d8d7h6c',
  'QcTc7c4c3c',
  '9h9c3h3c7d',
  '5s5h5d8s3d',
  'AsJs8s4s2s',
  'TsThQd9h3h',
  'AsAhKd6h3d',
  'JsJhJdTd7c',
  '9s9c9dQs4d',
  'KcQc7c6c5c',
  'JhJd8s8hQc',
  'AsAcAdKh9h',
  'JhJdKhTc8d',
  'QhQcQd9d3d',
  '6s6h6c6d4c',
  '9s9hAd7d4s',
  'Qs7s6s4s2s',
  '2s2h2c6d3h',
  'TsTh4c4dAd',
  'AsAcJsJhTh',
  '7s7cQhJs4h',
  '5s5c5dJd2c',
  '2s2c2d9s9h',
  'QhJh8h7h4h',
  'QsQcQd3s3h',
  'As9s6h5h2h',
  'QhQcAs5h2h',
  'AsAhAcAdKs',
  'AcKcJh5h4d',
  '9s9h9d6s4d',
  'AhQhTd7c4d',
  'AsAhKhTh5d',
  'AdKdQd3d2d',
  'AcAd2h2c9c',
  '6c5s4d3h2c',
  'QsQhQcTd2c',
  'JsJhJdTc5h',
  'AhKsQcJsTd',
  '2s2c2d7c7d',
  'AsAhAcQh3d',
  'As5s4s3s2s',
  'AdKdQd4d3d',
  'AsAhAcKcTc',
  'AsKhJhTd7h',
  'QsQc8c8d5c',
  '7h7c7dQsQh',
  'AcQcJc7c2c',
  '9s9hKdQdJc',
  'TsThTcTdAs',
  'JdTc9s8c7h',
  'QsQhQd3c2d',
  'JsJhJcJd3d',
  'TsTh6s6hKd',
  'QhQcQdJcJd',
  '2s2h2c5c5d',
  'AcKcQc4c2c',
  '9s8h7d6c5d',
  'JhJcJdQsTd',
  'QsJdTc9h8d',
  'KsKcKdAsAh',
  'As5h4h3s2d',
  '7s7h3s3dTh',
  'Ad9d5d3d2d',
  'AsAhAd7s7h',
  'KdQdTd4d3d',
  '4h4c4dJc6s',
  '2c2dJs9d8h',
  'KsKhKd2h2d',
  'QdJhTs9h8c',
  'JsJhJd7c2h',
  'AdKh9d7s6s',
  'Ts9d8s7c6d',
  '7s7h7c8c4h',
  '7s7dTh3d2c',
  'JsJd8s8h4d',
  '9s8s7s6s5s',
  'ThTcTdJd6d',
  'JsJhAhKs3h',
  'Js8c6h5h3c',
  'TsThTcTd9h',
  'AsAhAcAd6c',
  'AdKc7d6d2h',
  'JcJdAs9s3c',
  '2h2c2d6s5s',
  '7s7dAhJs2s',
  'JsJhJc2s2d',
  '5c5d2s2h8c',
  '6s6h6c6d5c',
  '8c8d7c7d6d',
  'KsKd6c5c2s',
  'AdKdQd9d3d',
  '9s8s7s6s5s',
  'AsAhKsKh6c',
  '7s7h7c7dJh',
  '3s3h3d8d4d',
  'KhKc9s9h5s',
  '7s7h7dAs2s',
  '6s5s4s3d2s',
  'KcQcJhTc9c',
  '7s7h7c7d2h',
  '6c5c4c3c2c',
  'JsJhJcJd4s',
  'ThTcTd6s6d',
  'KsQdJsTh9c',
  'JhJd6h6cAs',
  '7s6s5s4s3s',
  '6h6c6d8s8d',
  '9s8s7s6s5s',
  '6s6h6dAcKd',
  'AdQdJd4d2d',
  'AsQs9s8s7s',
  'JsJhJc9s9d',
  '4s4h4dQhJh',
  'Kd7d4c3h2d',
  'KcKd2s2dJc',
  '6s6h5h5d4h',
  '7s7dJd6h3h',
  'KhQs9s8d7s',
  '6c5d4d3c2s',
  'JcJdQhTh6c',
  'QsJdTh9d8s',
  'QhQcQdAsAd',
  'Qc8c7c5c3c',
  '7c7dKdQs6c',
  'Qd8h7s5s4c',
  'AsAhAdKsKd',
  'JsJhJcJd6h',
  '6h6cAd8h3h',
  'AsAhAd6s6h',
  '8c7h6d5d4h',
  'Th9d8c7c6s',
  'KsKhJd6c4c',
  '8h7c6d5c4c',
  '6s6h6c6dJh',
  '3s3h3c3dKh',
  'AsAhJs8d4h',
  'Ad5d4d3d2d',
  '6s6h2s2d5c',
  'AcKdQhJcTh',
  'As5s4s3s2s',
  '6s6h3c3d9d',
  'Ad5h4c3h2d',
  'JsJhAdTd5c',
  '2s2cQd9h6c',
  '7c7dKc8s4h',
  '7h7d2s2h6d',
  'AsKcJh8d2d',
  '9s9h9c9d7d',
  'QsTh8h5h2h',
  'AcAdTcTd5s',
  '2c2dKsQc7h',
  'AdQd8d7d4d',
  'TsThTcTdAd',
  'TsThJh7h6h',
  '6h5d4h3h2h',
  '9h9dJhTd8d',
  'Jd9s8c7d3s',
  '8s8h8c8d9d',
  '6d5d4d3d2d',
  'QhJsTc8d5h',
  'AhAcAdJsJd',
  '8d7h6d5h4h',
  '3h3dKc9c8c',
  'TsThTdAsAh',
  'KhKd3c3d8s',
  'KcKdAh9c6d',
  'QcQdJsJd5c',
  'KhQcTd6s5h',
  '7h7c7dAhJh',
  'AhAcJsJh8c',
  'AdKhQd5s2c',
  '8s8h8c6d5h',
  'AsAhAcAd6h',
  'ThTc8h8d6d',
  'QsQhQdKsKd',
  'QsJsTs7s4s',
  '7s7hAc6d3c',
  '6s6h6cQcQd',
  'AhAcAdKsQh',
  'QcTs8c5s3h',
  '4s4h4c4dJh',
  'KsKhKcKdQs',
  '8h8cAh6c5h',
  '4s4h4cAhKh',
  'QsJdTc9d8h',
  '9s9h9c9d7d',
  'JsTs8s5s3s',
  'Th9h8h7h2h',
  '8s8h8c8dKs',
  'KsQsJcTc9c',
  'QhJdTh9c8c',
  'AcKsQhJhTs',
  '9s8s7s6s5s',
  'AsAhAcAdQs',
  'AsAhQsQhKs',
  'KcKd6s6h2d',
  'ThTdKcQd3c',
  'AcKsQdJdTh',
  'KsKh4s4hJh',
  'JsJcTs8d6c',
  'QsQhQcJs3s',
  '7s7hAhQs9h',
  'AsKhQsJcTs',
  '9s9h9c7c7d',
  'Tc9h8h7h6d',
  '9s9h9c8s3c',
  'TsThTcTd3s',
  'AsAhAcAdTh',
  'AdKdQsJhTs',
  '9h9d8h8cAd',
  'As9s7s6s4s',
  'Td9d8d7d6d',
  'Ts9d8s7c6s',
  '9h9c9d7h3h',
  '8s8h8dJd2s',
  '5s5h5d6c3s',
  '4h4cAcKh2h',
  '4s4h2s2hQd',
  '6d5c4c3c2c',
  '9s9h9c9dJd',
  'QsQdTc9s5h',
  'AsAhAcAd6c',
  'AsAhTsTd8c',
  'KdQdJsTc9s',
  '5h5c5dAhKh',
  'AhAcAd9d4s',
  'KdQcJcTc9s',
  'JsJhJcJdTd',
  'AsAdThTdKc',
  'TsThTcTdQh',
  '7c6d5s4h3s',
  '9s9h9c8h6s',
  'AsAcJsTd2d',
  'AsAhAcKdQd',
  '9s9h9c9dAs',
  'AhAcAdQc7h',
  'AsAhAdKh9c',
  '5s5h2s2dTh',
  '8s8h8c8d5h',
  '3s3h3d7h7d',
  '9s9c9dQd6s',
  '4h4cKhQh9d',
  '8h8c8dJsJd',
  'QsJsTs4s2s',
  'JcTs8h7s6c',
  'JcTc9d8c7h',
  'ThTd6h5s4c',
  '8c8d3s3dKc',
  '7h7c7d8c8d',
  '7s7c7dAcAd',
  '5s5c5dKs6s',
  '2h2c2d5s5c',
  '5s5h8c7h6s',
  '9s9hQdJh8d',
  'Td9d8d7d6d',
  'TsThKcJd2d',
  'AsJs7s5s4s',
  '4c4dJc8s6h',
  'JsJhJcJd8h',
  '6s5s4d3d2c',
  '7h7c7dAcAd',
  'JsJhJcJd8s',
  'KsJs7s5s4s',
  '3s3d2s2hAh',
  'AdKdQd5d4d',
  'As9s8s6s5s',
  'QsQhQcQd7c',
  'JdTd9d8d7d',
  '2h2c2dAhAd',
  'QhJcTs9c8d',
  'JsJdKsQd7s',
  'JcJd9s9d7c',
  'QcJsTh9h8d',
  '9h9c7s7hTh',
  '3s3dAc8d5c',
  'AsKsTs9s8s',
  'KdQcJsTh9h',
  'AsAdKsQc8h',
  'JdTd9d7d6d',
  'Jd9d8d6d2d',
  'AcKcQsJcTs',
  'JsJd3s3h5d',
  'AsAhAd7d5h',
  'JsJh8c8d4d',
  'JhTh9h8h7h',
  'AhAcAd6c6d',
  '4s4hJc7s5c',
  '8h8dAhTd2c',
  'JsJh3c3d2h',
  '9c8s7d6c5c',
  'QsJcTc9s8c',
  'KsKhKc4d3c',
  'As5c4s3c2h',
  'QhQcQdAd7c',
  '6s6dAdJh8h',
  '9c8c7c6c2c',
  'AsAhAdQd5c',
  '5s5h5c5dJh',
  'AhAcTs6d2s',
  'KsQsJs9s4s',
  'Ad8d5d4d3d',
  'JdTc9d8d7c',
  'KsKhKc6d2c',
  '6s5c4s3c2d',
  '3s3hTs9s8c',
  'JsJhJc5c4d',
  'AcQh8c7h5c',
  '6h6c6dQh7s',
  '2c2dQhJc7s',
  'QsQhQcQdAh',
  '7h7c7dJs6h',
  '4h4c4dAc2s',
  'Ts9d8h7h6h',
  'AsAhAcTcTd',
  'AdKcQdJdTd',
  'ThTc3h3c7d',
  'AsAhAc2s2h',
  'AsAhAd7d6h',
  'KsQhJdTs9h',
  'As5c4s3c2d',
  'AsAhAc9s9d',
  'AsAhAcAd2h',
  'TcTd5h5c6h',
  'AsAhAcAd6d',
  'KsKhKc3h3d',
  '8d7s6c5s4c',
  '8s8h8dKcKd',
  'Js9h5s4d3s',
  'AhKdQdJcTd',
  '9c9d8d4s2d',
  'QsQhQcQd7h',
  '9s9hKcQd2s',
  '8s8h8c8d3d',
  'AsAhAd6c6d',
  '2s2h2c2dQs',
  '6s6hJhTh7h',
  'JsJhJdKsKh',
  'AsAc7s7h8d',
  'JsJh5c5d3d',
  '7s7h7dAcAd',
  '8h8c8dTc6c',
  '3s3h3c8s8h',
  'QsQhQcQd9d',
  'KdQdJcTh9c',
  'JsJhAdTd3h',
  'QcJcTd9d8h',
  '3s3h3c3d7h',
  'KdQd8d6d4d',
  '2s2h2c2d5c',
  '8d7d6d5d4d',
  'QcQd2s2h9c',
  'AsAh9h9c5d',
  'AsAh9s9cJs',
  '8s7c6d5d4s',
  'AcKh9d5h3h',
  '8c8dJhTh4h',
  'AhAc9s9c5h',
  'KdQh5s4d3h',
  '2c2dKhQd7s',
  '9h8h7h6h5h',
  'AsAhQc9d4c',
  '8d7h6h5c4c',
  '9h8s7c6s5h',
  '2h2c2d6s6h',
  '7h7c7d8c2d',
  '8s8h6s6d5d',
  'AsAhKcKd6h',
  'KsTs8s5s4s',
  '8s8cAcQcTs',
  'AhAcAdKc8c',
  '8s8h8c8d9c',
  'AsAhAd9s9d',
  'QhJhTh9s8s',
  '8d7d5d4d2d',
  '5s5h5dQs4c',
  'QhQc9c3d2c',
  'AsKsJs9s7s',
  'KcKdQhQd8h',
  'AdKd9d6d4d',
  'AsAdTsTh2d',
  '2s2h2c2dAh',
  'JsJhJcJd5h',
  'AsAhQd6c4d',
  'AdJd9d8d6d',
  'JhJcAs9h4d',
  '2s2h2c2d7h',
  'JdTd8h5s4h',
  'JdTh9s8h7d',
  'JdTd9c8h7h',
  '8s8d2c2dJd',
  '7s7hAh8c4c',
  'QcJcTd9s8h',
  'JhJcThTd9h',
  'QcJsTh9h8s',
  'QsQhQcQdKh',
  'AcAdKhKc6c',
  '6h5s4d3s2h',
  '4s4hAhKc5s',
  'JsJhJcQs5s',
  'JsJhJc5s5h',
  '9s9hAsKh2c',
  '8d7d6d5d4d',
  '7s7hQcTs8d',
  'QhTd9d8s5d',
  '6s6hQhJc5s',
  'QcJh8d5d2s',
  '8s8h8cKs9c',
  'QsQhQcAhTs',
  'AsAhAd9c7c',
  '6s6h6c6dAd',
  '7s7h7c7dJd',
  'QsJdTc9h8h',
  '2s2h2cAh6s',
  '8s7s6d5h4s',
  '8s8h5c5dAd',
  '4s4h4dThTc',
  'QdJsTc9s8c',
  'AhKdQdJcTc',
  'AhAdKcKd4h',
  '9s9c7s7hAs',
  'AsKhQhJhTh',
  'KsKhKcKdQs',
  'AsAhAd8h8d',
  '6s6c5h5dJh',
  '8s8h8dQcQd',
  'Ad8d7d6d4d',
  'AsAcAd7c7d',
  'KdQsJdTs9h',
  'JsTs9s8s7s',
  'AsAcAd3s3h',
  'AsAh5s5hJc',
  '7s7h7cQcJc',
  '9h9c9d6s3s',
  'AsAhAdTc8h',
  '7s7dAdKc2s',
  'AcQcTc7c5c',
  '8s8h8c8d2d',
  'TsThTd9s6s',
  '8s8hKcTc7d',
  '4s4hJc6s5d',
  'As5s4s3s2s',
  'JsJh9c9d3c',
  '8s8h8cQh3s',
  'KsKhKcKdJs',
  '8h7h6h5h4h',
  'JsJhJd8d4c',
  'QsQhQdJd6d',
  'AsKc9c8d3d',
  'AdKdTh6s3c',
  'QsQhQcQd7s',
  'AsAhAcQhJc',
  '7h7c7dQsQh',
  '5s5h5dJh9c',
  'Ks8s7d4h2h',
  'AdKdQhJsTs',
  'JsJhJdQhTd',
  '8s7s6d5d4c',
  'KsKhJsTd9h',
  'KhKcKd5h5c',
  '6s6h6cAsAh',
  '5s5h5dAhKc',
  '5s5dAdJh3d',
  '2s2hJd8c4c',
  'Ad5d4d3d2d',
  'ThTc9h9c8d',
  '2s2hJd8d4h',
  'Td9s8c7h6h',
  'Ad5h4c3d2s',
  'AsAhAc9c9d',
  '5c5dAsKs9s',
  'TsTd2c2d9d',
  'KhJc7h6s3d',
  'JsJhJdAd9s',
  'AsAhAcQd2h',
  'AcAdTsThKs',
  '8s8h8dKs3h',
  '7s7h7c7d9s',
  '7h7c7dQd8h',
  'AsAhJcJd9s',
  'Ts9s8s7s5s',
  '7s7hAhTs8s',
  'As5c4s3c2s',
  'AsAhQsQd4c',
  '7h7dJd3d2c',
  'KsQcJs4d3d',
  '4s4h4c4dJd',
  '6h6c6dAd5s',
  '7s7h7c7d8d',
  'Ac5c4c3c2c',
  'Tc8c7c4c2c',
  'QcQdJhJcTc',
  'AsAcAdKhKd',
  'AcAd5c5d3s',
  '9h9c9dTsTh',
  'JcTs9d8c7d',
  'JsTs8s5s4s',
  'Ad9c8h3s2s',
  '6d5d4h3c2d',
  '9s9h9d8h7s',
  'JsJhJcJd4s',
  '8s7s6s5s4s',
  'AdKdQhJcTc',
  '9s9h9dJs6c',
  'JhJcJd6s6h',
  'JdTd8d7d3d',
  'KdQd8s4h3c',
  'JhJcJd6s6h',
  'Ad6d4d3d2d',
  'AhAcAd3c3d',
  'AcKsQs7d6h',
  'As6s4s3s2s',
  '7c7d5s5dAh',
  '8h8c8d3c3d',
  'QsQhQdKs6h',
  'JsJhJcJdTd',
  '8s8h8c8dQs',
  '8s8h8c6h4d',
  '7c6d5s4c3c',
  '7s7h7c6h6d',
  '9s9d3c3dQh',
  'As5s4s3s2s',
  '9h8h4c3h2s',
  '3c3dTc6s5c',
  'AsAhAcKcKd',
  '4s4dQs9d3c',
  'AdQd9d8d5d',
  'KdQs9c8c6s',
  'AhKh9h7h5h',
  'QhJh9h8h7h',
  'ThTc5c5dAc',
  'AdKhTs9d4s',
  'JsJhQd6c5d',
  '7s6d5c4c3d',
  'QsQhQcQdAc',
  'AsAhAdKhTh',
  'TsThTcAsQs',
  'Kc9s6d4s3d',
  'JhJcJdAcKs',
  '7s6d5c4c3s',
  '5s5h5d3h2s',
  'AdKc7s6d5s',
  'KdQcJdTc9c',
  '7c7d2s2hAc',
  '5s5hKcJc3h',
  'Tc9h8c7h6c',
  'KdQsJsTh9h',
  '3h3dQd8d7s',
  'AcKcJc9c8c',
  '4h4c4dQhJd',
  'QdJdTh9h8h',
  '2s2h2dJcJd',
  '8c7s6c5d4h',
  'KsQs9s7s6s',
  '8s8h8dJcJd',
  'JhJcJd9s9h',
  '7d6d5d4d3d',
  'AcJc9c7h5d',
  'QdJd7d6d2d',
  'AsAhTs9d2s',
  'QhJsTs9d8s',
  '3s3hJc8c7d',
  '5s5h5c5dAc',
  '3s3hAd4h2s',
  'KsQdJhTc9s',
  'JsJhJdTd7d',
  'AsAhAdTcTd',
  'QsQhQc8h6s',
  'AhAcAd4s4h',
  'QdJdTd7d2d',
  '6c5d4h3d2s',
  'AhAcKcKd5d',
  '9s9h9d8s6c',
  '9h9c9dKsKd',
  'Td7d4d3d2d',
  'JsJhTsTh4d',
  '5s5h5cQd8h',
  'KhQhJhTh4h',
  '2h2c2d9s5s',
  'AcAd7s7dKs',
  'JsJhJcQh7d',
  'AsAhJhJd9d',
  'AcAd9s9hQd',
  'QsJcTs9h6h',
  '4h4cAsKcQs',
  '9s9dKdJh4c',
  'AsAhAcAd2s',
  '7s7h7dAhAc',
  'Tc9c8c7c6c',
  'QsQd9c9d6d',
  '2s2dQcJh5h',
  '7d6d5h4c3h',
  'QhJhTh9d8s',
  'AcKh9c6c2s',
  'JsJhJdAhQc',
  'AsAhAcAdKd',
  'Tc9c8c7c6c',
  'QcJcTc9c8c',
  'JhJcJd7s7d',
  '8s8h8c8dAs',
  '3s3h3cTd9h',
  'JsTs8s7s5s',
  'KdQhJhTc9d',
  'JsJhJc6h6c',
  '9d8d7d6d5d',
  'QsQhQd9s9d',
  '5s5h5cKd2h',
  '4s4h4d6h6c',
  'Qh9d8h7d2c',
  'KsKd7c7d9h',
  '9c8c7c6d5c',
  'Qc7c6c5c2c',
  'AhKh4h3h2h',
  'TsThAd4d2c',
  '7h7c7dJhJd',
  '7s7hAcJc4c',
  'AhAd4s4h5s',
  '3h3c3d4h4c',
  '9c8c7d6h2c',
  '5c5d2c2dQd',
  '4s4h4dJhJc',
  'AcKc9c6c4c',
  'AcAdKsKh4s',
  '4s4h4c4dKh',
  'QsQhQd6d4d',
  'QsJdTh9s2s',
  '3s3h3cQd5h',
  '3s3h3dAcJc',
  'Ah5h4h3d2c',
  '6d5d4d3c2s',
  'AdKdQdJdTd',
  '9d8d7h6d5d',
  'QcJc9c7c4c',
  'QhQcQdAh8c',
  'AdKdQdJdTd',
  'QcJdTd9h8h',
  'AdKd4d3d2d',
  '7d6d5c4s3c',
  'As8s4s3s2s',
  'QsQhQd7h4c',
  'AdKdQdJdTd',
  '9s8h7h6s5s',
  'As9c5s3s2d',
  'Js7s5s3s2s',
  'AsAh5c5dQd',
  'JsJhJdQh7d',
  '6s6c6d8s8h',
  'AhQd9d8s5h',
  'AsAhAdQcQd',
  'JsJhJc5s5h',
  '2s2h2cAsAh',
  'Tc9c7c3c2s',
  'AhKsQhJcTc',
  '9s9h9c9dAs',
  '8c7c6c5c4c',
  'Jh9h5h4h3h',
  'AsAhKhKc6h',
  '9s9h8s8h3c',
  'KcJc6s4d2s',
  'JsJhJcJd2h',
  '7s6s5s4s3s',
  '6c5c4c3c2d',
  'AdKdQdJdTd',
  'TsThTcTd7h',
  'JhTh9h8h6h',
  'ThTc4c4d5c',
  'KsKh4h4d8s',
  'QhQcTs5c4h',
  'Kh9h8h6h3h',
  '5s5h5d3h3d',
  'QsQhQdTh9h',
  'AsAh9s9hJc',
  'KsKd3s3hQd',
  'AsAhAcQcJh',
  'QsQhQc4c3h',
  'AsAhJhJcKd',
  'AcAdQsTd2c',
  'Ad5s4c3h2h',
  '7h7d6s6hAc',
  'JsTs8s7s5s',
  'KsKhKdAd6s',
  '4s4c4dQhQc',
  '7s7h7cKsKc',
  'JsJhJcJd5c',
  '8s8h8cThTd',
  'AhAcAd2s2h',
  '9s9h8c8d5c',
  '7h7c7dQsQh',
  '9s8s7s6s5s',
  'KsQhJcTs9h',
  '8s7s6c5c4s',
  '9d8d7d6d5d',
  '7c7d2s2h6d',
  'JsJhJcJd6h',
  'QhTs8h4h2s',
  'KcQcTh8c7c',
  '8h7h6h5h3h',
  'KsKh2h2dQs',
  '6s6h6c6d8s',
  'AsKsQs7s6s',
  '8h8cAsJd2s',
  'AsAdKh3s2h',
  'AhAcAdTsTd',
  '6s6h6dJs7c',
  'JsJh9s9h7s',
  '4c4dTs8h2c',
  '3c3dAdKc8c',
  'KdQd7d6d4d',
  'AsAhQsQh5s',
  'KdQd9d5d4d',
  'JsJhJcJd3c',
  '8d7d6d5d4d',
  '9s9h9c9d7d',
  'AdKcJh8s2c',
  'Jd8d7d5d3d',
  'JdTs9c6h3s',
  'QsJs9s4s3s',
  '4h4c4dJcJd',
  'KhQhJhTd9s',
  '7h6h5h4h3h',
  'AsAcAd8c8d',
  'KsQh9c7h5h',
  'AsKs9s8s4s',
  'AcJc8c6c5c',
  'Jc9c8c6c4c',
  'JsJhJdAc4d',
  '3s3dTd8s7h',
  'Th9d8c7s6c',
  'AsAhAd7s7h',
  'Js8s7s6s3s',
  'JsTc9h8h7s',
  '5s5h5cAsAh',
  'KsQhJcTd9c',
  'KsKhAd7d4h',
  'QsQhQc9h9d',
  '8d7d6d5d4d',
  'KhKcKdAsJh',
  'QcJc9c8c6c',
  'TsTh9s9cJc',
  'Ac8c7c6c4c',
  'QcQdKh8s3c',
  'AsAhAdKh6c',
  '6h5s4d3d2s',
  '3s3hKc7d4d',
  'JcTs6h5d3c',
  'AhAcAd7s7d',
  'AhAcAd2c2d',
  '4s4dJdTc5c',
  'Ad9d7d5d3d',
  'AsAhAc6c6d',
  'JsTc7s6d2c',
  'JsJhJc9s8d',
  'AhAd4s4dQs',
  'QdJcTs9c6d',
  '2s2h2c2d5d',
  '7h7c7dQsQc',
  '6d5h4h3s2c',
  'JhJcJd6d3d',
  '7s7h7c7dAh',
  'Ac5h4d3c2d',
  '9s9d3s3dQh',
  '6h5h4d3h2c',
  'JsJhJcJd5s',
  'AcAd5h5c7c',
  '7c7d2c2d8d',
  '7s7hAdKd2h',
  '2s2h2dQsQd',
  'KcQc8c7s6c',
  'Ac9s7d5c4d',
  '3s3h3dQcQd',
  'JsJhQsTc2c',
  '5h5c5dAhJh',
  '9s7s5d3h2h',
  '5s5dAhTd6c',
  '7s7h7dQdTc',
  '7c6h5c4c3d',
  'QsQhQcQdJh',
  'Ah9d7d6d3d',
  'KsKd9s9hAd',
  'Tc7c4c3c2c',
  '3h3c3d6s5s',
  'AcKcQc6c4c',
  'AhAcAdQhTd',
  '4s4h4dAd9d',
  'AsKhQs5h4s',
  'QsQhQc8d7h',
  'Ad5d4d3d2d',
  '3s3h3cQd5d',
  'AsTs8s7s5s',
  '2s2h2dJhJc',
  'KhKcKdQdJh',
  '2s2h2c2dAd',
  'QcQdThTd8d',
  'Js7s6s5s2s',
  '8s8h8c8dTs',
  '7h7c7d8h8d',
  'KsKhKdAh6s',
  '9s9c9dQc5c',
  'AsQsJsTs5s',
  '7s6s5c4d2d',
  'AsAhAcAdTc',
  '4c4d2s2hQs',
  'QsTs7s6s4s',
  'JhJcJdQsQh',
  '8s8h8c8dKd',
  'AhAdQdTh2h',
  'Tc9d8d7d6c',
  'KsQc6h5s2h',
  '7s7h7d9d3c',
  '4s4h4cAd7c',
  'AhAdKd7d2s',
  '9s9h9dKhTc',
  'QdJdTc8c3h',
  'TsTh6c3s2s',
  '9s9c2c2d3s',
  'QsQhQc3s3h',
  '3s3h3cQd6s',
  'KhJd7s4h3d',
  'QcQd2c2d3h',
  '9s9hQhTh8d',
  '9c9d2s2h8s',
  'KhKcKd3c3d',
  '8s8h8c8d9s',
  'JsJhJc2s2h',
  '5s5h5c5d2s',
  'KhKcTd9s2c',
  'JhTh9d8h7c',
  '3h3c2c2dAh',
  'QcJc8c7c6c',
  'JsJhAsKh6s',
  'QhQcQdKhKc',
  'JsJdKhQc8h',
  '9h9c9dAcJs',
  'AsAh3s3hTc',
  '2s2h2c2d6d',
  'AsAcAdKhQh',
  'AsAhAcAdKd',
  'JsJcJd6c6d',
  '4s4dAhTs6d',
  '7s7h3s3hQc',
  '2s2hAh9s8h',
  'Ad8h7c6d4c',
  '6h5h4h3h2h',
  'JhJdTh9c5h',
  '4s4h4dAsAh',
  '8s8h8c8dQc',
  'Jc8d7c6s2h',
  '9s9h9c9dAh',
  '9h9c9d3c3d',
  'AdKsQh9d6d',
  'AsAd3s3hQc',
  'KsKhKd7s7d',
  '8h8c8dAh9c',
  '4h4c4dKd8s',
  '9s9h9c9dAd',
  'AsAcQc8s6h',
  'AcAdKhQh5d',
  '8s8h8cQhQd',
  'AsAhAc9s9c',
  'QsTc8s6d2h',
  'AsKd9h5c3s',
  'JsJhJcJdTc',
  '8c7c6c5c4c',
  'JhJcJdQd4s',
  'JhJcJdKcKd',
  'KhQc7c6s4s',
  'AhKhQhJh9h',
  '6s6hJhTc7s',
  'AsAhAcTs4s',
  '4h4c4dQs9c',
  '6s5s4d3h2s',
  'KdQsJhTc9d',
  '4s4h4c4dAs',
  '2s2hQsJd7h',
  '7h7dTs8c3s',
  'KhQsJcTh9h',
  'JsJhJcJd9h',
  'AsKs7c6h2c',
  '9h9d3h3dTs',
  'AsAhAcAd4c',
  'KsKh9s9hTc',
  'KsTs6s5s2s',
  '9s9h9c9dQc',
  'AhAcAd2c2d',
  'QsQc9h9dJs',
  'KsKhJdTd9s',
  'KsQs8s4s3s',
  'ThTc7s7h8h',
  'Td9s8d7c6d',
  '8s8d6s6cKh',
  'QsQd2s2dAs',
  'QdJcTc9s8h',
  '2c2dAsKd6c',
  '2h2c2d9h5d',
  'AhKhQhJhTd',
  'Ts9s8s6s4s',
  'KsQs7s4s2s',
  '4s4c4dQsQh',
  'AcAdKd3h2c',
  '4s4dAs8c5d',
  'AdJdTs7h4c',
  '6h6c6dJsJh',
  '6s6h6c9c8s',
  'AdKhJh7h4s',
  'ThTcTd6s6h',
  '3s3h3c3dQs',
  '8s8h8c8dJc',
  'JsTs9s7s5s',
  'AhKsJd5s2s',
  'As7d6s5d3s',
  'JdTd9d7d5d',
  '9s9h9cAd7d',
  'ThTcTdJh3c',
  'AsAhJsJd6s',
  'AsKsTs3h2s',
  '2h2c2dKsKd',
  '5s5h5cKs2c',
  'AhKhQd8c5c',
  '8h8dJc6h2c',
  '4s4dAd9s2d',
  'AdKsTs5d3d',
  'TsThTcTd7h',
  '5s5h5dAcAd',
  '7h6h5h4h3h',
  '3s3h3dKdQd',
  'JsJd7s7hAs',
  'AsKdQd6s3s',
  '3h3dAs5s2s',
  'KsQsJsTs9s',
  'QsQhQcQd3c',
  'JsJhJc7c7d',
  'JsJhJcJdAs',
  'QsQhQc2s2h',
  'JsJhJd4s2c',
  'QsJs8s5s2s',
  '8s7h6d5c4s',
  '8s8h8c8dKc',
  'ThTc4c4dQc',
  'AsQsTs9s3s',
  'JsTs9s8s7s',
  'AhTc7d5h4c',
  'TsThTdAc4h',
  'AdQd6d5d3d',
  'JcTc9s8h7d',
  'Th8d6h5s3s',
  'KsKhKdTsTd',
  'AdKdQdJdTd',
  '7s7h7c7dAd',
  'AdQsJhTc3h',
  'TsTd6s6h5c',
  'QdTh9s8d2s',
  'AsAcAdTd7d',
  '7s7h7c7dKh',
  'JcTh9d8d7c',
  '8s8dAdQsTh',
  '2h2c2dJs4d',
  'AcKh9c7d4h',
  'JsJd4s4h6d',
  '8c8dKs6h3c',
  'AdKhJs8d5c',
  'TcTd9c9d7s',
  'AdQd8d4d3d',
  'AsAhAc6s6d',
  'Jc8c6c4c2c',
  'JsJhAsKd5s',
  'AsAhAcKsTs',
  'QhJcTc9h8s',
  '8s7c6h5d4h',
  'TsTc4s4hAc',
  '5s5hAsKc7s',
  'AsAhQdTd3s',
  'JsJhJcQsQd',
  'AsAhAcAd8d',
  'AcAd7h3d2d',
  'Td9d8s7h6c',
  'AhAcAdKd2c',
  '7s7h7d3s3h',
  'AhAc9s9h3c',
  'AsAhAcAd9d',
  'JsJhJcAsAd',
  'KsJs8s7d3h',
  'JsJhJcAsAh',
  '6s5c4d3h2d',
  '6s6h6c6d9h',
  '7c6c5c4c3c',
  '7s7h3s3hQd',
  'JsJh2c2d6h',
  'QsQdTsThKh',
  '7s7h7d6h6c',
  'AsAd4h4d8s',
  'Tc9c8c7c6c',
  '6s6d3s3h5d',
  'QdJdTd9d5d',
  '2s2h2c2d9c',
  '7d6d5d4d3d',
  'JdTd9h6c5h',
  'AsQs8s7s2s',
  '8s7d6h5h4h',
  'QsQhQcTd4s',
  'AsAhAcAd3c',
  '7h7c7d5s3c',
  'As5s4s3s2s',
  'JsTd9s8c7s',
  'KhQh9c6c2s',
  'Tc9c8h7h6s',
  '2s2dAdKh4c',
  '7s7c7dJsJh',
  '8h7d6s5c4h',
  'KsKhKc7h5h',
  'AsAcKcKd3h',
  'AhTh9h8h2h',
  '7s7dAcKd4s',
  'KdQhJcTc5h',
  'ThTc8h8cJd',
  'AdKdQdTd2d',
  'AhAdKsQh8c',
  '8s8h8c8dJh',
  '8s8h8c8d9c',
  'AcJc6s5c2d',
  'TsThTcJhJd',
  'KsKhKcKd2s',
  'JsJhJcJd6s',
  '6h6c6d9s9d',
  '7s7c7dAhKc',
  'QsJs9s8s7s',
  'KsJsTs7s3s',
  'JdTd7d5d2d',
  '8d7d6d5d4d',
  'QsQcQd2h2c',
  'QcTc8c6c4c',
  '8s8h8c8dJs',
  '8h8c8dQcQd',
  '9s9h9c9dKs',
  'Tc9c8c7c6c',
  '5c5dJsTd3h',
  '4s4h3s3hAs',
  '6s6dQh8c4d',
  'AsAhAdKs6d',
  'Td9d8h7c6s',
  'JhJdTsTdAc',
  'JsJhJcJdKs',
  'AsAhKsKdTc',
  '7s7h7cAsAh',
  'AsAhAcTcTd',
  'AhKh8h7h6h',
  '9h8c7s6s5s',
  'QsQhJcTh6h',
  'AdJc8c4s2c',
  '2s2hKhQd3c',
  'KsJh9h8s7c',
  'JsJhJdThTc',
  'AsKcQdJhTd',
  'QsTs9s5d4d',
  'AdKhQc8h2h',
  'QsQhQc4h4c',
  '7h7c7dAdKs',
  'KdQdJdTd9d',
  '7s7h7c7dJc',
  '7s7h7c2s2h',
  'KdJc9h8c4h',
  'AhJh7h5h3h',
  'AsKs7s6s2s',
  'QcJdTd9c8h',
  '4h4cAsJdTc',
  'AcKcTc4c3c',
  'AhAdJdTc5h',
  'AsKs9s4s3s',
  'TsThTcAhAc',
  '3s3c3dAhAc',
  'QdJdTd9d8d',
  'KsKhAdTc8c',
  '6s6h6c6dJc',
  'KsKhQhTh8s',
  'AdKdQd9d7d',
  '2s2h2cQsQd',
  'AsAdThTcKs',
  '6s6c6dAsQs',
  '6s6h6c6dTs',
  'AsAhAc7s7d',
  'QdJdTd9d8d',
  '8c8dTs7s2h',
  '9s9h9c9dJs',
  '8s8dAhKh3c',
  '6s6h6c6d9s',
  '9h9c9dJs7c',
  'Ac9c8c7c4c',
  '8h8c8d6h2c',
  'AsAc3h3c4d',
  'AsAcKh6s3s',
  '7c7d3s3hAc',
  'AsAd4s4c5d',
  'JcJdTs9h2h',
  'QcQd9c9d8d',
  '9s8s7s5s4s',
  '4s4hAd7h3s',
  'Ah5h4h3h2h',
  'AdKdQdJd6d',
  'AsAhAc6s6h',
  '7h7c7dAh8h',
  '7h6h5h4h3h',
  'JsJh7d6h3h',
  '2s2h2c2dJs',
  'AhAdThTd8h',
  'KdJh7d3d2h',
  'TsThTcAc7s',
  'AcJd8h3c2c',
  'AhAd9c6c4s',
  'Js7s5s4s3s',
  'ThTcTd3c3d',
  'QdJdTd9c8c',
  'AcAd9d6s4d',
  '7h6c5h4c3h',
  '7s7h7d2c2d',
  '4s4hKcJs2h',
  'JsJhJc9s6c',
  'KcQhJhTc9h',
  '6s6h6c6dKs',
  'AsQh8c7d4d',
  'TsThTcKdQs',
  'KdQc5h3s2h',
  '5s5h2h2cJs',
  'KsKhTsTd3h',
  'AdJhTc7d2h',
  'QsTs9s4s2s',
  'QsQhQcQd8c',
  'AsAhAdQhQc',
  'TsThKh9d2s',
  'AsQs7h4c2c',
  '4s4h4dAsAh',
  '6s6h6d3c3d',
  'AsAhKsQhJs',
  'JsJh9h9d2d',
  'QsQhTc9d6s',
  'AsAhJsJh8s',
  '6s6h6d3s3d',
  'AsJs5s4s3s',
  'JhJd6h6c3c',
  'AsKsQs7s2s',
  'JsTs9s7s5s',
  'KcKdQcQdAs',
  'QhTd8s6h5d',
  'JsTs9s8s4s',
  'JsJhJcJd3s',
  '9s8s7s6s5s',
  'AhKhJh9h5h',
  'AcAd2s2dTc',
  'AdKdQd6d4d',
  '2h2c2dJsJd',
  'QsQcJdTh8s',
  'QcQd7s7d2s',
  'QhJcTc8c2c',
  'Ts9s8s7s6s',
  '9h9c9dTh5c',
  'KsQs9s6s2s',
  'AhKhQh9h7h',
  'TsTc6s6h3h',
  'JsJc7s6c5d',
  'JsJdTcTd3s',
  '6h6c6d9h9c',
  'AdKcQcJhTc',
  'QsQhQd9s9d',
  '4s4c4d2s2h',
  'AcAd8c8d6d',
  '8h8c8dQsQh',
  '5h5c5dJs8s',
  'AsAhAcAd2s',
  '8d7d6d4d2d',
  '8s8h8cQsQh',
  'QsQhQd4s4d',
  '7s7h7c7dJs',
  'JsJhJd2c2d',
  'TsThTcTdAs',
  'QhQcQd3s3h',
  'AcQdJdTd9s',
  'Ts9s8s6s4s',
  'JsJcJdAd7s',
  'JcJdKs7c2h',
  'Th9s8h6d5c',
  'AdKd7h5d2s',
  '9s8s7c6s5s',
  '7h7c7dAsAd',
  'TsTcTd8s8h',
  'Ac8c6c5c4c',
  '2s2h2c2d8h',
  '4s4h4c4dTd',
  'KdQdJh7h5s',
  '6s5s4h3c2s',
  'QsQhQc9d7s',
  'KcTc9c5c2c',
  '6s5s4h3c2d',
  'AsAhAdTd5d',
  'AcKcQd8d6s',
  'Ac8s5d3s2s',
  '9s9h9c9dAc',
  'AdKdQdJdTd',
  'AsKsTc7c5s',
  'JsJh7h7cKs',
  'AsAhAdQsQd',
  'Tc9c8s7s6h',
  'KdQcJhTs5s',
  'AsQs7s5s4s',
  'AdKs4s3s2h',
  'As5s4s3s2s',
  'QhQcQd8s8h',
  '7s7h7dKhKd',
  'JsJc9h6h3s',
  'AsAd7s7h3s',
  'AsKsQsJsTs',
  'QsJsTs9s4s',
  'Td9s8h7h6c',
  'ThTc2h2d5s',
  '7d6d5d4d3d',
  'Jh9h8h4h3h',
  'TcTd6h6dAh',
  'KsQcJcTd9d',
  'KsKhJsJd2c',
  'TcTd2h2c9s',
  'KsQsJs3s2s',
  '5c5dAdKc6d',
  'QsQh6s6dKc',
  'Td9c8c7s6s',
  '7s7c4s4dTd',
  'Ah5c4c3s2h',
  'KsKhKc6s6h',
  'TsThTcTd4c',
  'AsQs8s7s5s',
  'JcTd9c8s7d',
  'JdTh9c4c3c',
  '8h7c6s5h4s',
  'Ah5h4h3h2h',
  '7s7h7dAhAc',
  'JdTs9h8h7h',
  '9h8d7s6h5s',
  '7s7h7cAh4s',
  '7d6d5d4d3d',
  '7h7c2s2d3d',
  '5s5hKcTc7d',
  'AcKcQcJcTc',
  'JsJhJcJdTc',
  'AcAdTh3h2d',
  'KsJs8s7s3s',
  'QdJc9c4c2c',
  'KsJs5s4s3s',
  'AsJs8s7s5s',
  '7s7hAcJh5s',
  'AsAdJcJd3h',
  '8c7c6h5d4d',
  'As7s6s3s2s',
  'AsAhAdTcTd',
  'QsQcQd7d6d',
  'AsAcKsKh5d',
  '7d6c5h4h3h',
  'QsQhQc8s8h',
  '8c7s6s5h4h',
  '7s7h7c7d3d',
  'ThTd3c3d9s',
  'QdJd9h5c3s',
  'AsJs9s5s4s',
  'As9h5c4s2h',
  'Tc9h8h7h6d',
  'KsTs9s6s2s',
  'AhJh8h5h2h',
  '8s8h8c8d2c',
  'AhKdQsJcTd',
  'AdJcTc4s3c',
  '2s2c2dTc5s',
  '9h9c9dTsTd',
  'Tc9c8c7h6s',
  'AsAhAcAd6d',
  'As5s4s3s2s',
  'Th9h8h6h5h',
  'AcKdQcJdTd',
  '5s5h2s2h7h',
  '3s3c3dJh7s',
  '8h7c6s5s4c',
  '9h9c9dAsAd',
  'Jc9c7c5c4c',
  'ThTcTdAcKd',
  'Jh9d8h7c5h',
  'KsKhKcKd6h',
  '7s7h7c7dAs',
  'KdQc9s8h3d',
  'AhKh7h5h4h',
  '5s5hKhTc6s',
  'AhAcJs8d2h',
  'AcAdJc7h6h',
  'JsJhJcKh4s',
  'QhQcQdAh7c',
  'AsAhAd7s7h',
  '7h7c7dJs9h',
  'JcJdQhTs4s',
  'QsQhQcQdAc',
  'TsTh9c9dAc',
  'AdKd5d4d3d',
  '3s3h3dQs4h',
  '8s8h8c8d5c',
  '8s8h8c9h7d',
  '8d7h6h5d4c',
  '8s7c6s5h4s',
  '4s4h4c4dJh',
  'QcJdTc7s3c',
  'QcJhTs8d4h',
  'AdKdQdJdTd',
  '3c3d9d7c2d',
  '7s7h7c7d2c',
  'JsJd2h2c7d',
  'AhQhTh8h4h',
  'TsTd7s7d8c',
  'AsKsQsTs8s',
  '7s7h7c3s3d',
  'AcKsQcJsTs',
  'JhJdKs3d2c',
  'AsAh7s7hQs',
  'KdQh6h5s4h',
  'AsAhJs6h3d',
  'Ts9h7h4s3h',
  'QdTd8d5d3d',
  'QdJcTd8d4c',
  'TcTdJd6h2c',
  'JsJcQh8s3d',
  'JsJd6s6hKh',
  '9s9h3c3dJc',
  'JsJc9s9d5h',
  '8s8h8c8dAd',
  'AsAd2s2c5h',
  '7s7h7cAdJs',
  'AsAhAcKhKc',
  '9s7s6s3s2s',
  '3s3h3cAsAc',
  'JsJhJdAs8h',
  'JdTd7d5d4d',
  'TsThTd4s4h',
  'Tc9c8c7c2c',
  '9c8c7c4s3s',
  '7s7h7c7dKh',
  '2c2dJc7d6h',
  'KsJs6s4s2s',
  'AdQd7d6s5s',
  '8s8h8c8d3h',
  'AsAhAcAd2s',
  'KsJs7s4s3s',
  'QhQc9s9dAh',
  'JsJcJdKdTs',
  'QcJhTh9c8s',
  'AsQs8s5s3s',
  'AdKsJh8h2d',
  'AhTs9c7s3h',
  '7s7h7c7dAc',
  'ThTd7h7c8d',
  'AhKdQhJdTd',
  'As7d5d4d2h',
  'AsAhAc7h4d',
  'QdJsTh9c8h',
  'AsAh7h7cKs',
  '9h9c9d4s4c',
  'AcKcQcJcTc',
  'AcKhQdJsTd',
  'TsThTcTd7s',
  '7s7h7c7dAc',
  'AhAc4h4d2c',
  'KcQcJsTd9d',
  'QcQd8s5c2h',
  'TsThTc7s5s',
  'AhKcJc9h2d',
  'AsAdKsKdQs',
  'QhQdJsJh7d',
  '9s9hAd6c4s',
  'AsAhQcJc4h',
  'TsThTcTd6d',
  '8s8h8d6s6d',
  '8s8h8cJsJc',
  '6h6dKdQh7d',
  'QhJcTs9h8s',
  'AsAdKsJh4d',
  'KsQsJsTs9s',
  'AhAdKh9s7d',
  'AsKdJdTc5d',
  'KcQcJdTh9d',
  'Js9s7s5s4s',
  '9c8s7h6c5d',
  'JsTs9s6s2s',
  'AhAcAd2s2d',
  'AsAhQh9s8s',
  'AsAhAcThTc',
  'AdJh7s5s4s',
  'KsKhKdAd5s',
  'TsThTcTd9s',
  'JcJd9s9h7c',
  'AsAhJdTc4d',
  'AhKhQh9h6h',
  'AsAhAcAd2d',
  'AcKcQcJcTc',
  'KhJs9d6s3c',
  'As5s4c3s2h',
  'Tc9c8s7h6d',
  '3s3h3c9h9d',
  'KhKcQsQc7s',
  '5s5dAc8d3c',
  'TsThTcTd2s',
  'QdJd9d6d4d',
  '4s4c4dAsAd',
  '5s5h5dAsAh',
  'JsTs9s8s2s',
  'TsThTd4d2c',
  'AdKdQd8d5d',
  'AhQhJh7h6h',
  '6s5s4s3s2s',
  'TsTcTd3s3c',
  'QdJhTc9h8s',
  '8s8h8dJc9c',
  'Ad5h4s3h2h',
  'KcQdJhTd9h',
  'KdQsJdTh9s',
  '5s5h5c9s9d',
  'QsJdTd9d8c',
  '7d6c5d4d3s',
  '4h4cAc9c5h',
  'AdKd9d4d2d',
  '5s5h5c5dQc',
  '7s7h7cJh5d',
  'AcAd8c7s4s',
  'AhAcJd4c3s',
  '2s2h2c2dJd',
  'AhKhQh5d3s',
  'AsAhAcQh7d',
  'JcJdAdTh2d',
  'AhAcAd3c2s',
  'JsJdTs6c5c',
  '8d7c6s5s4d',
  'AsAhAcAd7s',
  '6c5c4s3c2h',
  'JdTd9c8h7d',
  '8h8c8d7s7d',
  'QsQhQc4s4h',
  '5h5c5d7c7d',
  'QcJcTc9c8c',
  '6s6cAsKs7c',
  '2s2h2c2dTd',
  'QsQdAc9c8c',
  'AcAd7d6h5c',
  '9s9h4s4d5h',
  '9d7s5s3d2d',
  'Tc9d8c7d6d',
  'AcKcQcJc4c',
  'KcTc6c5c2c',
  '6h5d4c3c2c',
  '5s5h5c9c9d',
  '8s8c8dTcTd',
  'Ac7c6c4c3c',
  'AsQsTs4s3s',
  '8s7d6s5c4c',
  'Js8s6s4s3s',
  'JhTh9h8h7h',
  '2h2c8h6s5d',
  'TsThTcJsJh',
  'AsAd6h6c4c',
  'QsQhQc9h9c',
  'Ts9h8h7d6s',
  '3h3dAsKc2c',
  'AhQh9s8h4c',
  '8s8c8dTh7h',
  '8s8cAc6c2c',
  '7s7cAc9h4c',
  '4s4h4c4d3c',
  '9s9hAcKdQd',
  '7s7h7c7d5h',
  'AsAcKsKh6h',
  'TsThTcTd5d',
  'Ts9s8h7s6h',
  '6h6c6dAh2d',
  'AhKh8h7h3h',
  'QdJh7c5c4s',
  'Tc8c6c3c2c',
  '9s9h9c9dQs',
  '6c5c4h3h2h',
  '8s8hAdQcJd',
  '7h6d5c4h3d',
  '2s2h2c9h9d',
  '8d7d6h5s4c',
  'AdKd4d3d2d',
  'AsAdKhQs7s',
  'QsQhQcQd8c',
  'QdJsTs9s8s',
  '7s7h7c7d2h',
  'TsThTc2s2h',
  'KcJc9c7d5d',
  'JsJhJcTsTh',
  'AdKdJd6d5d',
  '7h6h5h4h3h',
  'QcQdAs9h8d',
  'AsAhAc7s2c',
  'KsQsJsTs9s',
  'AdKs7c4s3d',
  '9s9h9d6c6d',
  '4h4c4d7s7d',
  'KsKd7s7hAc',
  'TsTcTd3s3h',
  'JhJcJd6s5h',
  '4h4c4dAh8s',
  '6c5d4d3c2d',
  '5s5h5dQd7c',
  '6s5c4c3c2d',
  '4s4h2s2dAh',
  'QsQhAd6c3s',
  'QsJs8s6s4s',
  'AsAhKdTs8h',
  '2s2cKsJh8d',
  '3s3h3c3dQc',
  '2s2h2c2dTc',
  '7h7c7dJc4d',
  'QsJdTs9c8h',
  '8c7d6h5h4h',
  'TsThTcTd8c',
  'Jd8d5d3d2d',
  '5s5h5c3h3c',
  '9s9h9cTsTd',
  '9s9h6h6c7s',
  'AdTc8h7d5h',
  'KsQcJhTd9h',
  '7s7h7dAc9h',
  'QcJh9h6s5s',
  'Jh7h4h3h2h',
  '7h7c7dAd4c',
  'JsJhJcAcAd',
  'AdQd9d7d2d',
  '8c7h6d5h4h',
  '9h8h7h6h5h',
  'AcKdTd7s3d',
  '8c8dAsKdJs',
  '4c4dKs8d6s',
  'Ts9s8s7s6s',
  'KsKhJcTd8h',
  'QdJhTs9h7s',
  'AsQsJs8s3s',
  'KsJc7c4h2c',
  'JhJcAhTh4d',
  '3h3d2s2hQd',
  'TsThKdJs2s',
  '6c5d4c3s2d',
  '9c8h7h6c5h',
  'QdJdTd9d4d',
  'TcTd9s9hKd',
  '9h9c9d8h7d',
  'JhTs7d3h2c',
  'KsQs9s8s6s',
  'JsJhJcJdKs',
  '7h7cAs6s3h',
  'AsAdQd8d7h',
  'Ts9s8s7s6s',
  '7c6d5d4h3c',
  'AdKdQd7d6d',
  'JsJhJcJd5c',
  'Js7s5s4s2s',
  '8s7d6h5h4s',
  '7s7h7dJh6c',
  'AsKs7h5d3h',
  'KsKhJcJd8c',
  'JcTc9c8c7c',
  '9s9h9cTcTd',
  'AsAhKcKd2c',
  'TsThTdKhJc',
  'QhQd9h9c4h',
  '9c8s7h6d5c',
  'Th9d8d7c6c',
  'KdQdJdTd9d',
  'AcJc7c6c4c',
  'TsTcKhQd4d',
  'KsQsJs7s3s',
  'AsQs6s5s4s',
  'KsKcQcTs4d',
  '7h7dQcJc6d',
  '9s9cKs7d3s',
  'JsJhThTc7s',
  'QdJdTd9h8s',
  'Ah8d7s5h4s',
  '8d7s6c5d4d',
  '8s8h8c4h4c',
  '5h5c5d8s8h',
  'ThTdQd6c4d',
  'TsThTcTdQc',
  'QsQh2s2d6s',
  '3s3h3c3dJh',
  '9c9d8s8h6d',
  'AsAhAd5d4s',
  'QsQhQc4s4d',
  '7s7h7c7dJs',
  'AsAdKsKh8h',
  'AhAc7h7cKc',
  'Td9c8s7d6s',
  'AhAcAd9s3h',
  'AhAdQcQd5c',
  '4s4h4cTc7c',
  'Ad5h4c3c2d',
  'QcJs9s3d2h',
  'QhQcQd6s6d',
  'TsThTcTd6c',
  'QsQhQc5c5d',
  '6s6h6c6dTh',
  '8s8h8cKc7s',
  'QsQdJhJc2h',
  '7s7h7dAsAd',
  'AdQc5c4s2h',
  'TsThTcTd4d',
  'KcQcJc4c3c',
  '6c5d4c3s2c',
  'KsKcQcQd9h',
  'JsTc9c8h7s',
  'KsQh9d7c4h',
  'As8s4s3s2s',
  'Ad5h4d3d2h',
  '7s7h7c4s4h',
  'Jd9d7d6d2d',
  'KsKh3h3dJc',
  'AsAhAcAdKh',
  'JsJhQs6d5s',
  'AdKhTd5d3c',
  'AsAdJs8s6d',
  'AsJs9s7s5s',
  'AcAd5h5cJc',
  '3s3cKs7h4s',
  'KhKcKdAsAd',
  'AhKhQh6h2h',
  'AhTh8h7h4h',
  'AhQd7h6c3s',
  '2h2cAcKd5s',
  'AsAhAcAd5d',
  '8s8h8cKdQh',
  '4s4h4dTc6h',
  'Td9c8c7c6d',
  'QcQdAc7s3c',
  '3c3dAdKc7s',
  'AhAdKhJhTc',
  'AsAhAcAdTd',
  'KsKhJh9s7s',
  'JhJcJd9s9h',
  'QcQd8c8d2d',
  'KsQsTs6s3s',
  'Ac7c6d3s2h',
  '8s8h8d9s9d',
  'KsKdJsJh5s',
  'AsKc9h5c3d',
  'AsAhAcAd2d',
  'AsKsQsJsTs',
  'JsJc9h7d6s',
  'KsQsJsTs6s',
  'JhJc7s7h9s',
  '7s7c7d8c8d',
  'AsAhKsQc2s',
  '6s6h2h2d4s',
  'QsQh7c7dAs',
  'ThTd7s4h2h',
  'AcAdJhJdKs',
  'AsAhAcAd4c',
  'TsThTcTd5s',
  'AsAhAcAd5c',
  '8s8h8d7s7h',
  '8c8d7c6s2c',
  'Ad9d8d7d4d',
  'JsJhJcJdQd',
  'JdTd9d8d6d',
  '6c6dJd4c2d',
  '9h8d7c6c5h',
  'AcKc8c4c3c',
  'QcJcTh9d8s',
  'Ah5c4s3c2h',
  'Td9c8h7s6h',
  'QdJh8s5d2c',
  '6s6h6c8s8h',
  'TsTd9h6h2d',
  'JhTd8d6h5c',
  'QhQcQdAcAd',
  '9s9h9d8h8c',
  'AhAdQcTh7h',
  '4s4h4cAhAc',
  '9s8d7s6c5c',
  'AhAcAd6h6c',
  'AsAhAcKsKh',
  '4s4h4dTc6d',
  'AsAhAcKsTh',
  'KsKhKcKdAs',
  'KsQsJsTs9s',
  'JdTs9d8h7d',
  'QsQhJsJh2d',
  'JsJcAdKh7c',
  '7s7h4s4c2s',
  'JsTs7c6c4d',
  '6c6dJh7s2c',
  'QdJcTc9c8h',
  'AhAcAdKc2s',
  'Qd9d8d6d3d',
  'AcAdQs7h3d',
  '7h6h5d4d3h',
  '2s2c2dAcAd',
  '9c8h7c6d5c',
  '6s6h6dAs2s',
  '8h8c8d7d3c',
  'Tc9d8d7d6h',
  '9c9d7h7c8h',
  '8s8h4s4c9h',
  'AhKhQh6h2h',
  '9d8h7c6h5s',
  'JdTc9c8c7d',
  'Ac5h4d3h2s',
  '8s8h8c9s9d',
  '8h7s5s3s2d',
  '9c9dQh7h2d',
  '4s4hTc9d2d',
  'KdQdTd7d3d',
  '8s8h5h5dAc',
  'JcTc9c8c7c',
  '9h9dTc8d3s',
  '8h7h6d5h4h',
  '4s4c4d9s6h',
  '8h8c8dAcTc',
  'KsQhJdTh9s',
  '4s4h4c4dJd',
  'QsQhQcThTc',
  'JsJhJc9h3s',
  'JsJhJdQh2s',
  'KsQs6s4s3s',
  'AhKs8c7d5c',
  '4h4c4dTh7s',
  'JsJhJd2h2c',
  '7s7h7d5h5d',
  'QdTd9h5h4d',
  '7h6d5h4s3s',
  'AsJs9s7s4s',
  'KdQd7d6d3d',
  'KsKhKcKd4h',
  'AsKsQsJsTs',
  'KcQsJcTc9h',
  'QcQdAhKhJd',
  '9s9h9c9d4s',
  '3s3h3d7c4s',
  '9s9h9cAh6d',
  'AcKcQsJdTs',
  '4s4h4c9d8c',
  'AhKhQhJh5h',
  'KsKhKcKdAd',
  '2s2hQsJs4s',
  '8s8d2s2hAh',
  '2s2dQcTc3c',
  '8s8c8d6h6c',
  '6h6c6dJhJd',
  'KhJd7h4c2d',
  'Ts9s8s5s4s',
  'JcTc9s8c7h',
  'AsAhAcAdTd',
  'As8s7s5s4s',
  'AcKdJcTd7d',
  '3s3h3c3dQd',
  'Qc9c6c3c2c',
  'QcJcTc7c6c',
  'AsKs8s6s4s',
  'TsThTc9h7c',
  '8s8h2c2d7c',
  'AsAhAdKh7d',
  'AdJdTd8d4d',
  'QhQcQd5s5h',
  '2c2dJd4d3d',
  'AdKdQdJd4d',
  '7s7h7cQcQd',
  'JsJh8s7h2s',
  '7s7h7c7dTc',
  'Kc7c4c3c2c',
  'AdKdQdJdTd',
  '6s6h6c6d4c',
  'AhAd9s9h7c',
  '2h2c2dQsQh',
  'AcKsTc8h5s',
  'AsAhKhKcQd',
  'Ts9d8s7c6h',
  'QsJs4h3s2h',
  'AcKhQhJcTd',
  '3h3dKh6s2h',
  'AcKcQcTc2c',
  '9h9c9dQc7h',
  'AdKdQdJd2d',
  'Ts9h8s7s6d',
  'KsKhKd7c3h',
  'QsQh6h6c9d',
  'QsQhQcQd5h',
  'KsQsTs9s8s',
  'AsJs9c8d5s',
  '8s8h8c8dTs',
  'JhTs9h8c7h',
  'AcKhQs6d4s',
  '9d8c7h6c5s',
  'AdJhTs7c4s',
  'QsQhQcAc3c',
  '8s8hAcKc2d',
  'ThTcTd4c4d',
  '9s9h7s7c5d',
  'QsJsTc9s8c',
  '6h5c4c3c2h',
  'AdKdJdTd8d',
  'AsJs7s5s3s',
  'KcQdJcTc9s',
  '6s6hTs7c2h',
  '7c7d3h3c8h',
  '3s3h3c9s4d',
  'AsAhAcKcTc',
  'QdJcTd8h7h',
  'KcQc7c6c2c',
  '7s7h7d9s5s',
  'KhQdTc6c2s',
  '6h5c4h3s2s',
  'AdKdJd7d5d',
  '5c5d2s2hJh',
  'TsThTcJh9h',
  '3s3hQcJh6c',
  'KhKcKdQsQh',
  'JsJd4c4d8c',
  '9d8c7c6h5c',
  'TsTh7s7h8c',
  '7s7c7dAcAd',
  'KsKd7s7cAh',
  'AsAd9h9cKs',
  '9c8h7d6s5s',
  '8s8h8c8dTh',
  'AdJd9s8d7h',
  '8s7s6s4s3s',
  '8c8d7d4s2c',
  'KsKhJsJh8h',
  '9h8h7h6h5h',
  '7c7dAhKh3h',
  'QhQcQd9c8s',
  'QhQc2c2d9c',
  '8s7s6s5s4s',
  'KsKhJcJd9d',
  'AsJs8s7s3s',
  '7h6d5h4h3s',
  'KdQdJdTd9d',
  'QdTh8s6h2d',
  'Ts9s8s7s3s',
  'JsJh7s7hAc',
  '5s5h5c5dAs',
  '6s5h4c3s2d',
  'Jd9h6d3c2d',
  '9h9c9dJsJc',
  'AcAd7s5s4c',
  'AsAhJs6s4s',
  '9s9h9c9dJh',
  'Kc9d7c6s4h',
  'TsThTcJd6c',
  '2s2h2c2dJs',
  'AcAdJcTc2d',
  'JsJcJd5c5d',
  '6s6d4h4dAd',
  'Th9s8h7h6s',
  '2s2h2c2d7c',
  'KcQsJs8c3d',
  'QsQcQdKhKd',
  '4s4h4cKd2c',
  'TcTdAdJh3c',
  '7c7d8h4d2h',
  'AhAd7s7h9h',
  'KdQdJdTd9d',
  '5s5h5dKh4h',
  'AsAhAdJd5d',
  'AsJs7s6s5s',
  'AsAdTcTdKc',
  'QcQdAhKdJc',
  '5s5h5cJs3s',
  '9s9h9dQsQc',
  'TsThTcKsKh',
  'TsThTcAs6d',
  'KhQh7h6h2h',
  'Td9s8s7d6s',
  'AdJdTd5d4d',
  '8s8h3s3dTh',
  'JcJdQh9h8d',
  '2s2dKdQh9c',
  '3s3h3c3d4h',
  '3s3h3d8h8c',
  '3h3c3d7h5s',
  'KhKcKdJs6s',
  'AdKdQdJd7d',
  '8s8h8c8d7d',
  '2s2hJhTc6d',
  '8s8c8dQh9d',
  'AhAcKs6c5d',
  '4s4h4cKd5h',
  '9h9c9d7s7h',
  '9s9h9dKh6d',
  '6h5c4s3c2s',
  '6s5d4c3d2s',
  '2h2cKhJc4h',
  'AcQc8c7c3c',
  'JhJc4s4h6d',
  'QdJsTh9d8h',
  '4h4c4dQcQd',
  '8h8c8dKsTh',
  '5h5c5dJhTh',
  'AcAdQsQd6s',
  'QsQhQcQd6h',
  '3s3h3cAc2s',
  'Tc9c8c7c6c',
  '2h2c2d4s4d',
  'TcTd2s2h6s',
  'QhQcQdKsKd',
  'KcQsJs6s4h',
  'AsAhJh8d7c',
  'JcJdAs7d6h',
  'AdKhQcJdTh',
  'AdJhTd6s2s',
  '7h7c7d6s6h',
  'KsQdJdTd9h',
  '2h2c2d4s4h',
  '5s5h5cKd3d',
  'AsKs9c6c4c',
  '4h4c4d9s9c',
  'JcTs9d8h7d',
  '7s7c7d3s2d',
  '4s4c4dAhAd',
  '9s9h9c9d5s',
  '9h9cAcKh4c',
  'KcJcTc9c5c',
  'AhKdQcJdTd',
  'Jc9c8c5c3c',
  '7c7dTc9h8s',
  'AdQdJdTd2d',
  'Tc9c8c7c6c',
  'JsJhJd8s8h',
  'AsJs9s8s5s',
  'AhAdKsTc9s',
  'QsQhQdAsAh',
  'KsKhAdTc9c',
  'TsThTd3s3h',
  'AsAhAd8s8d',
  'Ts9c7c5d4h',
  'JsJhJd9d8s',
  '7s7cJs6s5d',
  'KhQdJsTs9d',
  'AsAhAc6h6c',
  'ThTdAdKd3d',
  '4s4h4c4d7c',
  'AsAhAcAd9h',
  'AcAd8c8d3c',
  'AcKc7c5c3c',
  'JsTs6s5s4s',
  'AsAd4s4dJh',
  '8s8h8c6s3d',
  '7h7c7dAsAd',
  '9s9d5h5c2c',
  '6s6h6c6dTd',
  '9s9h9d6s6h',
  'Ad8c7s5c4c',
  '4c4dAsKs3s',
  'AhKhQhJhTh',
  'As5s4h3c2s',
  'QsQh6h5h4d',
  '7c7dAcKc3c',
  '9s9h9c9d6c',
  'AcAdQs9c8h',
  '7h7dKhQh2h',
  'KdQc9c5d2c',
  '6c5c4s3s2h',
  'QhJhTh8h2h',
  'AsKsJs7s6s',
  'JcTc9c8c7c',
  'AhAcAdJh2d',
  'JhTs9d8c7c',
  'QcJsTh4h3c',
  'KhTs9h5h4c',
  'JsJcJd6h6d',
  'KcQc7c4c3c',
  'Ad5h4c3h2d',
  '8s8h8c8dAc',
  '6s6dKcQc9h',
  'KsKhKcAhAc',
  'AdKdQdJdTd',
  'Td9d8d7d6d',
  '3h3c3dQhJh',
  '8s7s6s5s4s',
  '7s7h9d4c3h',
  'JsJcAh8d2d',
  'QhQcAc6c3h',
  'QsQhQdTsTc',
  'KsKhKcKdQc',
  'Ts9s8s7s6s',
  '9h9c4s4h2d',
  'KhJh9h8h5h',
  '6s6h6c6dJs',
  'JcJdTsTd5h',
  '6d5s4h3c2h',
  'Ts9h8d7s6h',
  '8h8d7c7dJd',
  'TcTd2h2cJd',
  '3s3h3d8s8h',
  'KsQsTs9s6s',
  '5s5c5dJs7h',
  'JhJcJd9s9c',
  'KcQs6s3s2h',
  'KsKhKdQd7d',
  'JsJhJd7s7d',
  'KcQs9d8h3h',
  'AdKdJdTd2d',
  'Th9d8h7h6s',
  'QsJs9s8s5s',
  'Qh8c7c6h2d',
  '7s7h7c7d9c',
  '5s5h5c5d7s',
  '7h6s5d4h3h',
  '4s4h4c4d5d',
  'AcAdKcKd9h',
  '7d6h5s4s3s',
  'Kh9c7s6s3c',
  '5s5h5cQsQh',
  'AhKdQdJdTh',
  'JsTs9d8s7s',
  'Td9d7d5d2d',
  'AdKd9d7d6d',
  '9s9c9d8h8d',
  'TsThQsJs4h',
  'AhAcAd3h3c',
  '2s2h2c2d7d',
  '9s7s4s3s2s',
  'TsThTc7s7c',
  '8h8c8d2s2c',
  'AsAhJsTh5c',
  '9s8s7s6s5s',
  '5s5h5c5dAs',
  '2c2dQdJc3c',
  'KhQhJhTh9h',
  '6d5c4d3d2h',
  'QhJcTd9s8h',
  'JhJd3s3h5s',
  'QsQhQc9d8s',
  'KsQhJhTc9h',
  'AsKcQs5h2s',
  'JhJcJdQc4h',
  '7s7h7c7dJd',
  'AhKhQhJhTh',
  'JsJhJd7s7h',
  'TsThTcTdAd',
  'QsJs9s6s2c',
  '6c5h4c3d2h',
  'AsAh6s6cTc',
  'Kd8d6d4d3d',
  '6c5h4c3c2d',
  '6s6h6c6dAh',
  'Th9s8h7c6s',
  'KsKh6h6d5d',
  'AsAhAcAd8d',
  'TsTh9s9h4d',
  '8s8h8cKc7c',
  'QsQhQd5s5h',
  'JdTc9s8s7h',
  '8h8d2s2h9s',
  'AsKc9s5c2d',
  '2s2h2c7c7d',
  'KsJsTs9s4s',
  'QdJdTc6c3c',
  '5h5c5dJhJd',
  'AcAd7h5s4c',
  'Td9d8h7d6d',
  '8s8h8cJsTh',
  'QhJc9s7d3h',
  '2s2h2dQd4s',
  'AsKsTs9s3s',
  'AhKcQsJsTs',
  'Ac5s4s3d2h',
  'KsQcJdTs9s',
  '3s3hAhKs8h',
  'AsKs7s5s2s',
  '9s9h9c8h8c',
  'JsJh2c2dKd',
  'AhKhQh7h4h',
  'KsKhKd9h8s',
  '4h4c4dJhJd',
  'QsQhJsJhAh',
  '7s7hAsJc2s',
  '6h6c6d7d2h',
  'KsKh7c7d8h',
  'JdTd9d8d7d',
  '8s8hAsTs4h',
  '2h2c2d4c3h',
  '8h7h6d5s4s',
  'JhTh9h4h3h',
  '6s6h6c6d5c',
  '7s7c7d9h9c',
  'KhKcKdQh9h',
  '3h3c3dAsAh',
  '4h4c4dTh3c',
  '9h9c9d3d2c',
  'QsQhQc7h7c',
  'JhJc6s6dQc',
  'AsAc7s7dTc',
  'QsJs8s5s4s',
  'AcJh7c5c4s',
  '8d7d6s5h4d',
  '2h2c2dKsKh',
  '5s5h5c6c6d',
  '9s9h7s7dKc',
  'QsQhQcAhTh',
  'AcAd8h7c5c',
  'TsThTc7h7c',
  '7h7c7d4s4c',
  'KhKc7s7h8c',
  '2h2cQs6s4c',
  '7s7cAsTh8h',
  'JsJhJcJd9s',
  '7h6d5c4c3s',
  '8s8c8dAcQc',
  'KhQhJhTh5h',
  '8d7d6d5d4d',
  'AcAdTs9h4c',
  'AsAhAcTh7d',
  'JcTs9h5c4c',
  'As5c4h3s2s',
  'TsTh9h8h2d',
  'QsQh6s6hTs',
  '7s7h7d8s8h',
  'AdKdQdJd5d',
  'AsJs9c8d5s',
  '7h7dKh9s8d',
  'AdKsQcJcTc',
  'QsQhQc7c7d',
  'TcTd8s8h5s',
  '4s4h4cKsKh',
  'QsJcTs9c8c',
  '8h7h6s5d4s',
  'QdJsTd9h8s',
  'QcJcTc9c8c',
  '8h5s4s3c2d',
  'KdQhJcTc7h',
  'QsQcJhJdAh',
  '9h9c9dKdJd',
  'AhAc2c2dJc',
  'AhKhQhJh7h',
  '8s8cTs9d7d',
  'JhJd7h7cAd',
  '6s6h6cTs9h',
  'AsQsJs8s4s',
  '7s7h7cQhJc',
  'Td9c8s7c6c',
  '2h2cKhJd8c',
  'AsKcQdJsTc',
  'Qh8h7c6d2h',
  'AsAdKsKdJc',
  '9s9h4c4d6h',
  '5h5cKsQc4c',
  '7s7h7cAcAd',
  'JhJcJd9c5h',
  'TsThTcTdKh',
  '7s7h7c7d6s',
  'AdJd9d7d3d',
  'QcQd4c4d5h',
  '9c8d7c6h5c',
  '6c6dAd9s3s',
  'AsAh3s3hKs',
  'QsJsTs8s7s',
  '3s3c3dKsKd',
  '3s3hAh9s5d',
  '5s5h5c8c8d',
  'AsJs4s3s2s',
  '9s9h9d4h4c',
  'QcQdJhJdKd',
  'JsTs9s8s7s',
  '2s2h2dAs8s',
  'JsJhJc7s6s',
  'KdQdJhTc9s',
  'QhJc8d3d2c',
  'AdJs7c5h2d',
  '9s9h9d6s3d',
  'KdQsJdTc9s',
  'JcTh9c8h7s',
  '2h2c2d8s8h',
  '3s3h3dAsAh',
  '4s4h4c3s3h',
  '2s2h2c2d9c',
  'AhAcAd9d2c',
  'JsTs7s5s3s',
  'KsKhKcKdTd',
  '8h8c2s2hAc',
  'AcKsQhJd7s',
  'AcKhQh9c4c',
  '7h7c2s2h6s',
  'JhJcJd6s3d',
  '5s5h5dAsAh',
  'AhAcAdKh9s',
  '4s4c4d5c5d',
  'QsQhQdTh3s',
  '9c8d7s6s5d',
  'Ad5s4c3h2h',
  'JsJhTc9s2c',
  'ThTcTdAdKs',
  '7d6d5d4d3d',
  '7s7cKsJs6c',
  'JsJhJcQhQc',
  'JhTc9c8h7c',
  'AcAd9s9dKd',
  '9s9h9d7h7c',
  'QsJdTs9s8d',
  'KhKcKdAdQc',
  'KdQd8d5d3d',
  'JhTh9h8h7h',
  'JhTd9s8s7h',
  'AdKcQsJsTc',
  '3s3h3d7c7d',
  'KhQsJhTd9s',
  '9s9h9cJcJd',
  'KsQcJdTd9d',
  'Js8s5s3s2s',
  '4h4c4dKc2s',
  'AcAdKsKh6c',
  'ThTcTdQcJc',
  'TsTh8c8d9s',
  'Qs7c5h4c3h',
  'AsTs9s7s6s',
  '8c8dJsTs6c',
  '3h3dQdJc2h',
  '8h7d6d5h4s',
  '9d8d6d3d2d',
  'AhAdJhJdTc',
  'AhAcAdKs5c',
  '5s5h5d9s9h',
  'AsAhTd8h2h',
  'KdJdTd9d7d',
  'QsQcQdAd9h',
  'TsThQsJd6c',
  'KsKcKd2s2h',
  'JsJhTc8h3d',
  'KdQdJdTd5d',
  'AdKc7h5h2d',
]
